/**
 * Auto-generated by scripts/generate-api-endpoints.js. Do not edit manually.
 */

export const endpoints = {
  activaTelogo: {
    url: "activatelogo",
    method: "POST",
    resource: "ACTIVATELOGO",
    type: "WRITE",
  },
  alocaPessoasemlinhas: {
    url: "alocapessoasemlinhas",
    method: "POST",
    resource: "ALOCAPESSOASEMLINHAS",
    type: "WRITE",
  },
  alteraSenha: {
    url: "alterasenha",
    method: "POST",
    resource: "ALTERASENHA",
    type: "WRITE",
  },
  alteraSituacaoativapessoa: {
    url: "alterasituacaoativapessoa",
    method: "POST",
    resource: "ALTERASITUACAOATIVAPESSOA",
    type: "WRITE",
  },
  alteraSituacaovalidacaoativapessoa: {
    url: "alterasituacaovalidacaoativapessoa",
    method: "POST",
    resource: "ALTERASITUACAOVALIDACAOATIVAPESSOA",
    type: "WRITE",
  },
  aplicaUnidadespessoas: {
    url: "aplicaunidadespessoas",
    method: "POST",
    resource: "APLICAUNIDADESPESSOAS",
    type: "WRITE",
  },
  aplicaValidacaobulk: {
    url: "aplicavalidacaobulk",
    method: "POST",
    resource: "APLICAVALIDACAOBULK",
    type: "WRITE",
  },
  appendTickettequipamento: {
    url: "appendtickettequipamento",
    method: "POST",
    resource: "APPENDTICKETEQUIPAMENTO",
    type: "WRITE",
  },
  associaLinhasbulk: {
    url: "associalinhasbulk",
    method: "POST",
    resource: "ASSOCIALINHASBULK",
    type: "WRITE",
  },
  associaRembarquesviagembulk: {
    url: "associarembarquesviagembulk",
    method: "POST",
    resource: "ASSOCIAREMBARQUESVIAGEMBULK",
    type: "WRITE",
  },
  associaRotasbulk: {
    url: "associarotasbulk",
    method: "POST",
    resource: "ASSOCIAROTASBULK",
    type: "WRITE",
  },
  associaRusuariosbulk: {
    url: "associarusuariosbulk",
    method: "POST",
    resource: "ASSOCIARUSUARIOSBULK",
    type: "WRITE",
  },
  associaSublinhasbulk: {
    url: "associasublinhasbulk",
    method: "POST",
    resource: "ASSOCIASUBLINHASBULK",
    type: "WRITE",
  },
  associaTagrfid: {
    url: "associatagrfid",
    method: "POST",
    resource: "ASSOCIATAGRFID",
    type: "WRITE",
  },
  associaUnidadesarea: {
    url: "associaunidadesarea",
    method: "POST",
    resource: "ASSOCIAUNIDADESAREA",
    type: "WRITE",
  },
  atualizastatus: {
    url: "atualizastatus",
    method: "PUT",
    resource: "ATUALIZASTATUS",
    type: "WRITE",
  },
  auditDownloadLogfile: {
    url: "audit/downloadlogfile",
    method: "POST",
    resource: "AUDIT_DOWNLOADLOGFILE",
    type: "READ",
  },
  auditDownloadLogfilesbulk: {
    url: "audit/downloadlogfilesbulk",
    method: "POST",
    resource: "AUDIT_DOWNLOADLOGFILESBULK",
    type: "READ",
  },
  auditDownloadSystemlogExport: {
    url: "audit/downloadsystemlogexport",
    method: "POST",
    resource: "AUDIT_DOWNLOADSYSTEMLOGEXPORT",
    type: "READ",
  },
  auditExportSystemlog: {
    url: "audit/exportsystemlog",
    method: "POST",
    resource: "AUDIT_EXPORTSYSTEMLOG",
    type: "WRITE",
  },
  auditGetDiasexecucaoauditoria: {
    url: "audit/getdiasexecucaoauditoria",
    method: "POST",
    resource: "AUDIT_GETDIASEXECUCAOAUDITORIA",
    type: "READ",
  },
  auditGetExecucoesauditoria: {
    url: "audit/getexecucoesauditoria",
    method: "POST",
    resource: "AUDIT_GETEXECUCOESAUDITORIA",
    type: "READ",
  },
  auditGetInconsistenciasauditoria: {
    url: "audit/getinconsistenciasauditoria",
    method: "POST",
    resource: "AUDIT_GETINCONSISTENCIASAUDITORIA",
    type: "READ",
  },
  auditGetPanoramaauditoria: {
    url: "audit/getpanoramaauditoria",
    method: "POST",
    resource: "AUDIT_GETPANORAMAAUDITORIA",
    type: "READ",
  },
  auditGetLogfiles: {
    url: "audit/getlogfiles",
    method: "POST",
    resource: "AUDIT_GETLOGFILES",
    type: "READ",
  },
  auditGetSystemlog: {
    url: "audit/getsystemlog",
    method: "POST",
    resource: "AUDIT_GETSYSTEMLOG",
    type: "READ",
  },
  auditGetSystemlogExports: {
    url: "audit/getsystemlogexports",
    method: "POST",
    resource: "AUDIT_GETSYSTEMLOGEXPORTS",
    type: "READ",
  },
  auditGetTrilhaviagem: {
    url: "audit/gettrilhaviagem",
    method: "POST",
    resource: "AUDIT_GETTRILHAVIAGEM",
    type: "READ",
  },
  auditGetViagensauditoria: {
    url: "audit/getviagensauditoria",
    method: "POST",
    resource: "AUDIT_GETVIAGENSAUDITORIA",
    type: "READ",
  },
  auditReprocessaauditoriaviagens: {
    url: "audit/reprocessaauditoriaviagens",
    method: "POST",
    resource: "AUDIT_REPROCESSAAUDITORIAVIAGENS",
    type: "WRITE",
  },
  autenticacao: {
    url: "autenticacao",
    method: "POST",
    resource: "AUTENTICACAO",
    type: "WRITE",
  },
  cancelaragendamentobyidagendamento: {
    url: "cancelaragendamentobyidagendamento",
    method: "POST",
    resource: "CANCELARAGENDAMENTOBYIDAGENDAMENTO",
    type: "WRITE",
  },
  cancelarreservacandidato: {
    url: "cancelarreservacandidato",
    method: "POST",
    resource: "CANCELARRESERVACANDIDATO",
    type: "WRITE",
  },
  colaboradorDetailfirstview: {
    url: "colaboradordetailfirstview",
    method: "POST",
    resource: "COLABORADORDETAILFIRSTVIEW",
    type: "WRITE",
  },
  compararDistanciainformadalinha: {
    url: "comparardistanciainformadalinha",
    method: "POST",
    resource: "COMPARARDISTANCIAINFORMADALINHA",
    type: "WRITE",
  },
  conciliaCaoautomatica: {
    url: "conciliacaoautomatica",
    method: "POST",
    resource: "CONCILIACAOAUTOMATICA",
    type: "WRITE",
  },
  conciliaCaomanual: {
    url: "conciliacaomanual",
    method: "POST",
    resource: "CONCILIACAOMANUAL",
    type: "WRITE",
  },
  confirmCsvvalidation: {
    url: "confirmcsvvalidation",
    method: "POST",
    resource: "CONFIRMCSVVALIDATION",
    type: "WRITE",
  },
  createEquipe: {
    url: "createequipe",
    method: "POST",
    resource: "CREATEEQUIPE",
    type: "WRITE",
  },
  createGrupo: {
    url: "creategrupo",
    method: "POST",
    resource: "CREATEGRUPO",
    type: "WRITE",
  },
  createPessoa: {
    url: "createpessoa",
    method: "POST",
    resource: "CREATEPESSOA",
    type: "WRITE",
  },
  deleteAgenciaemprego: {
    url: "deleteagenciaemprego",
    method: "POST",
    resource: "DELETEAGENCIAEMPREGO",
    type: "DELETE",
  },
  deleteAgendamentobyidagendamento: {
    url: "deleteagendamentobyidagendamento",
    method: "POST",
    resource: "DELETEAGENDAMENTOBYIDAGENDAMENTO",
    type: "DELETE",
  },
  deleteArea: {
    url: "deletearea",
    method: "POST",
    resource: "DELETEAREA",
    type: "DELETE",
  },
  deleteAssociacaoquadrolinha: {
    url: "deleteassociacaoquadrolinha",
    method: "POST",
    resource: "DELETEASSOCIACAOQUADROLINHA",
    type: "DELETE",
  },
  deleteAvisobanner: {
    url: "deleteavisobanner",
    method: "POST",
    resource: "DELETEAVISOBANNER",
    type: "DELETE",
  },
  deleteCategoriaticket: {
    url: "deletecategoriaticket",
    method: "GET",
    resource: "DELETECATEGORIATICKET",
    type: "DELETE",
  },
  deleteCerca: {
    url: "deletecerca",
    method: "POST",
    resource: "DELETECERCA",
    type: "DELETE",
  },
  deleteCercaordem: {
    url: "deletecercaordem",
    method: "DELETE",
    resource: "DELETECERCAORDEM",
    type: "DELETE",
    params: ["id_ordem"],
  },
  deleteCercasbylinha: {
    url: "deletecercasbylinha",
    method: "POST",
    resource: "DELETECERCASBYLINHA",
    type: "DELETE",
  },
  deleteCercascontrolador: {
    url: "deletecercascontrolador",
    method: "POST",
    resource: "DELETECERCASCONTROLADOR",
    type: "DELETE",
  },
  deleteCercavigencia: {
    url: "deletecercavigencia",
    method: "DELETE",
    resource: "DELETECERCAVIGENCIA",
    type: "DELETE",
    params: ["id"],
  },
  deleteChecklistequipamento: {
    url: "deletechecklistequipamento",
    method: "DELETE",
    resource: "DELETECHECKLISTEQUIPAMENTO",
    type: "DELETE",
    params: ["id"],
  },
  deleteClassificacao: {
    url: "deleteclassificacao",
    method: "POST",
    resource: "DELETECLASSIFICACAO",
    type: "DELETE",
  },
  deleteCliente: {
    url: "deletecliente",
    method: "POST",
    resource: "DELETECLIENTE",
    type: "DELETE",
  },
  deleteEmpresa: {
    url: "deleteempresa",
    method: "POST",
    resource: "DELETEEMPRESA",
    type: "DELETE",
  },
  deleteEnderecodevalidacao: {
    url: "deleteenderecodevalidacao",
    method: "DELETE",
    resource: "DELETEENDERECODEVALIDACAO",
    type: "DELETE",
    params: ["id"],
  },
  deleteEnderecoexterno: {
    url: "deleteenderecoexterno",
    method: "DELETE",
    resource: "DELETEENDERECOEXTERNO",
    type: "DELETE",
    params: ["id"],
  },
  deleteEnderecosvalidacoes: {
    url: "deleteenderecosvalidacoes",
    method: "DELETE",
    resource: "DELETEENDERECOSVALIDACOES",
    type: "DELETE",
    params: ["id"],
  },
  deleteEntrada: {
    url: "deleteentrada",
    method: "POST",
    resource: "DELETEENTRADA",
    type: "DELETE",
  },
  deleteEquipamento: {
    url: "deleteequipamento",
    method: "POST",
    resource: "DELETEEQUIPAMENTO",
    type: "DELETE",
  },
  deleteEquipe: {
    url: "deleteequipe",
    method: "POST",
    resource: "DELETEEQUIPE",
    type: "DELETE",
  },
  deleteEscala: {
    url: "deleteescala",
    method: "GET",
    resource: "DELETEESCALA",
    type: "DELETE",
  },
  deleteFamiliaatendimento: {
    url: "deletefamiliaatendimento",
    method: "POST",
    resource: "DELETEFAMILIAATENDIMENTO",
    type: "DELETE",
  },
  deleteFeriado: {
    url: "deleteferiado",
    method: "POST",
    resource: "DELETEFERIADO",
    type: "DELETE",
  },
  deleteFoto: {
    url: "deletefoto",
    method: "POST",
    resource: "DELETEFOTO",
    type: "DELETE",
  },
  deleteFuncionario: {
    url: "deletefuncionario",
    method: "POST",
    resource: "DELETEFUNCIONARIO",
    type: "DELETE",
  },
  deleteFuncionariosguia: {
    url: "deletefuncionariosguia",
    method: "POST",
    resource: "DELETEFUNCIONARIOSGUIA",
    type: "DELETE",
  },
  deleteGrupo: {
    url: "deletegrupo",
    method: "POST",
    resource: "DELETEGRUPO",
    type: "DELETE",
  },
  deleteGuia: {
    url: "deleteguia",
    method: "POST",
    resource: "DELETEGUIA",
    type: "DELETE",
  },
  deleteKit: {
    url: "deletekit",
    method: "DELETE",
    resource: "DELETEKIT",
    type: "DELETE",
    params: ["id"],
  },
  deleteLabelreferente: {
    url: "deletelabelreferente",
    method: "POST",
    resource: "DELETELABELREFERENTE",
    type: "DELETE",
  },
  deleteLinha: {
    url: "deletelinha",
    method: "POST",
    resource: "DELETELINHA",
    type: "DELETE",
  },
  deleteLocal: {
    url: "deletelocal",
    method: "DELETE",
    resource: "DELETELOCAL",
    type: "DELETE",
    params: ["id"],
  },
  deleteLocalempresa: {
    url: "deletelocalempresa",
    method: "DELETE",
    resource: "DELETELOCALEMPRESA",
    type: "DELETE",
    params: ["id"],
  },
  deleteLocationunidade: {
    url: "deletelocationunidade",
    method: "POST",
    resource: "DELETELOCATIONUNIDADE",
    type: "DELETE",
  },
  deleteMensagem: {
    url: "deletemensagem",
    method: "POST",
    resource: "DELETEMENSAGEM",
    type: "DELETE",
  },
  deleteMetatemplates: {
    url: "deletemetatemplates",
    method: "POST",
    resource: "DELETEMETATEMPLATES",
    type: "DELETE",
  },
  deleteMotivo: {
    url: "deletemotivo",
    method: "POST",
    resource: "DELETEMOTIVO",
    type: "DELETE",
  },
  deleteNotafiscal: {
    url: "deletenotafiscal",
    method: "POST",
    resource: "DELETENOTAFISCAL",
    type: "DELETE",
  },
  deleteParadasbylinha: {
    url: "deleteparadasbylinha",
    method: "POST",
    resource: "DELETEPARADASBYLINHA",
    type: "DELETE",
  },
  deletePerfil: {
    url: "deleteperfil",
    method: "POST",
    resource: "DELETEPERFIL",
    type: "DELETE",
  },
  deletePermissao: {
    url: "deletepermissao",
    method: "POST",
    resource: "DELETEPERMISSAO",
    type: "DELETE",
  },
  deletePermissionario: {
    url: "deletepermissionario",
    method: "POST",
    resource: "DELETEPERMISSIONARIO",
    type: "DELETE",
  },
  deletePermissoesbulk: {
    url: "deletepermissoesbulk",
    method: "POST",
    resource: "DELETEPERMISSOESBULK",
    type: "DELETE",
  },
  deletePermissoesperfispermissao: {
    url: "deletepermissoesperfispermissao",
    method: "POST",
    resource: "DELETEPERMISSOESPERFISPERMISSAO",
    type: "DELETE",
  },
  deletePessoa: {
    url: "deletepessoa",
    method: "POST",
    resource: "DELETEPESSOA",
    type: "DELETE",
  },
  deleteProdutointerno: {
    url: "deleteprodutointerno",
    method: "DELETE",
    resource: "DELETEPRODUTOINTERNO",
    type: "DELETE",
    params: ["id"],
  },
  deleteQuadro: {
    url: "deletequadro",
    method: "POST",
    resource: "DELETEQUADRO",
    type: "DELETE",
  },
  deleteQuadrosbylinha: {
    url: "deletequadrosbylinha",
    method: "POST",
    resource: "DELETEQUADROSBYLINHA",
    type: "DELETE",
  },
  deleteRecurso: {
    url: "deleterecurso",
    method: "POST",
    resource: "DELETERECURSO",
    type: "DELETE",
  },
  deleteRecursospermissaobulk: {
    url: "deleterecursospermissaobulk",
    method: "POST",
    resource: "DELETERECURSOSPERMISSAOBULK",
    type: "DELETE",
  },
  deleteRegistro: {
    url: "deleteregistro",
    method: "POST",
    resource: "DELETEREGISTRO",
    type: "DELETE",
  },
  deleteRota: {
    url: "deleterota",
    method: "POST",
    resource: "DELETEROTA",
    type: "DELETE",
  },
  deleteRotaslinhabulk: {
    url: "deleterotaslinhabulk",
    method: "POST",
    resource: "DELETEROTASLINHABULK",
    type: "DELETE",
  },
  deleteRotavigencia: {
    url: "deleterotavigencia",
    method: "DELETE",
    resource: "DELETEROTAVIGENCIA",
    type: "DELETE",
    params: ["id"],
  },
  deleteServico: {
    url: "deleteservico",
    method: "POST",
    resource: "DELETESERVICO",
    type: "DELETE",
  },
  deleteSimcard: {
    url: "deletesimcard",
    method: "POST",
    resource: "DELETESIMCARD",
    type: "DELETE",
  },
  deleteSituacao: {
    url: "deletesituacao",
    method: "POST",
    resource: "DELETESITUACAO",
    type: "DELETE",
  },
  deleteStatusticket: {
    url: "deletestatusticket",
    method: "POST",
    resource: "DELETETICKETSTATUS",
    type: "DELETE",
  },
  deleteTagrfid: {
    url: "deletetagrfid",
    method: "POST",
    resource: "DELETETAGRFID",
    type: "DELETE",
  },
  deleteTarifa: {
    url: "deletetarifa",
    method: "GET",
    resource: "DELETETARIFA",
    type: "DELETE",
  },
  deleteTema: {
    url: "deletetema",
    method: "GET",
    resource: "DELETETEMA",
    type: "DELETE",
  },
  deleteTemplatemensagem: {
    url: "deletetemplatemensagem",
    method: "POST",
    resource: "DELETETEMPLATEMENSAGEM",
    type: "DELETE",
  },
  deleteTicket: {
    url: "deleteticket",
    method: "GET",
    resource: "DELETETICKET",
    type: "DELETE",
  },
  deleteTipoatendimento: {
    url: "deletetipoatendimento",
    method: "POST",
    resource: "DELETETIPOATENDIMENTO",
    type: "DELETE",
  },
  deleteTipoentrada: {
    url: "deletetipoentrada",
    method: "PUT",
    resource: "DELETETIPOENTRADA",
    type: "DELETE",
  },
  deleteTipokit: {
    url: "deletetipokit",
    method: "DELETE",
    resource: "DELETETIPOKIT",
    type: "DELETE",
    params: ["id"],
  },
  deleteTipotarifa: {
    url: "deletetipotarifa",
    method: "GET",
    resource: "DELETETIPOTARIFA",
    type: "DELETE",
  },
  deleteTrecho: {
    url: "deletetrecho",
    method: "POST",
    resource: "DELETETRECHO",
    type: "DELETE",
  },
  deleteTrecholimite: {
    url: "deletetrecholimite",
    method: "POST",
    resource: "DELETETRECHOLIMITE",
    type: "DELETE",
  },
  deleteTrechosporlinha: {
    url: "deletetrechosporlinha",
    method: "POST",
    resource: "DELETETRECHOSPORLINHA",
    type: "DELETE",
  },
  deleteTurno: {
    url: "deleteturno",
    method: "POST",
    resource: "DELETETURNO",
    type: "DELETE",
  },
  deleteTurnofuncionario: {
    url: "deleteturnofuncionario",
    method: "POST",
    resource: "DELETETURNOFUNCIONARIO",
    type: "DELETE",
  },
  deleteTurnopassageiro: {
    url: "deleteturnopassageiro",
    method: "POST",
    resource: "DELETETURNOPASSAGEIRO",
    type: "DELETE",
  },
  deleteTurnoslinhabulk: {
    url: "deleteturnoslinhabulk",
    method: "POST",
    resource: "DELETETURNOSLINHABULK",
    type: "DELETE",
  },
  deleteUnidade: {
    url: "deleteunidade",
    method: "POST",
    resource: "DELETEUNIDADE",
    type: "DELETE",
  },
  deleteUsuario: {
    url: "deleteusuario",
    method: "POST",
    resource: "DELETEUSUARIO",
    type: "DELETE",
  },
  deleteVeiculo: {
    url: "deleteveiculo",
    method: "POST",
    resource: "DELETEVEICULO",
    type: "DELETE",
  },
  deleteViagemescala: {
    url: "deleteviagemescala",
    method: "POST",
    resource: "DELETEVIAGEMESCALA",
    type: "DELETE",
  },
  deleteViagemprevista: {
    url: "deleteviagemprevista",
    method: "GET",
    resource: "DELETEVIAGEMPREVISTA",
    type: "DELETE",
  },
  deleteViagemquadro: {
    url: "deleteviagemquadro",
    method: "POST",
    resource: "DELETEVIAGEMQUADRO",
    type: "DELETE",
  },
  deleteViagensbyescala: {
    url: "deleteviagensbyescala",
    method: "POST",
    resource: "DELETEVIAGENSBYESCALA",
    type: "DELETE",
  },
  deleteViagensbyquadro: {
    url: "deleteviagensbyquadro",
    method: "POST",
    resource: "DELETEVIAGENSBYQUADRO",
    type: "DELETE",
  },
  deleteVigenciahodometroveiculo: {
    url: "deletevigenciahodometroveiculo",
    method: "POST",
    resource: "DELETEVIGENCIAHODOMETROVEICULO",
    type: "DELETE",
  },
  desassociaLinhasbulk: {
    url: "desassocialinhasbulk",
    method: "POST",
    resource: "DESASSOCIALINHASBULK",
    type: "WRITE",
  },
  desassociaRotasbulk: {
    url: "desassociarotasbulk",
    method: "POST",
    resource: "DESASSOCIAROTASBULK",
    type: "WRITE",
  },
  desassociaRusuariosbulk: {
    url: "desassociarusuariosbulk",
    method: "POST",
    resource: "DESASSOCIARUSUARIOSBULK",
    type: "WRITE",
  },
  desassociaSublinhasbulk: {
    url: "desassociasublinhasbulk",
    method: "POST",
    resource: "DESASSOCIASUBLINHASBULK",
    type: "WRITE",
  },
  desassociaUnidadesarea: {
    url: "desassociaunidadesarea",
    method: "POST",
    resource: "DESASSOCIAUNIDADESAREA",
    type: "WRITE",
  },
  desativaEscala: {
    url: "desativaescala",
    method: "POST",
    resource: "DESATIVAESCALA",
    type: "WRITE",
  },
  desativaQuadro: {
    url: "desativaquadro",
    method: "POST",
    resource: "DESATIVAQUADRO",
    type: "WRITE",
  },
  docs: {
    url: "docs",
    method: "GET",
    resource: "DOCS",
    type: "READ",
  },
  downloadDocumento: {
    url: "downloaddocumento",
    method: "GET",
    resource: "DOWNLOADDOCUMENTO",
    type: "READ",
    params: ["filename"],
  },
  downloadLog: {
    url: "downloadlog",
    method: "GET",
    resource: "DOWNLOADLOG",
    type: "READ",
    params: ["filename"],
  },
  downloadQrcode: {
    url: "downloadqrcode",
    method: "POST",
    resource: "DOWNLOADQRCODE",
    type: "READ",
    params: ["qrcode_no","id_pessoa"],
  },
  downloadQrcodeequipamento: {
    url: "downloadqrcodeequipamento",
    method: "GET",
    resource: "DOWNLOADQRCODEEQUIPAMENTO",
    type: "READ",
    params: ["id_equipamento"],
  },
  downloadQrcodekit: {
    url: "downloadqrcodekit",
    method: "GET",
    resource: "DOWNLOADQRCODEKIT",
    type: "READ",
    params: ["id_kit"],
  },
  downloadQrcodesequipamentos: {
    url: "downloadqrcodesequipamentos",
    method: "GET",
    resource: "DOWNLOADQRCODESEQUIPAMENTOS",
    type: "READ",
    query: ["quantity","format","columns"],
  },
  downloadQrcodeskits: {
    url: "downloadqrcodeskits",
    method: "GET",
    resource: "DOWNLOADQRCODESKITS",
    type: "READ",
    query: ["quantity","format","columns"],
  },
  ensureqrcodepool: {
    url: "ensureqrcodepool",
    method: "GET",
    resource: "ENSUREQRCODEPOOL",
    type: "READ",
  },
  enviacredenciais: {
    url: "enviacredenciais",
    method: "POST",
    resource: "ENVIACREDENCIAIS",
    type: "WRITE",
  },
  enviamensagem: {
    url: "enviamensagem",
    method: "POST",
    resource: "ENVIAMENSAGEM",
    type: "WRITE",
  },
  enviamensagensbulk: {
    url: "enviamensagensbulk",
    method: "POST",
    resource: "ENVIAMENSAGENSBULK",
    type: "WRITE",
  },
  enviaqrcodeemail: {
    url: "enviaqrcodeemail",
    method: "POST",
    resource: "ENVIAQRCODEEMAIL",
    type: "WRITE",
  },
  exportDownloadTableCsv: {
    url: "export/downloadtablecsv",
    method: "POST",
    resource: "EXPORT_DOWNLOADTABLECSV",
    type: "READ",
  },
  exportTableCsv: {
    url: "export/tablecsv",
    method: "POST",
    resource: "EXPORT_TABLECSV",
    type: "WRITE",
  },
  fechaviagemgridcontrolador: {
    url: "fechaviagemgridcontrolador",
    method: "POST",
    resource: "FECHAVIAGEMGRIDCONTROLADOR",
    type: "WRITE",
  },
  generateLogbulk: {
    url: "generatelogbulk",
    method: "POST",
    resource: "GENERATELOGBULK",
    type: "WRITE",
  },
  gerarotaotimizadalinha: {
    url: "gerarotaotimizadalinha",
    method: "POST",
    resource: "GERAROTAOTIMIZADALINHA",
    type: "WRITE",
  },
  gerarotaotimizadaunidade: {
    url: "gerarotaotimizadaunidade",
    method: "POST",
    resource: "GERAROTAOTIMIZADAUNIDADE",
    type: "WRITE",
  },
  getAcessoscategoria: {
    url: "getacessoscategoria",
    method: "GET",
    resource: "GETACESSOSCATEGORIA",
    type: "READ",
    params: ["id"],
  },
  getAdocaosistemaagrupamento: {
    url: "getadocaosistemaagrupamento",
    method: "POST",
    resource: "GETADOCAOSISTEMAAGRUPAMENTO",
    type: "READ",
  },
  getAdocaosistemabase: {
    url: "getadocaosistemabase",
    method: "POST",
    resource: "GETADOCAOSISTEMABASE",
    type: "READ",
  },
  getAdocaosistemalideres: {
    url: "getadocaosistemalideres",
    method: "POST",
    resource: "GETADOCAOSISTEMALIDERES",
    type: "READ",
  },
  getAdocaosistemapassageiros: {
    url: "getadocaosistemapassageiros",
    method: "POST",
    resource: "GETADOCAOSISTEMAPASSAGEIROS",
    type: "READ",
  },
  getAdocaosistemaresumo: {
    url: "getadocaosistemaresumo",
    method: "POST",
    resource: "GETADOCAOSISTEMARESUMO",
    type: "READ",
  },
  getAgenciasempregolazy: {
    url: "getagenciasempregolazy",
    method: "POST",
    resource: "GETAGENCIASEMPREGOLAZY",
    type: "READ",
  },
  getAgendamentosbyidagendamento: {
    url: "getagendamentosbyidagendamento",
    method: "POST",
    resource: "GETAGENDAMENTOSBYIDAGENDAMENTO",
    type: "READ",
  },
  getAgendamentosbyidveiculo: {
    url: "getagendamentosbyidveiculo",
    method: "POST",
    resource: "GETAGENDAMENTOSBYIDVEICULO",
    type: "READ",
  },
  getAgregadoconciliacao: {
    url: "getagregadoconciliacao",
    method: "POST",
    resource: "GETAGREGADOCONCILIACAO",
    type: "READ",
  },
  getAgregadoconciliacaoporlinha: {
    url: "getagregadoconciliacaoporlinha",
    method: "POST",
    resource: "GETAGREGADOCONCILIACAOPORLINHA",
    type: "READ",
  },
  getAgregadomanutencaolinhas: {
    url: "getagregadomanutencaolinhas",
    method: "POST",
    resource: "GETAGREGADOMANUTENCAOLINHAS",
    type: "READ",
  },
  getAgregadomanutencaosentidos: {
    url: "getagregadomanutencaosentidos",
    method: "POST",
    resource: "GETGAREGADOMANUTENCAOSENTIDOS",
    type: "READ",
  },
  getAgregadomanutencaoviagens: {
    url: "getagregadomanutencaoviagens",
    method: "POST",
    resource: "GETAGREGADOMANUTENCAOVIAGENS",
    type: "READ",
  },
  getAgregadoprevrealizadoguias: {
    url: "getagregadoprevrealizadoguias",
    method: "POST",
    resource: "GETAGREGADOPREVREALIZADOGUIAS",
    type: "READ",
  },
  getAgregadoprevrealizadolinhas: {
    url: "getagregadoprevrealizadolinhas",
    method: "POST",
    resource: "GETAGREGADOPREVREALIZADOLINHAS",
    type: "READ",
  },
  getAgregadoprevrealizadoveiculos: {
    url: "getagregadoprevrealizadoveiculos",
    method: "POST",
    resource: "GETAGREGADOPREVREALIZADOVEICULOS",
    type: "READ",
  },
  getAgregadostatusviagens: {
    url: "getagregadostatusviagens",
    method: "POST",
    resource: "GETAGREGADOSTATUSVIAGENS",
    type: "READ",
  },
  getAgregadosviagens: {
    url: "getagregadosviagens",
    method: "GET",
    resource: "GETAGREGADOSVIAGENS",
    type: "READ",
    params: ["atraso","adiantamento","dti","dtf"],
  },
  getAgregadosviagensempresas: {
    url: "getagregadosviagensempresas",
    method: "POST",
    resource: "GETAGREGADOSVIAGENSEMPRESAS",
    type: "READ",
  },
  getAgregadosviagensguias: {
    url: "getagregadosviagensguias",
    method: "POST",
    resource: "GETAGREGADOSVIAGENSGUIAS",
    type: "READ",
  },
  getAgregadosviagenslinhas: {
    url: "getagregadosviagenslinhas",
    method: "GET",
    resource: "GETAGREGADOSVIAGENSLINHAS",
    type: "READ",
    params: ["atraso","adiantamento","dti","dtf"],
  },
  getAgregadosviagensveiculos: {
    url: "getagregadosviagensveiculos",
    method: "POST",
    resource: "GETAGREGADOSVIAGENSVEICULOS",
    type: "READ",
  },
  getAgregadoviagensmotivos: {
    url: "getagregadoviagensmotivos",
    method: "POST",
    resource: "GETAGREGADOVIAGENSMOTIVOS",
    type: "READ",
  },
  getApprovedmetatemplates: {
    url: "getapprovedmetatemplates",
    method: "GET",
    resource: "GETAPPROVEDMETATEMPLATES",
    type: "READ",
  },
  getAreaporid: {
    url: "getareaporid",
    method: "GET",
    resource: "GETAREAPORID",
    type: "READ",
    params: ["id"],
  },
  getAreaslazy: {
    url: "getareaslazy",
    method: "POST",
    resource: "GETAREASLAZY",
    type: "READ",
  },
  getAreasunidades: {
    url: "getareasunidades",
    method: "POST",
    resource: "GETAREASUNIDADES",
    type: "READ",
  },
  getArquivosagendamentobyidagendamento: {
    url: "getarquivosagendamentobyidagendamento",
    method: "POST",
    resource: "GETARQUIVOSAGENDAMENTOBYIDAGENDAMENTO",
    type: "READ",
  },
  getAtrasocercasdata: {
    url: "getatrasocercasdata",
    method: "GET",
    resource: "GETATRASOCERCASDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getAvailableqrcodesequipamentos: {
    url: "getavailableqrcodesequipamentos",
    method: "GET",
    resource: "GETAVAILABLEQRCODESEQUIPAMENTOS",
    type: "READ",
  },
  getAvailableqrcodesequipamentoslazy: {
    url: "getavailableqrcodesequipamentoslazy",
    method: "POST",
    resource: "GETAVAILABLEQRCODESEQUIPAMENTOSLAZY",
    type: "READ",
  },
  getAvailableqrcodeskits: {
    url: "getavailableqrcodeskits",
    method: "GET",
    resource: "GETAVAILABLEQRCODESKITS",
    type: "READ",
  },
  getAvisosbannerbyiddata: {
    url: "getavisosbannerbyiddata",
    method: "GET",
    resource: "GETAVISOSBANNERBYIDDATA",
    type: "READ",
    params: ["id_banner","dti","dtf"],
  },
  getAvisosvigentesbannerbyid: {
    url: "getavisosvigentesbannerbyid",
    method: "GET",
    resource: "GETAVISOSVIGENTESBANNERBYID",
    type: "READ",
    params: ["id_banner"],
  },
  getBalancotiposveiculounidade: {
    url: "getbalancotiposveiculounidade",
    method: "POST",
    resource: "GETBALANCOTIPOSVEICULOUNIDADE",
    type: "READ",
  },
  getBaselinehistoricoalteracoesrotas: {
    url: "getbaselinehistoricoalteracoesrotas",
    method: "GET",
    resource: "GETBASELINEHISTORICOALTERACOESROTAS",
    type: "READ",
    query: ["id_rota"],
  },
  getBilhetagensporcarrodata: {
    url: "getbilhetagensporcarrodata",
    method: "POST",
    resource: "GETBILHETAGENSPORCARRODATA",
    type: "READ",
  },
  getBilhetagenspormatriculadata: {
    url: "getbilhetagenspormatriculadata",
    method: "GET",
    resource: "GETBILHETAGENSPORMATRICULADATA",
    type: "READ",
    params: ["matricula","dti","dtf"],
  },
  getBilhetagensporservico: {
    url: "getbilhetagensporservico",
    method: "GET",
    resource: "GETBILHETAGENSPORSERVICO",
    type: "READ",
    params: ["matricula"],
  },
  getBilhetagenstotaisdata: {
    url: "getbilhetagenstotaisdata",
    method: "POST",
    resource: "GETBILHETAGENSTOTAISDATA",
    type: "READ",
  },
  getBilhetagenstotaisdatacarros: {
    url: "getbilhetagenstotaisdatacarros",
    method: "POST",
    resource: "GETBILHETAGENSTOTAISDATACARROS",
    type: "READ",
  },
  getBilhetagenstotaisdatalinhas: {
    url: "getbilhetagenstotaisdatalinhas",
    method: "POST",
    resource: "GETBILHETAGENSTOTAISDATALINHAS",
    type: "READ",
  },
  getCanaistiponotificacaoporid: {
    url: "getcanaistiponotificacaoporid",
    method: "GET",
    resource: "GETCANAISTIPONOTIFICACAOPORID",
    type: "READ",
    params: ["id"],
  },
  getCanaistiposnotificacoes: {
    url: "getcanaistiposnotificacoes",
    method: "GET",
    resource: "GETCANAISTIPOSNOTIFICACOES",
    type: "READ",
  },
  getCatalogoendpoints: {
    url: "getcatalogoendpoints",
    method: "GET",
    resource: "GETCATALOGOENDPOINTS",
    type: "READ",
  },
  getCatalogotelas: {
    url: "getcatalogotelas",
    method: "GET",
    resource: "GETCATALOGOTELAS",
    type: "READ",
  },
  getCategoriasfuncionarios: {
    url: "getcategoriasfuncionarios",
    method: "GET",
    resource: "GETCATEGORIASFUNCIONARIOS",
    type: "READ",
  },
  getCategoriasquadros: {
    url: "getcategoriasquadros",
    method: "GET",
    resource: "GETCATEGORIASQUADROS",
    type: "READ",
  },
  getCercamaisproxima: {
    url: "getcercamaisproxima",
    method: "POST",
    resource: "GETCERCAMAISPROXIMA",
    type: "READ",
  },
  getCercaporid: {
    url: "getcercaporid",
    method: "GET",
    resource: "GETCERCAPORID",
    type: "READ",
    params: ["id"],
  },
  getCercascontrolador: {
    url: "getcercascontrolador",
    method: "GET",
    resource: "GETCERCASCONTROLADOR",
    type: "READ",
    params: ["id"],
  },
  getCercasgeometriaporids: {
    url: "getcercasgeometriaporids",
    method: "POST",
    resource: "GETCERCASGEOMETRIAPORIDS",
    type: "READ",
  },
  getCercaslazy: {
    url: "getcercaslazy",
    method: "POST",
    resource: "GETCERCASLAZY",
    type: "READ",
  },
  getCercaspadraoporlinha: {
    url: "getcercaspadraoporlinha",
    method: "POST",
    resource: "GETCERCASPADRAOPORLINHA",
    type: "READ",
  },
  getCercasporcliente: {
    url: "getcercasporcliente",
    method: "GET",
    resource: "GETCERCASPORCLIENTE",
    type: "READ",
    params: ["id"],
  },
  getCercasporcodigo: {
    url: "getcercasporcodigo",
    method: "POST",
    resource: "GETCERCASPORCODIGO",
    type: "READ",
  },
  getCercasporlinha: {
    url: "getcercasporlinha",
    method: "POST",
    resource: "GETCERCASPORLINHA",
    type: "READ",
  },
  getCercasporlinhacomvigencia: {
    url: "getcercasporlinhacomvigencia",
    method: "POST",
    resource: "GETCERCASPORLINHACOMVIGENCIA",
    type: "READ",
  },
  getCercasregistro: {
    url: "getcercasregistro",
    method: "GET",
    resource: "GETCERCASREGISTRO",
    type: "READ",
    params: ["registro"],
  },
  getCercasselect: {
    url: "getcercasselect",
    method: "GET",
    resource: "GETCERCASSELECT",
    type: "READ",
  },
  getCercasselectroteirizacao: {
    url: "getcercasselectroteirizacao",
    method: "GET",
    resource: "GETCERCASSELECTROTEIRIZACAO",
    type: "READ",
  },
  getCercasvalidacaocandidato: {
    url: "getcercasvalidacaocandidato",
    method: "GET",
    resource: "GETCERCASVALIDACAOCANDIDATO",
    type: "READ",
    params: ["id"],
  },
  getCercasvigenciaporlinha: {
    url: "getcercasvigenciaporlinha",
    method: "POST",
    resource: "GETCERCASVIGENCIAPORLINHA",
    type: "READ",
  },
  getCercavigenciaporid: {
    url: "getcercavigenciaporid",
    method: "GET",
    resource: "GETCERCAVIGENCIAPORID",
    type: "READ",
    params: ["id"],
  },
  getChecklistequipamentoporid: {
    url: "getchecklistequipamentoporid",
    method: "GET",
    resource: "GETCHECKLISTEQUIPAMENTOPORID",
    type: "READ",
    params: ["id"],
  },
  getChecklistequipamentorespostaporid: {
    url: "getchecklistequipamentorespostaporid",
    method: "GET",
    resource: "GETCHECKLISTEQUIPAMENTORESPOSTAPORID",
    type: "READ",
    params: ["id"],
  },
  getChecklistequipamentorespostaporticket: {
    url: "getchecklistequipamentorespostaporticket",
    method: "GET",
    resource: "GETCHECKLISTEQUIPAMENTORESPOSTAPORTICKET",
    type: "READ",
    params: ["id_ticket"],
    query: ["id_checklist_equipamento"],
  },
  getChecklistsequipamentorespostasagregadasporfuncionario: {
    url: "getchecklistsequipamentorespostasagregadasporfuncionario",
    method: "GET",
    resource: "GETCHECKLISTSEQUIPAMENTORESPOSTASAGREGADASPORFUNCIONARIO",
    type: "READ",
    params: ["dti","dtf","idEquipamento"],
  },
  getChecklistsequipamentorespostasporchecklist: {
    url: "getchecklistsequipamentorespostasporchecklist",
    method: "GET",
    resource: "GETCHECKLISTSEQUIPAMENTORESPOSTASPORCHECKLIST",
    type: "READ",
    params: ["idChecklist"],
  },
  getChecklistsequipamentorespostaspordata: {
    url: "getchecklistsequipamentorespostaspordata",
    method: "GET",
    resource: "GETCHECKLISTSEQUIPAMENTORESPOSTASPORDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getChecklistsequipamentorespostasporequipamento: {
    url: "getchecklistsequipamentorespostasporequipamento",
    method: "GET",
    resource: "GETCHECKLISTSEQUIPAMENTORESPOSTASPOREQUIPAMENTO",
    type: "READ",
    params: ["idEquipamento"],
  },
  getChecklistsequipamentospordata: {
    url: "getchecklistsequipamentospordata",
    method: "GET",
    resource: "GETCHECKLISTSEQUIPAMENTOSPORDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getChecklistspordata: {
    url: "getchecklistspordata",
    method: "GET",
    resource: "GETCHECKLISTSPORDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getClassificacaoporid: {
    url: "getclassificacaoporid",
    method: "GET",
    resource: "GETCLASSIFICACAOPORID",
    type: "READ",
    params: ["id"],
  },
  getClientesativos: {
    url: "getclientesativos",
    method: "GET",
    resource: "GETCLIENTESATIVOS",
    type: "READ",
  },
  getClienteslazy: {
    url: "getclienteslazy",
    method: "POST",
    resource: "GETCLIENTESLAZY",
    type: "READ",
  },
  getClientesporcodigo: {
    url: "getclientesporcodigo",
    method: "GET",
    resource: "GETCLIENTESPORCODIGO",
    type: "READ",
    params: ["id"],
  },
  getClientesporempresa: {
    url: "getclientesporempresa",
    method: "GET",
    resource: "GETCLIENTESPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getComboiosdata: {
    url: "getcomboiosdata",
    method: "GET",
    resource: "GETCOMBOIOSDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getComboioslinhadata: {
    url: "getcomboioslinhadata",
    method: "GET",
    resource: "GETCOMBOIOSLINHADATA",
    type: "READ",
    params: ["idlinha","dti","dtf"],
  },
  getComentariosbyticketid: {
    url: "getcomentariosbyticketid",
    method: "GET",
    resource: "GETCOMENTARIOSBYTICKETID",
    type: "READ",
    params: ["id"],
  },
  getCompanies: {
    url: "getcompanies",
    method: "GET",
    resource: "GETCOMPANIES",
    type: "READ",
  },
  getCompaniesporperiodo: {
    url: "getcompaniesporperiodo",
    method: "GET",
    resource: "GETCOMPANIESPORPERIODO",
    type: "READ",
    params: ["dtinicio","dtfim"],
  },
  getComparacaoetaslinhas: {
    url: "getcomparacaoetaslinhas",
    method: "POST",
    resource: "GETCOMPARACAOETASLINHAS",
    type: "READ",
  },
  getComparacaorotaslinha: {
    url: "getcomparacaorotaslinha",
    method: "POST",
    resource: "GETCOMPARACAOROTASLINHA",
    type: "READ",
  },
  getComparacaorotasunidade: {
    url: "getcomparacaorotasunidade",
    method: "POST",
    resource: "GETCOMPARACAOROTASUNIDADE",
    type: "READ",
  },
  getConcessoesperfil: {
    url: "getconcessoesperfil",
    method: "GET",
    resource: "GETCONCESSOESPERFIL",
    type: "READ",
    params: ["id"],
  },
  getConcessoesusuario: {
    url: "getconcessoesusuario",
    method: "GET",
    resource: "GETCONCESSOESUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getCondicaoatual: {
    url: "getcondicaoatual",
    method: "GET",
    resource: "GETCONDICAOATUAL",
    type: "READ",
  },
  getCondicaoatualcidade: {
    url: "getcondicaoatualcidade",
    method: "GET",
    resource: "GETCONDICAOATUALCIDADE",
    type: "READ",
    params: ["id"],
  },
  getCondicaoporcidadedata: {
    url: "getcondicaoporcidadedata",
    method: "GET",
    resource: "GETCONDICAOPORCIDADEDATA",
    type: "READ",
    params: ["id","dti","dtf"],
  },
  getCondicaopordata: {
    url: "getcondicaopordata",
    method: "GET",
    resource: "GETCONDICAOPORDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getCorridasenvioqrcode: {
    url: "getcorridasenvioqrcode",
    method: "GET",
    resource: "GETCORRIDASENVIOQRCODE",
    type: "READ",
    query: ["dti","dtf"],
  },
  getDashboardbyid: {
    url: "getdashboardbyid",
    method: "GET",
    resource: "GETDASHBOARDBYID",
    type: "READ",
    params: ["id"],
  },
  getDashboardtickets: {
    url: "getdashboardtickets",
    method: "GET",
    resource: "GETDASHBOARDTICKETS",
    type: "READ",
  },
  getDashboardviagens: {
    url: "getdashboardviagens",
    method: "GET",
    resource: "GETDASHBOARDVIAGENS",
    type: "READ",
  },
  getDesviosoperacionaiscercasnaopassadas: {
    url: "getdesviosoperacionaiscercasnaopassadas",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISCERCASNAOPASSADAS",
    type: "READ",
  },
  getDesviosoperacionaisembarquesforacerca: {
    url: "getdesviosoperacionaisembarquesforacerca",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISEMBARQUESFORACERCA",
    type: "READ",
  },
  getDesviosoperacionaisembarquesporcerca: {
    url: "getdesviosoperacionaisembarquesporcerca",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISEMBARQUESPORCERCA",
    type: "READ",
  },
  getDesviosoperacionaisembarquessemviagem: {
    url: "getdesviosoperacionaisembarquessemviagem",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISEMBARQUESSEMVIAGEM",
    type: "READ",
  },
  getDesviosoperacionaisresumo: {
    url: "getdesviosoperacionaisresumo",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISRESUMO",
    type: "READ",
  },
  getDesviosoperacionaisviagensinvalidas: {
    url: "getdesviosoperacionaisviagensinvalidas",
    method: "POST",
    resource: "GETDESVIOSOPERACIONAISVIAGENSINVALIDAS",
    type: "READ",
  },
  getDocumentosporidpessoa: {
    url: "getdocumentosporidpessoa",
    method: "GET",
    resource: "GETDOCUMENTOSPORIDPESSOA",
    type: "READ",
    params: ["id"],
  },
  getDocumentosporidveiculo: {
    url: "getdocumentosporidveiculo",
    method: "GET",
    resource: "GETDOCUMENTOSPORIDVEICULO",
    type: "READ",
    params: ["id"],
  },
  getEmbarquesnaoassociadosfechamentodia: {
    url: "getembarquesnaoassociadosfechamentodia",
    method: "POST",
    resource: "GETEMBARQUESNAOASSOCIADOSFECHAMENTODIA",
    type: "READ",
  },
  getEmbarquesporhoradata: {
    url: "getembarquesporhoradata",
    method: "GET",
    resource: "GETEMBARQUESPORHORADATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getEmbarquesporhoradatacliente: {
    url: "getembarquesporhoradatacliente",
    method: "POST",
    resource: "GETEMBARQUESPORHORADATACLIENTE",
    type: "READ",
  },
  getEmbarquesporhoradatarotas: {
    url: "getembarquesporhoradatarotas",
    method: "POST",
    resource: "GETEMBARQUESPORHORADATAROTAS",
    type: "READ",
  },
  getEmbarquesporhoradataunidades: {
    url: "getembarquesporhoradataunidades",
    method: "POST",
    resource: "GETEMBARQUESPORHORADATAUNIDADES",
    type: "READ",
  },
  getEmbarquesporhoradataveiculos: {
    url: "getembarquesporhoradataveiculos",
    method: "POST",
    resource: "GETEMBARQUESPORHORADATAVEICULOS",
    type: "READ",
  },
  getEmbarquesporviagem: {
    url: "getembarquesporviagem",
    method: "POST",
    resource: "GETEMBARQUESPORVIAGEM",
    type: "READ",
  },
  getEmbarquestrecho: {
    url: "getembarquestrecho",
    method: "POST",
    resource: "GETEMBARQUESTRECHO",
    type: "READ",
  },
  getEmpresaporrazao: {
    url: "getempresaporrazao",
    method: "GET",
    resource: "GETEMPRESAPORRAZAO",
    type: "READ",
    query: ["razao"],
  },
  getEmpresaslazy: {
    url: "getempresaslazy",
    method: "POST",
    resource: "GETEMPRESASLAZY",
    type: "READ",
  },
  getEmpresasmatriz: {
    url: "getempresasmatriz",
    method: "GET",
    resource: "GETEMPRESASMATRIZ",
    type: "READ",
  },
  getEnderecodevalidacao: {
    url: "getenderecodevalidacao",
    method: "GET",
    resource: "GETENDERECODEVALIDACAO",
    type: "READ",
    params: ["id"],
  },
  getEnderecoexterno: {
    url: "getenderecoexterno",
    method: "GET",
    resource: "GETENDERECOEXTERNO",
    type: "READ",
    params: ["id"],
  },
  getEnderecoskpisenderecosexternos: {
    url: "getenderecoskpisenderecosexternos",
    method: "POST",
    resource: "GETENDERECOSKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  getEnderecosvalidacoes: {
    url: "getenderecosvalidacoes",
    method: "GET",
    resource: "GETENDERECOSVALIDACOES",
    type: "READ",
    params: ["id"],
  },
  getEnderecosvalidacoesporendereco: {
    url: "getenderecosvalidacoesporendereco",
    method: "GET",
    resource: "GETENDERECOSVALIDACOESPORENDERECO",
    type: "READ",
    params: ["idEndereco"],
  },
  getEnderecosvalidadosalocacao: {
    url: "getenderecosvalidadosalocacao",
    method: "POST",
    resource: "GETENDERECOSVALIDADOSALOCACAO",
    type: "READ",
  },
  getEnderecosvalidadospessoa: {
    url: "getenderecosvalidadospessoa",
    method: "POST",
    resource: "GETENDERECOSVALIDADOSPESSOA",
    type: "READ",
  },
  getEnderecovalidadoid: {
    url: "getenderecovalidadoid",
    method: "GET",
    resource: "GETENDERECOVALIDADOID",
    type: "READ",
    params: ["id"],
  },
  getEndpointstela: {
    url: "getendpointstela",
    method: "GET",
    resource: "GETENDPOINTSTELA",
    type: "READ",
    params: ["id"],
  },
  getEntradasaidagaragemporcarro: {
    url: "getentradasaidagaragemporcarro",
    method: "GET",
    resource: "GETENTRADASAIDAGARAGEMPORCARRO",
    type: "READ",
    params: ["id","dti","dtf"],
  },
  getEntradasaidagaragemporfuncionario: {
    url: "getentradasaidagaragemporfuncionario",
    method: "GET",
    resource: "GETENTRADASAIDAGARAGEMPORFUNCIONARIO",
    type: "READ",
    params: ["id","dti","dtf"],
  },
  getEntradaspordata: {
    url: "getentradaspordata",
    method: "POST",
    resource: "GETENTRADASPORDATA",
    type: "READ",
  },
  getEnviosmensagemporid: {
    url: "getenviosmensagemporid",
    method: "GET",
    resource: "GETENVIOSMENSAGEMPORID",
    type: "READ",
    params: ["id"],
  },
  getEnviosmensagensdata: {
    url: "getenviosmensagensdata",
    method: "GET",
    resource: "GETENVIOSMENSAGENSDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getEquipamentobyid: {
    url: "getequipamentobyid",
    method: "GET",
    resource: "GETEQUIPAMENTOBYID",
    type: "READ",
    params: ["id"],
  },
  getEquipamentosbynotafiscal: {
    url: "getequipamentosbynotafiscal",
    method: "GET",
    resource: "GETEQUIPAMENTOSBYNOTAFISCAL",
    type: "READ",
    params: ["id"],
  },
  getEquipamentosdvr: {
    url: "getequipamentosdvr",
    method: "POST",
    resource: "GETEQUIPAMENTOSDVR",
    type: "READ",
  },
  getEquipamentoslazy: {
    url: "getequipamentoslazy",
    method: "POST",
    resource: "GETEQUIPAMENTOSLAZY",
    type: "READ",
  },
  getEquipamentosnaoutilizados: {
    url: "getequipamentosnaoutilizados",
    method: "GET",
    resource: "GETEQUIPAMENTOSNAOUTILIZADOS",
    type: "READ",
  },
  getEquipamentosrastreadores: {
    url: "getequipamentosrastreadores",
    method: "POST",
    resource: "GETEQUIPAMENTOSRASTREADORES",
    type: "READ",
  },
  getEquipamentosvalidadores: {
    url: "getequipamentosvalidadores",
    method: "POST",
    resource: "GETEQUIPAMENTOSVALIDADORES",
    type: "READ",
  },
  getEquipamentosvalidadoresrastreadoresbilhetagem: {
    url: "getequipamentosvalidadoresrastreadoresbilhetagem",
    method: "POST",
    resource: "GETEQUIPAMENTOSVALIDADORESRASTREADORESBILHETAGEM",
    type: "READ",
  },
  getEquipeporid: {
    url: "getequipeporid",
    method: "GET",
    resource: "GETEQUIPEPORID",
    type: "READ",
    params: ["id"],
  },
  getEquipeslazy: {
    url: "getequipeslazy",
    method: "POST",
    resource: "GETEQUIPESLAZY",
    type: "READ",
  },
  getEquipesporusuario: {
    url: "getequipesporusuario",
    method: "GET",
    resource: "GETEQUIPESPORUSUARIO",
    type: "READ",
    params: ["id_usuario"],
  },
  getEquipmentidsinkits: {
    url: "getequipmentidsinkits",
    method: "GET",
    resource: "GETEQUIPMENTIDSINKITS",
    type: "READ",
    params: ["excludeKitId"],
  },
  getErroshikvisionporequipamento: {
    url: "geterroshikvisionporequipamento",
    method: "GET",
    resource: "GETERROSHIKVISIONPOREQUIPAMENTO",
    type: "READ",
    params: ["id"],
  },
  getErroshikvisionporpessoa: {
    url: "geterroshikvisionporpessoa",
    method: "GET",
    resource: "GETERROSHIKVISIONPORPESSOA",
    type: "READ",
    params: ["id"],
  },
  getEscalaveiculosporrota: {
    url: "getescalaveiculosporrota",
    method: "GET",
    resource: "GETESCALAVEICULOSPORROTA",
    type: "READ",
    params: ["id_rota"],
  },
  getEtaparadaslinha: {
    url: "getetaparadaslinha",
    method: "GET",
    resource: "GETETAPARADASLINHA",
    type: "READ",
    params: ["idLinha","idSentido"],
  },
  getEtaviagem: {
    url: "getetaviagem",
    method: "GET",
    resource: "GETETAVIAGEM",
    type: "READ",
    params: ["idviagem"],
  },
  getEventosporhoradata: {
    url: "geteventosporhoradata",
    method: "GET",
    resource: "GETEVENTOSPORHORADATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getEventosporhoradatarotas: {
    url: "geteventosporhoradatarotas",
    method: "POST",
    resource: "GETEVENTOSPORHORADATAROTAS",
    type: "READ",
  },
  getEventosporhoradataunidades: {
    url: "geteventosporhoradataunidades",
    method: "POST",
    resource: "GETEVENTOSPORHORADATAUNIDADES",
    type: "READ",
  },
  getEventosporhoradataveiculos: {
    url: "geteventosporhoradataveiculos",
    method: "POST",
    resource: "GETEVENTOSPORHORADATAVEICULOS",
    type: "READ",
  },
  getEventospormatriculadata: {
    url: "geteventospormatriculadata",
    method: "GET",
    resource: "GETEVENTOSPORMATRICULADATA",
    type: "READ",
    params: ["matricula","dti","dtf"],
  },
  getFamiliasatendimento: {
    url: "getfamiliasatendimento",
    method: "GET",
    resource: "GETFAMILIASATENDIMENTO",
    type: "READ",
    query: ["id_tipo_ticket","id_tipo_solicitacao"],
  },
  getFotoprincipal: {
    url: "getfotoprincipal",
    method: "GET",
    resource: "GETFOTOPRINCIPAL",
    type: "READ",
    params: ["id"],
  },
  getFotos: {
    url: "getfotos",
    method: "GET",
    resource: "GETFOTOS",
    type: "READ",
    params: ["pasta"],
  },
  getFuncionarioporempresa: {
    url: "getfuncionarioporempresa",
    method: "GET",
    resource: "GETFUNCIONARIOPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getFuncionariosguia: {
    url: "getfuncionariosguia",
    method: "GET",
    resource: "GETFUNCIONARIOSGUIA",
    type: "READ",
    params: ["idguia"],
  },
  getFuncionariosguiabulk: {
    url: "getfuncionariosguiabulk",
    method: "POST",
    resource: "GETFUNCIONARIOSGUIABULK",
    type: "READ",
  },
  getFuncionarioslazy: {
    url: "getfuncionarioslazy",
    method: "POST",
    resource: "GETFUNCIONARIOSLAZY",
    type: "READ",
  },
  getGeojsonfromfile: {
    url: "getgeojsonfromfile",
    method: "GET",
    resource: "GETGEOJSONFROMFILE",
    type: "READ",
    params: ["file"],
  },
  getGruposlazy: {
    url: "getgruposlazy",
    method: "POST",
    resource: "GETGRUPOSLAZY",
    type: "READ",
  },
  getGruposmatriz: {
    url: "getgruposmatriz",
    method: "GET",
    resource: "GETGRUPOSMATRIZ",
    type: "READ",
  },
  getGruposporlinhas: {
    url: "getgruposporlinhas",
    method: "POST",
    resource: "GETGRUPOSPORLINHAS",
    type: "READ",
  },
  getGuiamotoristahistorico: {
    url: "getguiamotoristahistorico",
    method: "GET",
    resource: "GETGUIAMOTORISTAHISTORICO",
    type: "READ",
    params: ["dti","dtf"],
  },
  getGuiamotoristainsertformdata: {
    url: "getguiamotoristainsertformdata",
    method: "GET",
    resource: "GETGUIAMOTORISTAINSERTFORMDATA",
    type: "READ",
  },
  getGuiamotoristarota: {
    url: "getguiamotoristarota",
    method: "GET",
    resource: "GETGUIAMOTORISTAROTA",
    type: "READ",
    params: ["id_guia"],
  },
  getGuiamotoristaveiculoposicao: {
    url: "getguiamotoristaveiculoposicao",
    method: "GET",
    resource: "GETGUIAMOTORISTAVEICULOPOSICAO",
    type: "READ",
    params: ["id_guia"],
  },
  getGuiamotoristaviagensporquadro: {
    url: "getguiamotoristaviagensporquadro",
    method: "GET",
    resource: "GETGUIAMOTORISTAVIAGENSPORQUADRO",
    type: "READ",
    params: ["id_quadro"],
  },
  getGuiasdata: {
    url: "getguiasdata",
    method: "GET",
    resource: "GETGUIASDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getGuiasemoperacao: {
    url: "getguiasemoperacao",
    method: "GET",
    resource: "GETGUIASEMOPERACAO",
    type: "READ",
  },
  getGuiasmotoristadia: {
    url: "getguiasmotoristadia",
    method: "GET",
    resource: "GETGUIASMOTORISTADIA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getGuiasporempresa: {
    url: "getguiasporempresa",
    method: "GET",
    resource: "GETGUIASPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getGuiasveiculodata: {
    url: "getguiasveiculodata",
    method: "POST",
    resource: "GETGUIASVEICULODATA",
    type: "READ",
  },
  getGuiasveiculosativos: {
    url: "getguiasveiculosativos",
    method: "GET",
    resource: "GETGUIASVEICULOSATIVOS",
    type: "READ",
  },
  getGuiaveiculos: {
    url: "getguiaveiculos",
    method: "GET",
    resource: "GETGUIAVEICULOS",
    type: "READ",
    params: ["id"],
  },
  getGuiaveiculosporrota: {
    url: "getguiaveiculosporrota",
    method: "GET",
    resource: "GETGUIAVEICULOSPORROTA",
    type: "READ",
    params: ["id"],
  },
  getGuiaviagensprevistas: {
    url: "getguiaviagensprevistas",
    method: "POST",
    resource: "GETGUIAVIAGENSPREVISTAS",
    type: "READ",
  },
  getHeaderstabela: {
    url: "getheaderstabela",
    method: "GET",
    resource: "GETHEADERSTABELA",
    type: "READ",
    params: ["cod"],
  },
  getHistoricoalteracoesrotas: {
    url: "gethistoricoalteracoesrotas",
    method: "GET",
    resource: "GETHISTORICOALTERACOESROTAS",
    type: "READ",
  },
  getHistoricoalteracoesrotasporgrupo: {
    url: "gethistoricoalteracoesrotasporgrupo",
    method: "GET",
    resource: "GETHISTORICOALTERACOESROTASPORGRUPO",
    type: "READ",
    query: ["id_grupo"],
  },
  getHistoricoenviosqrcode: {
    url: "gethistoricoenviosqrcode",
    method: "GET",
    resource: "GETHISTORICOENVIOSQRCODE",
    type: "READ",
    query: ["dti","dtf"],
  },
  getHistoricoequipamento: {
    url: "gethistoricoequipamento",
    method: "GET",
    resource: "GETHISTORICOEQUIPAMENTO",
    type: "READ",
    params: ["idEquipamento"],
  },
  getHistoricoequipamentomanutencao: {
    url: "gethistoricoequipamentomanutencao",
    method: "POST",
    resource: "GETHISTORICOEQUIPAMENTOMANUTENCAO",
    type: "READ",
  },
  getHistoricorotasotimizadaslinha: {
    url: "gethistoricorotasotimizadaslinha",
    method: "POST",
    resource: "GETHISTORICOROTASOTIMIZADASLINHA",
    type: "READ",
  },
  getHistoricorotasotimizadasunidade: {
    url: "gethistoricorotasotimizadasunidade",
    method: "POST",
    resource: "GETHISTORICOROTASOTIMIZADASUNIDADE",
    type: "READ",
  },
  getHistoricoroteirizacao: {
    url: "gethistoricoroteirizacao",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAO",
    type: "READ",
  },
  getHistoricoroteirizacaogrupo: {
    url: "gethistoricoroteirizacaogrupo",
    method: "POST",
    resource: "GETHISTORICOROTEIRIZACAOGRUPO",
    type: "READ",
  },
  getHistoricoroteirizacaopessoaseventos: {
    url: "gethistoricoroteirizacaopessoaseventos",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAOPESSOASEVENTOS",
    type: "READ",
    query: ["id_sessao"],
  },
  getHistoricoroteirizacaopessoaseventosdetalhes: {
    url: "gethistoricoroteirizacaopessoaseventosdetalhes",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAOPESSOASEVENTOSDETALHES",
    type: "READ",
    query: ["id_historico_roteirizacao","tipo_evento","sentido","id_linha_anterior","id_rota_anterior","id_linha_atual","id_rota_atual"],
  },
  getHistoricoroteirizacaoporid: {
    url: "gethistoricoroteirizacaoporid",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAOPORID",
    type: "READ",
    params: ["id"],
    query: ["compare"],
  },
  getHistoricoroteirizacaoporsessao: {
    url: "gethistoricoroteirizacaoporsessao",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAOPORSESSAO",
    type: "READ",
    query: ["id_sessao"],
  },
  getHistoricoroteirizacaosessoes: {
    url: "gethistoricoroteirizacaosessoes",
    method: "GET",
    resource: "GETHISTORICOROTEIRIZACAOSESSOES",
    type: "READ",
  },
  getHistoricoveiculoequipamento: {
    url: "gethistoricoveiculoequipamento",
    method: "POST",
    resource: "GETHISTORICOVEICULOEQUIPAMENTO",
    type: "READ",
  },
  getHodometrokmcarro: {
    url: "gethodometrokmcarro",
    method: "POST",
    resource: "GETHODOMETROKMCARRO",
    type: "READ",
  },
  getHodometrosviagemgrid: {
    url: "gethodometrosviagemgrid",
    method: "GET",
    resource: "GETHODOMETROSVIAGEMGRID",
    type: "READ",
    params: ["idviagemgrid"],
  },
  getHorariopordia: {
    url: "gethorariopordia",
    method: "POST",
    resource: "GETHORARIOPORDIA",
    type: "READ",
    params: ["date"],
  },
  getHorariosporlinha: {
    url: "gethorariosporlinha",
    method: "POST",
    resource: "GETHORARIOSPORLINHA",
    type: "READ",
  },
  getIdmodo: {
    url: "getidmodo",
    method: "GET",
    resource: "GETIDMODO",
    type: "READ",
  },
  getInconsistenciadadosfuncionarios: {
    url: "getinconsistenciadadosfuncionarios",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSFUNCIONARIOS",
    type: "READ",
  },
  getInconsistenciadadoslinhaspontos: {
    url: "getinconsistenciadadoslinhaspontos",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSLINHASPONTOS",
    type: "READ",
  },
  getInconsistenciadadoslinhasprogramacao: {
    url: "getinconsistenciadadoslinhasprogramacao",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSLINHASPROGRAMACAO",
    type: "READ",
  },
  getInconsistenciadadoslinhasrotacercas: {
    url: "getinconsistenciadadoslinhasrotacercas",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSLINHASROTASCERCAS",
    type: "READ",
  },
  getInconsistenciadadoslinhasunidades: {
    url: "getinconsistenciadadoslinhasunidades",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSLINHASUNIDADES",
    type: "READ",
  },
  getInconsistenciadadospassageiros: {
    url: "getinconsistenciadadospassageiros",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSPASSAGEIROS",
    type: "READ",
  },
  getInconsistenciadadospassageirosembarque: {
    url: "getinconsistenciadadospassageirosembarque",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSPASSAGEIROSEMBARQUE",
    type: "READ",
  },
  getInconsistenciadadosresumo: {
    url: "getinconsistenciadadosresumo",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSRESUMO",
    type: "READ",
  },
  getInconsistenciadadosveiculosequipamentos: {
    url: "getinconsistenciadadosveiculosequipamentos",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSVEICULOSEQUIPAMENTOS",
    type: "READ",
  },
  getInconsistenciadadosveiculosprogramacao: {
    url: "getinconsistenciadadosveiculosprogramacao",
    method: "POST",
    resource: "GETINCONSISTENCIADADOSVEICULOSPROGRAMACAO",
    type: "READ",
  },
  getJornadamotoristaativa: {
    url: "getjornadamotoristaativa",
    method: "GET",
    resource: "GETJORNADAMOTORISTAATIVA",
    type: "READ",
  },
  getKitbyid: {
    url: "getkitbyid",
    method: "GET",
    resource: "GETKITBYID",
    type: "READ",
    params: ["id"],
  },
  getKitslazy: {
    url: "getkitslazy",
    method: "POST",
    resource: "GETKITSLAZY",
    type: "READ",
  },
  getKpisenderecosexternos: {
    url: "getkpisenderecosexternos",
    method: "POST",
    resource: "GETKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  getLastcompanieslinescars: {
    url: "getlastcompanieslinescars",
    method: "GET",
    resource: "GETLASTCOMPANIESLINESCARS",
    type: "READ",
  },
  getLimitesportrecho: {
    url: "getlimitesportrecho",
    method: "GET",
    resource: "GETLIMITESPORTRECHO",
    type: "READ",
    params: ["id"],
  },
  getLines: {
    url: "getlines",
    method: "GET",
    resource: "GETLINES",
    type: "READ",
  },
  getLinhasassociadas: {
    url: "getlinhasassociadas",
    method: "POST",
    resource: "GETLINHASASSOCIADAS",
    type: "READ",
    params: ["id_unidade"],
  },
  getLinhasativas: {
    url: "getlinhasativas",
    method: "GET",
    resource: "GETLINHASATIVAS",
    type: "READ",
  },
  getLinhasbycerca: {
    url: "getlinhasbycerca",
    method: "GET",
    resource: "GETLINHASBYCERCA",
    type: "READ",
    params: ["idCerca"],
  },
  getLinhascomrotasecercas: {
    url: "getlinhascomrotasecercas",
    method: "POST",
    resource: "GETLINHASCOMROTASECERCAS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getLinhasconsultapassageiro: {
    url: "getlinhasconsultapassageiro",
    method: "POST",
    resource: "GETLINHASCONSULTAPASSAGEIRO",
    type: "READ",
  },
  getLinhasfechamentodia: {
    url: "getlinhasfechamentodia",
    method: "POST",
    resource: "GETLINHASFECHAMENTODIA",
    type: "READ",
  },
  getLinhashoje: {
    url: "getlinhashoje",
    method: "GET",
    resource: "GETLINHASHOJE",
    type: "READ",
  },
  getLinhaslazy: {
    url: "getlinhaslazy",
    method: "POST",
    resource: "GETLINHASLAZY",
    type: "READ",
  },
  getLinhasocupacaoturno: {
    url: "getlinhasocupacaoturno",
    method: "POST",
    resource: "GETLINHASOCUPACAOTURNO",
    type: "READ",
  },
  getLinhasoperacao: {
    url: "getlinhasoperacao",
    method: "GET",
    resource: "GETLINHASOPERACAO",
    type: "READ",
  },
  getLinhasporcodigo: {
    url: "getlinhasporcodigo",
    method: "GET",
    resource: "GETLINHASPORCODIGO",
    type: "READ",
    params: ["id"],
  },
  getLinhaspordia: {
    url: "getlinhaspordia",
    method: "GET",
    resource: "GETLINHASPORDIA",
    type: "READ",
    params: ["date"],
  },
  getLinhasporempresa: {
    url: "getlinhasporempresa",
    method: "GET",
    resource: "GETLINHASPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getLinhasporpontosiniciaisefinais: {
    url: "getlinhasporpontosiniciaisefinais",
    method: "POST",
    resource: "GETLINHAPORPONTOSINICIAISEFINAIS",
    type: "READ",
  },
  getLinhassemunidades: {
    url: "getlinhassemunidades",
    method: "GET",
    resource: "GETLINHASSEMUNIDADES",
    type: "READ",
  },
  getLocaisporcliente: {
    url: "getlocaisporcliente",
    method: "GET",
    resource: "GETLOCAISPORCLIENTE",
    type: "READ",
    params: ["id"],
  },
  getLocaisporempresa: {
    url: "getlocaisporempresa",
    method: "GET",
    resource: "GETLOCAISPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getLocale: {
    url: "getlocale",
    method: "GET",
    resource: "GETLOCALE",
    type: "READ",
  },
  getLocationsunidade: {
    url: "getlocationsunidade",
    method: "POST",
    resource: "GETLOCATIONSUNIDADE",
    type: "READ",
  },
  getLogoativa: {
    url: "getlogoativa",
    method: "GET",
    resource: "GETLOGOATIVA",
    type: "READ",
  },
  getMapakpisenderecosexternos: {
    url: "getmapakpisenderecosexternos",
    method: "POST",
    resource: "GETMAPAKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  getMediaembarquesporcerca: {
    url: "getmediaembarquesporcerca",
    method: "POST",
    resource: "GETMEDIAEMBARQUESPORCERCA",
    type: "READ",
  },
  getMediaspassageiroslinhasdatahora: {
    url: "getmediaspassageiroslinhasdatahora",
    method: "POST",
    resource: "GETMEDIASPASSAGEIROSLINHASDATAHORA",
    type: "READ",
  },
  getMediaspassageirosveiculosdatahora: {
    url: "getmediaspassageirosveiculosdatahora",
    method: "POST",
    resource: "GETMEDIASPASSAGEIROSVEICULOSDATAHORA",
    type: "READ",
  },
  getMensagensnaolidaspordestinatario: {
    url: "getmensagensnaolidaspordestinatario",
    method: "GET",
    resource: "GETMENSAGENSNAOLIDASPORDESTINATARIO",
    type: "READ",
    params: ["id"],
  },
  getMensagenspordatainclusao: {
    url: "getmensagenspordatainclusao",
    method: "GET",
    resource: "GETMENSAGENSPORDATAINCLUSAO",
    type: "READ",
    params: ["dti","dtf"],
  },
  getMensagenspordestinatariodata: {
    url: "getmensagenspordestinatariodata",
    method: "GET",
    resource: "GETMENSAGENSPORDESTINATARIODATA",
    type: "READ",
    params: ["id","dti","dtf"],
  },
  getMensagenspordestinatariolazy: {
    url: "getmensagenspordestinatariolazy",
    method: "GET",
    resource: "GETMENSAGENSPORDESTINATARIOLAZY",
    type: "READ",
    params: ["id","dt"],
  },
  getMensagensportelefone: {
    url: "getmensagensportelefone",
    method: "POST",
    resource: "GETMENSAGENSPORTELEFONE",
    type: "READ",
  },
  getMinhaspermissoes: {
    url: "getminhaspermissoes",
    method: "GET",
    resource: "GETMINHASPERMISSOES",
    type: "READ",
  },
  getModelobyfabricante: {
    url: "getmodelobyfabricante",
    method: "GET",
    resource: "GETMODELOBYFABRICANTE",
    type: "READ",
    params: ["id"],
  },
  getMotivoslazy: {
    url: "getmotivoslazy",
    method: "POST",
    resource: "GETMOTIVOSLAZY",
    type: "READ",
  },
  getNiveisacessopessoa: {
    url: "getniveisacessopessoa",
    method: "GET",
    resource: "GETNIVEISACESSOPESSOA",
    type: "READ",
    params: ["codpessoa"],
  },
  getNotafiscalbyid: {
    url: "getnotafiscalbyid",
    method: "GET",
    resource: "GETNOTAFISCALBYID",
    type: "READ",
    params: ["id"],
  },
  getNotasatualizacao: {
    url: "getnotasatualizacao",
    method: "GET",
    resource: "GETNOTASATUALIZACAO",
    type: "READ",
  },
  getNotasatualizacaonaovistas: {
    url: "getnotasatualizacaonaovistas",
    method: "GET",
    resource: "GETNOTASATUALIZACAONAOVISTAS",
    type: "READ",
  },
  getNotificacoesempresapordata: {
    url: "getnotificacoesempresapordata",
    method: "GET",
    resource: "GETNOTIFICACOESEMPRESAPORDATA",
    type: "READ",
    params: ["dti","dtf","idempresa"],
  },
  getNotificacoesempresatipopordata: {
    url: "getnotificacoesempresatipopordata",
    method: "GET",
    resource: "GETNOTIFICACOESEMPRESATIPOPORDATA",
    type: "READ",
    params: ["dti","dtf","idempresa","idtipo"],
  },
  getNotificacoesempresatipotratadapordata: {
    url: "getnotificacoesempresatipotratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESEMPRESATIPOTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idempresa","idtipo","tratada"],
  },
  getNotificacoesempresatratadapordata: {
    url: "getnotificacoesempresatratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESEMPRESATRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idempresa","tratada"],
  },
  getNotificacoeslinhapordata: {
    url: "getnotificacoeslinhapordata",
    method: "GET",
    resource: "GETNOTIFICACOESLINHAPORDATA",
    type: "READ",
    params: ["dti","dtf","idlinha"],
  },
  getNotificacoeslinhatipopordata: {
    url: "getnotificacoeslinhatipopordata",
    method: "GET",
    resource: "GETNOTIFICACOESLINHATIPOPORDATA",
    type: "READ",
    params: ["dti","dtf","idlinha","idtipo"],
  },
  getNotificacoeslinhatipotratadapordata: {
    url: "getnotificacoeslinhatipotratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESLINHATIPOTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idlinha","idtipo","tratada"],
  },
  getNotificacoeslinhatratadapordata: {
    url: "getnotificacoeslinhatratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESLINHATRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idlinha","tratada"],
  },
  getNotificacoespordata: {
    url: "getnotificacoespordata",
    method: "POST",
    resource: "GETNOTIFICACOESPORDATA",
    type: "READ",
  },
  getNotificacoestipopordata: {
    url: "getnotificacoestipopordata",
    method: "GET",
    resource: "GETNOTIFICACOESTIPOPORDATA",
    type: "READ",
    params: ["dti","dtf","idtipo"],
  },
  getNotificacoestipotratadapordata: {
    url: "getnotificacoestipotratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESTIPOTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idtipo","tratada"],
  },
  getNotificacoestratadapordata: {
    url: "getnotificacoestratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","tratada"],
  },
  getNotificacoesveiculopordata: {
    url: "getnotificacoesveiculopordata",
    method: "GET",
    resource: "GETNOTIFICACOESVEICULOSPORDATA",
    type: "READ",
    params: ["dti","dtf","idveiculo"],
  },
  getNotificacoesveiculotipopordata: {
    url: "getnotificacoesveiculotipopordata",
    method: "GET",
    resource: "GETNOTIFICACOESVEICULOTIPOPORDATA",
    type: "READ",
    params: ["dti","dtf","idveiculo","idtipo"],
  },
  getNotificacoesveiculotipotratadapordata: {
    url: "getnotificacoesveiculotipotratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESVEICULOTIPOTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idveiculo","idtipo","tratada"],
  },
  getNotificacoesveiculotratadapordata: {
    url: "getnotificacoesveiculotratadapordata",
    method: "GET",
    resource: "GETNOTIFICACOESVEICULOTRATADAPORDATA",
    type: "READ",
    params: ["dti","dtf","idveiculo","tratada"],
  },
  getObservacoesauditoriaviagem: {
    url: "getobservacoesauditoriaviagem",
    method: "GET",
    resource: "GETOBSERVACOESAUDITORIAVIAGEM",
    type: "READ",
    params: ["idviagem"],
  },
  getOrigempermissoesusuario: {
    url: "getorigempermissoesusuario",
    method: "GET",
    resource: "GETORIGEMPERMISSOESUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getOutrosequipamentosmanutencao: {
    url: "getoutrosequipamentosmanutencao",
    method: "GET",
    resource: "GETOUTROSEQUIPAMENTOSMANUTENCAO",
    type: "READ",
  },
  getParadasbylinha: {
    url: "getparadasbylinha",
    method: "GET",
    resource: "GETPARADASBYLINHA",
    type: "READ",
    params: ["id"],
  },
  getParadaslazy: {
    url: "getparadaslazy",
    method: "POST",
    resource: "GETPARADASLAZY",
    type: "READ",
  },
  getParadasporrota: {
    url: "getparadasporrota",
    method: "GET",
    resource: "GETPARADASPORROTA",
    type: "READ",
    params: ["id_rota"],
  },
  getParadasroteirizacao: {
    url: "getparadasroteirizacao",
    method: "GET",
    resource: "GETPARADASROTEIRIZACAO",
    type: "READ",
  },
  getPassageirosporfaixahoraria: {
    url: "getpassageirosporfaixahoraria",
    method: "POST",
    resource: "GETPASSAGEIROSPORFAIXAHORARIA",
    type: "READ",
  },
  getPassageirosviagenslinhas: {
    url: "getpassageirosviagenslinhas",
    method: "POST",
    resource: "GETPASSAGEIROSVIAGENSLINHAS",
    type: "READ",
  },
  getPassengersfinanceirobydate: {
    url: "getpassengersfinanceirobydate",
    method: "GET",
    resource: "GETPASSENGERSFINANCEIROBYDATE",
    type: "READ",
    params: ["dtinicio","dtfim"],
  },
  getPerfisporpermissao: {
    url: "getperfisporpermissao",
    method: "GET",
    resource: "GETPERFISPORPERMISSAO",
    type: "READ",
    params: ["id"],
  },
  getPermissionariosnaoutilizados: {
    url: "getpermissionariosnaoutilizados",
    method: "GET",
    resource: "GETPERMISSIONARIOSNAOUTILIZADOS",
    type: "READ",
  },
  getPermissoesgranulares: {
    url: "getpermissoesgranulares",
    method: "GET",
    resource: "GETPERMISSOESGRANULARES",
    type: "READ",
  },
  getPermissoespadrao: {
    url: "getpermissoespadrao",
    method: "GET",
    resource: "GETPERMISSOESPADRAO",
    type: "READ",
  },
  getPermissoesperfil: {
    url: "getpermissoesperfil",
    method: "GET",
    resource: "GETPERMISSOESPERFIL",
    type: "READ",
    params: ["id"],
  },
  getPermissoestelas: {
    url: "getpermissoestelas",
    method: "POST",
    resource: "GETPERMISSOESTELAS",
    type: "READ",
  },
  getPermissoesusuario: {
    url: "getpermissoesusuario",
    method: "GET",
    resource: "GETPERMISSOESUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getPessoaporchavesunicas: {
    url: "getpessoaporchavesunicas",
    method: "POST",
    resource: "GETPESSOAPORCHAVESUNICAS",
    type: "READ",
  },
  getPessoaporcpf: {
    url: "getpessoaporcpf",
    method: "POST",
    resource: "GETPESSOAPORCPF",
    type: "READ",
  },
  getPessoaportelefone: {
    url: "getpessoaportelefone",
    method: "POST",
    resource: "GETPESSOAPORTELEFONE",
    type: "READ",
  },
  getPessoaporusuario: {
    url: "getpessoaporusuario",
    method: "GET",
    resource: "GETPESSOAPORUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getPessoaslazy: {
    url: "getpessoaslazy",
    method: "POST",
    resource: "GETPESSOASLAZY",
    type: "READ",
  },
  getPessoasporgrupo: {
    url: "getpessoasporgrupo",
    method: "POST",
    resource: "GETPESSOASPORGRUPO",
    type: "READ",
  },
  getPessoasporlinha: {
    url: "getpessoasporlinha",
    method: "GET",
    resource: "GETPESSOASPORLINHA",
    type: "READ",
    params: ["idlinha"],
  },
  getPessoasroteirizacaolazy: {
    url: "getpessoasroteirizacaolazy",
    method: "POST",
    resource: "GETPESSOASROTEIRIZACAOLAZY",
    type: "READ",
  },
  getPontosinteresselazy: {
    url: "getpontosinteresselazy",
    method: "POST",
    resource: "GETPONTOSINTERESSELAZY",
    type: "READ",
  },
  getPontosporlinha: {
    url: "getpontosporlinha",
    method: "POST",
    resource: "GETPONTOSPORLINHA",
    type: "READ",
  },
  getPosicoesporcarro: {
    url: "getposicoesporcarro",
    method: "GET",
    resource: "GETPOSICOESPORCARRO",
    type: "READ",
    params: ["id"],
  },
  getPosicoesporcarrodata: {
    url: "getposicoesporcarrodata",
    method: "POST",
    resource: "GETPOSICOESPORCARRODATA",
    type: "READ",
  },
  getPosicoesporcarrodatamanutencao: {
    url: "getposicoesporcarrodatamanutencao",
    method: "POST",
    resource: "GETPOSICOESPORCARRODATAMANUTENCAO",
    type: "READ",
  },
  getPosicoespordata: {
    url: "getposicoespordata",
    method: "GET",
    resource: "GETPOSICOESPORDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getPosicoesporequipamentodata: {
    url: "getposicoesporequipamentodata",
    method: "POST",
    resource: "GETPOSICOESPOREQUIPAMENTODATA",
    type: "READ",
  },
  getPosicoesporlinhadata: {
    url: "getposicoesporlinhadata",
    method: "GET",
    resource: "GETPOSICOESPORLINHADATA",
    type: "READ",
    params: ["id","dti","dtf"],
  },
  getPosicoesporpermissionariodata: {
    url: "getposicoesporpermissionariodata",
    method: "GET",
    resource: "GETPOSICOESPORPERMISSIONARIODATA",
    type: "READ",
    params: ["id_permissionario","dtinicio","dtfim"],
  },
  getPosicoesrelatoriocarrodata: {
    url: "getposicoesrelatoriocarrodata",
    method: "POST",
    resource: "GETPOSICOESRELATORIOCARRODATA",
    type: "READ",
  },
  getPrecandidatosbyticket: {
    url: "getprecandidatosbyticket",
    method: "GET",
    resource: "GETPRECANDIDATOSBYTICKET",
    type: "READ",
    params: ["id_ticket"],
  },
  getPrecandidatoscsvticket: {
    url: "getprecandidatoscsvticket",
    method: "GET",
    resource: "GETPRECANDIDATOSCSVTICKET",
    type: "READ",
    params: ["id_ticket"],
  },
  getPrevistorealizadolinhasdata: {
    url: "getprevistorealizadolinhasdata",
    method: "POST",
    resource: "GETPREVISTOREALIZADOLINHASDATA",
    type: "READ",
  },
  getProximaversaohistoricoroteirizacao: {
    url: "getproximaversaohistoricoroteirizacao",
    method: "GET",
    resource: "GETPROXIMAVERSAOHISTORICOROTEIRIZACAO",
    type: "READ",
  },
  getPublicacoesmensagemporid: {
    url: "getpublicacoesmensagemporid",
    method: "GET",
    resource: "GETPUBLICACOESMENSAGEMPORID",
    type: "READ",
    params: ["id"],
  },
  getQuadroativolinha: {
    url: "getquadroativolinha",
    method: "GET",
    resource: "GETQUADROATIVOLINHA",
    type: "READ",
    params: ["id_linha","data"],
  },
  getQuadrosativoslinhasdata: {
    url: "getquadrosativoslinhasdata",
    method: "POST",
    resource: "GETQUADROSATIVOSLINHASDATA",
    type: "READ",
  },
  getQuadrosporlinha: {
    url: "getquadrosporlinha",
    method: "GET",
    resource: "GETQUADROSPORLINHA",
    type: "READ",
    params: ["id_linha"],
  },
  getRecursospermissao: {
    url: "getrecursospermissao",
    method: "GET",
    resource: "GETRECURSOSPERMISSAO",
    type: "READ",
    params: ["id"],
  },
  getRecursosusuario: {
    url: "getrecursosusuario",
    method: "GET",
    resource: "GETRECURSOSUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getReferentesunidade: {
    url: "getreferentesunidade",
    method: "POST",
    resource: "GETREFERENTESUNIDADE",
    type: "READ",
  },
  getRegistrosporusuarios: {
    url: "getregistrosporusuarios",
    method: "POST",
    resource: "GETREGISTROSPORUSUARIOS",
    type: "READ",
  },
  getRegistrosporusuariosdata: {
    url: "getregistrosporusuariosdata",
    method: "POST",
    resource: "GETREGISTROSPORUSUARIOSDATA",
    type: "READ",
  },
  getRegistrosporveiculos: {
    url: "getregistrosporveiculos",
    method: "POST",
    resource: "GETREGISTROSPORVEICULOS",
    type: "READ",
  },
  getRegistrosporveiculosdata: {
    url: "getregistrosporveiculosdata",
    method: "POST",
    resource: "GETREGISTROSPORVEICULOSDATA",
    type: "READ",
  },
  getRelatorioatrasoviagens: {
    url: "getrelatorioatrasoviagens",
    method: "POST",
    resource: "GETRELATORIOATRASOVIAGENS",
    type: "READ",
  },
  getRelatorioconciliacao: {
    url: "getrelatorioconciliacao",
    method: "POST",
    resource: "GETRELATORIOCONCILIACAO",
    type: "READ",
  },
  getRelatorioconciliacaoanalitico: {
    url: "getrelatorioconciliacaoanalitico",
    method: "POST",
    resource: "GETRELATORIOCONCILIACAOANALITICO",
    type: "READ",
  },
  getRelatorioconsumoapiexternas: {
    url: "getrelatorioconsumoapiexternas",
    method: "POST",
    resource: "GETRELATORIOCONSUMOAPIEXTERNAS",
    type: "READ",
  },
  getRelatorioembarquesporlinha: {
    url: "getrelatorioembarquesporlinha",
    method: "POST",
    resource: "GETRELATORIOEMBARQUESPORLINHA",
    type: "READ",
  },
  getRelatoriomotoristaveiculo: {
    url: "getrelatoriomotoristaveiculo",
    method: "POST",
    resource: "GETRELATORIOMOTORISTAVEICULO",
    type: "READ",
  },
  getRelatorioocupacaoporturno: {
    url: "getrelatorioocupacaoporturno",
    method: "POST",
    resource: "GETRELATORIOOCUPACAOPORTURNO",
    type: "READ",
  },
  getRelatoriooperacion: {
    url: "getrelatoriooperacion",
    method: "POST",
    resource: "GETRELATORIOOPERACION",
    type: "READ",
  },
  getRelatoriopontualidade: {
    url: "getrelatoriopontualidade",
    method: "POST",
    resource: "GETRELATORIOPONTUALIDADE",
    type: "READ",
  },
  getRelatoriovelocidade: {
    url: "getrelatoriovelocidade",
    method: "POST",
    resource: "GETRELATORIOVELOCIDADE",
    type: "READ",
  },
  getRelmanutencaotiposequipamentos: {
    url: "getrelmanutencaotiposequipamentos",
    method: "GET",
    resource: "GETRELMANUTENCAOTIPOSEQUIPAMENTOS",
    type: "READ",
  },
  getReservaativacandidato: {
    url: "getreservaativacandidato",
    method: "GET",
    resource: "GETRESERVAATIVACANDIDATO",
    type: "READ",
    params: ["id_pessoa"],
  },
  getReservacandidatobyid: {
    url: "getreservacandidatobyid",
    method: "GET",
    resource: "GETRESERVACANDIDATOBYID",
    type: "READ",
    params: ["id"],
  },
  getReservascandidatos: {
    url: "getreservascandidatos",
    method: "GET",
    resource: "GETRESERVASCANDIDATOS",
    type: "READ",
  },
  getRotaporcodigo: {
    url: "getrotaporcodigo",
    method: "POST",
    resource: "GETROTAPORCODIGO",
    type: "READ",
  },
  getRotaporid: {
    url: "getrotaporid",
    method: "GET",
    resource: "GETROTAPORID",
    type: "READ",
    params: ["id"],
  },
  getRotasbyempresa: {
    url: "getrotasbyempresa",
    method: "GET",
    resource: "GETROTASBYEMPRESA",
    type: "READ",
    params: ["id"],
  },
  getRotascaminhada: {
    url: "getrotascaminhada",
    method: "POST",
    resource: "GETROTASCAMINHADA",
    type: "READ",
  },
  getRotasescalaporlinha: {
    url: "getrotasescalaporlinha",
    method: "GET",
    resource: "GETROTASESCALAPORLINHA",
    type: "READ",
    params: ["id"],
  },
  getRotaslazy: {
    url: "getrotaslazy",
    method: "POST",
    resource: "GETROTASLAZY",
    type: "READ",
  },
  getRotaspadraoporlinha: {
    url: "getrotaspadraoporlinha",
    method: "POST",
    resource: "GETROTASPADRAOPORLINHA",
    type: "READ",
  },
  getRotasporcliente: {
    url: "getrotasporcliente",
    method: "GET",
    resource: "GETROTASPORCLIENTE",
    type: "READ",
    params: ["id"],
  },
  getRotasporgrupo: {
    url: "getrotasporgrupo",
    method: "POST",
    resource: "GETROTASPORGRUPO",
    type: "READ",
  },
  getRotasporlinha: {
    url: "getrotasporlinha",
    method: "POST",
    resource: "GETROTASPORLINHA",
    type: "READ",
  },
  getRotasporlinhacomvigencia: {
    url: "getrotasporlinhacomvigencia",
    method: "POST",
    resource: "GETROTASPORLINHACOMVIGENCIA",
    type: "READ",
  },
  getRotasvigenciaporlinha: {
    url: "getrotasvigenciaporlinha",
    method: "POST",
    resource: "GETROTASVIGENCIAPORLINHA",
    type: "READ",
  },
  getRotavigenciaporid: {
    url: "getrotavigenciaporid",
    method: "GET",
    resource: "GETROTAVIGENCIAPORID",
    type: "READ",
    params: ["id"],
  },
  getServicos: {
    url: "getservicos",
    method: "GET",
    resource: "GETSERVICOS",
    type: "READ",
    query: ["id_tipo_atendimento","descricao_tipo_atendimento"],
  },
  getShapefromfile: {
    url: "getshapefromfile",
    method: "GET",
    resource: "GETSHAPEFROMFILE",
    type: "READ",
    params: ["file"],
  },
  getSituacaoativapessoaporid: {
    url: "getsituacaoativapessoaporid",
    method: "GET",
    resource: "GETSITUACAOATIVAPESSOAPORID",
    type: "READ",
    params: ["id"],
  },
  getSituacaoenvioqrcode: {
    url: "getsituacaoenvioqrcode",
    method: "GET",
    resource: "GETSITUACAOENVIOQRCODE",
    type: "READ",
    query: ["dti","dtf"],
  },
  getSituacaovalidacaoativapessoaporid: {
    url: "getsituacaovalidacaoativapessoaporid",
    method: "GET",
    resource: "GETSITUACAOVALIDACAOATIVAPESSOAPORID",
    type: "READ",
    params: ["id"],
  },
  getSituacoesativaspessoas: {
    url: "getsituacoesativaspessoas",
    method: "GET",
    resource: "GETSITUACOESATIVASPESSOAS",
    type: "READ",
  },
  getSituacoesvalidacaoativaspessoas: {
    url: "getsituacoesvalidacaoativaspessoas",
    method: "GET",
    resource: "GETSITUACOESVALIDACAOATIVASPESSOAS",
    type: "READ",
  },
  getStatusallveiculospordata: {
    url: "getstatusallveiculospordata",
    method: "GET",
    resource: "GETSTATUSALLVEICULOSPORDATA",
    type: "READ",
    params: ["dt"],
  },
  getStatuscomunicacaoequipamentosporveiculo: {
    url: "getstatuscomunicacaoequipamentosporveiculo",
    method: "GET",
    resource: "GETSTATUSCOMUNICACAOEQUIPAMENTOSPORVEICULO",
    type: "READ",
    query: ["id_veiculo"],
  },
  getStatusguias: {
    url: "getstatusguias",
    method: "GET",
    resource: "GETSTATUSGUIAS",
    type: "READ",
  },
  getStatusqrcode: {
    url: "getstatusqrcode",
    method: "GET",
    resource: "GETSTATUSQRCODE",
    type: "READ",
  },
  getStatusqrcodelazy: {
    url: "getstatusqrcodelazy",
    method: "POST",
    resource: "GETSTATUSQRCODELAZY",
    type: "READ",
  },
  getStatusveiculo: {
    url: "getstatusveiculo",
    method: "GET",
    resource: "GETSTATUSVEICULO",
    type: "READ",
    params: ["id"],
  },
  getSubgrupos: {
    url: "getsubgrupos",
    method: "GET",
    resource: "GETSUBGRUPOS",
    type: "READ",
    params: ["id"],
  },
  getSublinhasporlinha: {
    url: "getsublinhasporlinha",
    method: "GET",
    resource: "GETSUBLINHASPORLINHA",
    type: "READ",
    params: ["idlinha"],
  },
  getSubsidioviagensdataprefeitura: {
    url: "getsubsidioviagensdataprefeitura",
    method: "GET",
    resource: "GETSUBSIDIOVIAGENSDATAPREFEITURA",
    type: "READ",
  },
  getTelemetriadata: {
    url: "gettelemetriadata",
    method: "GET",
    resource: "GETTELEMETRIADATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getTemplateporcodigo: {
    url: "gettemplateporcodigo",
    method: "GET",
    resource: "GETTEMPLATEPORCODIGO",
    type: "READ",
    params: ["codigo"],
  },
  getTemplatetiponotificacaoporid: {
    url: "gettemplatetiponotificacaoporid",
    method: "GET",
    resource: "GETTEMPLATETIPONOTIFICACAOPORID",
    type: "READ",
    params: ["id"],
  },
  getTempoonibus: {
    url: "gettempoonibus",
    method: "POST",
    resource: "GETTEMPOONIBUS",
    type: "READ",
  },
  getTempoplacatotalservico: {
    url: "gettempoplacatotalservico",
    method: "GET",
    resource: "GETTEMPOPLACATOTALSERVICO",
    type: "READ",
    params: ["dti","dtf"],
  },
  getTempoplacatotalservicopormatricula: {
    url: "gettempoplacatotalservicopormatricula",
    method: "POST",
    resource: "GETTEMPOPLACATOTALSERVICOPORMATRICULA",
    type: "READ",
  },
  getTempotrecho: {
    url: "gettempotrecho",
    method: "POST",
    resource: "GETTEMPOTRECHO",
    type: "READ",
  },
  getTicketByIdUsuarioInclusao: {
    url: "getTicketByIdUsuarioInclusao",
    method: "GET",
    resource: "GETTICKETBYIDUSUARIOINCLUSAO",
    type: "READ",
    params: ["id"],
  },
  getTicketCamposCriacao: {
    url: "getTicketCamposCriacao",
    method: "GET",
    resource: "GETTICKETCAMPOSCRIACAO",
    type: "READ",
  },
  getTicketCamposDetalhe: {
    url: "getTicketCamposDetalhe",
    method: "GET",
    resource: "GETTICKETCAMPOSDETALHE",
    type: "READ",
  },
  getTicketanexos: {
    url: "getticketanexos",
    method: "GET",
    resource: "GETTICKETANEXOS",
    type: "READ",
    params: ["id_ticket"],
  },
  getTicketbyid: {
    url: "getticketbyid",
    method: "GET",
    resource: "GETTICKETBYID",
    type: "READ",
    params: ["id"],
  },
  getTicketbyidusuario: {
    url: "getticketbyidusuario",
    method: "GET",
    resource: "GETTICKETBYIDUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getTicketcomentariosnovos: {
    url: "getticketcomentariosnovos",
    method: "GET",
    resource: "GETTICKETCOMENTARIOSNOVOS",
    type: "READ",
  },
  getTicketequipamentos: {
    url: "getticketequipamentos",
    method: "GET",
    resource: "GETTICKETEQUIPAMENTOS",
    type: "READ",
    params: ["id"],
  },
  getTicketequipes: {
    url: "getticketequipes",
    method: "GET",
    resource: "GETTICKETEQUIPES",
    type: "READ",
    params: ["id"],
  },
  getTickethistory: {
    url: "gettickethistory",
    method: "GET",
    resource: "GETTICKETHISTORY",
    type: "READ",
    params: ["id_ticket"],
  },
  getTicketperfis: {
    url: "getticketperfis",
    method: "GET",
    resource: "GETTICKETPERFIS",
    type: "READ",
    params: ["id"],
  },
  getTicketsabertosbyusuario: {
    url: "getticketsabertosbyusuario",
    method: "GET",
    resource: "GETTICKETSABERTOBYUSUARIO",
    type: "READ",
    params: ["id"],
  },
  getTicketsbyempresa: {
    url: "getticketsbyempresa",
    method: "GET",
    resource: "GETTICKETSBYEMPRESA",
    type: "READ",
    params: ["id"],
  },
  getTicketsbyequipesusuario: {
    url: "getticketsbyequipesusuario",
    method: "GET",
    resource: "GETTICKETSBYEQUIPESUSUARIO",
    type: "READ",
    params: ["id_usuario"],
  },
  getTicketsbyperfilusuario: {
    url: "getticketsbyperfilusuario",
    method: "GET",
    resource: "GETTICKETSBYPERFILUSUARIO",
    type: "READ",
    params: ["id_perfil_usuario"],
  },
  getTicketsbyusuarioatribuido: {
    url: "getticketsbyusuarioatribuido",
    method: "GET",
    resource: "GETTICKETSBYUSUARIOATRIBUIDO",
    type: "READ",
    params: ["id"],
  },
  getTicketsbyviewerusuario: {
    url: "getticketsbyviewerusuario",
    method: "GET",
    resource: "GETTICKETSBYVIEWERUSUARIO",
    type: "READ",
    params: ["id_usuario"],
  },
  getTicketslazy: {
    url: "getticketslazy",
    method: "POST",
    resource: "GETTICKETSLAZY",
    type: "READ",
  },
  encaminharticket: {
    url: "encaminharticket",
    method: "POST",
    resource: "ENCAMINHARTICKET",
    type: "WRITE",
  },
  getEncaminhamentosticket: {
    url: "getencaminhamentosticket",
    method: "GET",
    resource: "GETENCAMINHAMENTOSTICKET",
    type: "READ",
    params: ["id"],
  },
  getRelticketssuporte: {
    url: "getrelticketssuporte",
    method: "POST",
    resource: "GETRELTICKETSSUPORTE",
    type: "READ",
  },
  updateEmailsequipes: {
    url: "updateemailsequipes",
    method: "POST",
    resource: "UPDATEEMAILSEQUIPES",
    type: "WRITE",
  },
  validaRticketsuporte: {
    url: "validarticketsuporte",
    method: "POST",
    resource: "VALIDARTICKETSUPORTE",
    type: "WRITE",
  },
  getTicketsporstatus: {
    url: "getticketsporstatus",
    method: "POST",
    resource: "GETTICKETSPORSTATUS",
    type: "READ",
  },
  getTicketsporveiculo: {
    url: "getticketsporveiculo",
    method: "GET",
    resource: "GETTICKETSPORVEICULO",
    type: "READ",
    params: ["id_veiculo"],
  },
  getTicketsquadro: {
    url: "getticketsquadro",
    method: "POST",
    resource: "GETTICKETSQUADRO",
    type: "READ",
  },
  getTicketsuportesistemaanexos: {
    url: "getticketsuportesistemaanexos",
    method: "GET",
    resource: "GETTICKETSUPORTESISTEMAANEXOS",
    type: "READ",
    params: ["id_ticket"],
  },
  getTickettasks: {
    url: "gettickettasks",
    method: "GET",
    resource: "GETTICKETTASKS",
    type: "READ",
    params: ["id_ticket"],
  },
  getTicketveiculos: {
    url: "getticketveiculos",
    method: "GET",
    resource: "GETTICKETVEICULOS",
    type: "READ",
    params: ["id"],
  },
  getTipokitbyid: {
    url: "gettipokitbyid",
    method: "GET",
    resource: "GETTIPOKITBYID",
    type: "READ",
    params: ["id"],
  },
  getTiposatendimento: {
    url: "gettiposatendimento",
    method: "GET",
    resource: "GETTIPOSATENDIMENTO",
    type: "READ",
    query: ["id_familia_atendimento","id_tipo_ticket"],
  },
  getTiposcerca: {
    url: "gettiposcerca",
    method: "GET",
    resource: "GETTIPOSCERCA",
    type: "READ",
  },
  getTiposdocumentospessoas: {
    url: "gettiposdocumentospessoas",
    method: "GET",
    resource: "GETTIPOSDOCUMENTOSPESSOAS",
    type: "READ",
  },
  getTiposdocumentosveiculos: {
    url: "gettiposdocumentosveiculos",
    method: "GET",
    resource: "GETTIPOSDOCUMENTOSVEICULOS",
    type: "READ",
  },
  getTipospermissoes: {
    url: "gettipospermissoes",
    method: "GET",
    resource: "GETTIPOSPERMISSOES",
    type: "READ",
  },
  getTiposrota: {
    url: "gettiposrota",
    method: "GET",
    resource: "GETTIPOSROTA",
    type: "READ",
  },
  getTiposrotaporlinha: {
    url: "gettiposrotaporlinha",
    method: "POST",
    resource: "GETTIPOSROTAPORLINHA",
    type: "READ",
  },
  getTipossolicitacao: {
    url: "gettipossolicitacao",
    method: "GET",
    resource: "GETTIPOSSOLICITACAO",
    type: "READ",
    query: ["id_tipo_ticket"],
  },
  getTotaispassengersporperiodo: {
    url: "gettotaispassengersporperiodo",
    method: "GET",
    resource: "GETTOTAISPASSENGERSPORPERIODO",
    type: "READ",
    params: ["dtinicio","dtfim"],
  },
  getTotaisporempresaporlinhaporcarroporperiodo: {
    url: "gettotaisporempresaporlinhaporcarroporperiodo",
    method: "GET",
    resource: "GETTOTAISPOREMPRESAPORLINHAPORCARROPORPERIODO",
    type: "READ",
    params: ["dtinicio","dtfim"],
  },
  getTotaisporhoraporperiodo: {
    url: "gettotaisporhoraporperiodo",
    method: "GET",
    resource: "GETTOTAISPORHORAPORPERIODO",
    type: "READ",
    params: ["dtinicio","dtfim"],
  },
  getTotalnotificacoesnotreseted: {
    url: "gettotalnotificacoesnotreseted",
    method: "POST",
    resource: "GETTOTALNOTIFICACOESNOTRESETED",
    type: "READ",
    params: ["dti","dtf"],
  },
  getTotalpessoas: {
    url: "gettotalpessoas",
    method: "GET",
    resource: "GETTOTALPESSOAS",
    type: "READ",
  },
  getTrechoporid: {
    url: "gettrechoporid",
    method: "GET",
    resource: "GETTRECHOPORID",
    type: "READ",
    params: ["id"],
  },
  getTrechosporlinha: {
    url: "gettrechosporlinha",
    method: "GET",
    resource: "GETTRECHOSPORLINHA",
    type: "READ",
    params: ["id"],
  },
  getTurnosfuncionariosporcerca: {
    url: "getturnosfuncionariosporcerca",
    method: "GET",
    resource: "GETTURNOSFUNCIONARIOSPORCERCA",
    type: "READ",
    params: ["id_cerca"],
  },
  getTurnoslazy: {
    url: "getturnoslazy",
    method: "POST",
    resource: "GETTURNOSLAZY",
    type: "READ",
  },
  getTurnospassageiroporlinha: {
    url: "getturnospassageiroporlinha",
    method: "GET",
    resource: "GETTURNOSPASSAGEIROPORLINHA",
    type: "READ",
    params: ["idlinha"],
  },
  getTurnospassageiroslazy: {
    url: "getturnospassageiroslazy",
    method: "POST",
    resource: "GETTURNOSPASSAGEIROSLAZY",
    type: "READ",
  },
  getTurnosporcerca: {
    url: "getturnosporcerca",
    method: "GET",
    resource: "GETTURNOSPORCERCA",
    type: "READ",
    params: ["id_cerca"],
  },
  getUltimasposicoesporlinha: {
    url: "getultimasposicoesporlinha",
    method: "GET",
    resource: "GETULTIMASPOSICOESPORLINHA",
    type: "READ",
    params: ["id"],
  },
  getUltimohistoricoroteirizacao: {
    url: "getultimohistoricoroteirizacao",
    method: "GET",
    resource: "GETULTIMOHISTORICOROTEIRIZACAO",
    type: "READ",
  },
  getUltimosenderecosvalidados: {
    url: "getultimosenderecosvalidados",
    method: "GET",
    resource: "GETULTIMOSENDERECOSVALIDADOS",
    type: "READ",
  },
  getUnidadesareas: {
    url: "getunidadesareas",
    method: "POST",
    resource: "GETUNIDADESAREAS",
    type: "READ",
  },
  getUnidadeslazy: {
    url: "getunidadeslazy",
    method: "POST",
    resource: "GETUNIDADESLAZY",
    type: "READ",
  },
  getUnidadessugeridasarea: {
    url: "getunidadessugeridasarea",
    method: "POST",
    resource: "GETUNIDADESSUGERIDASAREA",
    type: "READ",
  },
  getUrlbydashboardid: {
    url: "geturlbydashboardid",
    method: "GET",
    resource: "GETURLBYDASHBOARDID",
    type: "READ",
    params: ["id"],
  },
  getUsuarioslazy: {
    url: "getusuarioslazy",
    method: "POST",
    resource: "GETUSUARIOSLAZY",
    type: "READ",
  },
  getUsuariosparamensagens: {
    url: "getusuariosparamensagens",
    method: "POST",
    resource: "GETUSUARIOSPARAMENSAGENS",
    type: "READ",
  },
  getUsuariospessoas: {
    url: "getusuariospessoas",
    method: "POST",
    resource: "GETUSUARIOSSPESSOAS",
    type: "READ",
  },
  getUsuariosporequipe: {
    url: "getusuariosporequipe",
    method: "GET",
    resource: "GETUSUARIOSPOREQUIPE",
    type: "READ",
    params: ["id"],
  },
  getUsuariosporids: {
    url: "getusuariosporids",
    method: "POST",
    resource: "GETUSUARIOSPORIDS",
    type: "READ",
  },
  getValidacaocandidatobycod: {
    url: "getvalidacaocandidatobycod",
    method: "POST",
    resource: "GETVALIDACAOCANDIDATOBYCOD",
    type: "READ",
  },
  getVariantesporlinha: {
    url: "getvariantesporlinha",
    method: "GET",
    resource: "GETVARIANTESPORLINHA",
    type: "READ",
    params: ["idlinha"],
  },
  getVehicles: {
    url: "getvehicles",
    method: "GET",
    resource: "GETVEHICLES",
    type: "READ",
  },
  getVeiculonaoassociado: {
    url: "getveiculonaoassociado",
    method: "GET",
    resource: "GETVEICULONAOASSOCIADO",
    type: "READ",
    params: ["id"],
  },
  getVeiculoporempresa: {
    url: "getveiculoporempresa",
    method: "GET",
    resource: "GETVEICULOPOREMPRESA",
    type: "READ",
    params: ["id"],
  },
  getVeiculorastreamentobyordem: {
    url: "getveiculorastreamentobyordem",
    method: "GET",
    resource: "GETVEICULOSRASTREAMENTOBYORDEM",
    type: "READ",
    params: ["id"],
  },
  getVeiculosareamapa: {
    url: "getveiculosareamapa",
    method: "POST",
    resource: "GETVEICULOSAREAMAPA",
    type: "READ",
  },
  getVeiculosareamapatemporeal: {
    url: "getveiculosareamapatemporeal",
    method: "GET",
    resource: "GETVEICULOSAREAMAPATEMPOREAL",
    type: "READ",
  },
  getVeiculoscercas: {
    url: "getveiculoscercas",
    method: "POST",
    resource: "GETVEICULOSCERCAS",
    type: "READ",
  },
  getVeiculoscercastemporeal: {
    url: "getveiculoscercastemporeal",
    method: "POST",
    resource: "GETVEICULOSCERCASTEMPOREAL",
    type: "READ",
  },
  getVeiculoscomboioid: {
    url: "getveiculoscomboioid",
    method: "GET",
    resource: "GETVEICULOSCOMBOIOID",
    type: "READ",
    params: ["idcomboio"],
  },
  getVeiculoscomboiolinhadata: {
    url: "getveiculoscomboiolinhadata",
    method: "GET",
    resource: "GETVEICULOSCOMBOIOLINHADATA",
    type: "READ",
    params: ["idlinha","dti","dtf"],
  },
  getVeiculosconsultapassageiro: {
    url: "getveiculosconsultapassageiro",
    method: "POST",
    resource: "GETVEICULOSCONSULTAPASSAGEIRO",
    type: "READ",
  },
  getVeiculosdashboardtelemetria: {
    url: "getveiculosdashboardtelemetria",
    method: "GET",
    resource: "GETVEICULOSDASHBOARDTELEMETRIA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getVeiculosemviagem: {
    url: "getveiculosemviagem",
    method: "GET",
    resource: "GETVEICULOSEMVIAGEM",
    type: "READ",
  },
  getVeiculosenderecotemporeal: {
    url: "getveiculosenderecotemporeal",
    method: "POST",
    resource: "GETVEICULOSENDERECOTEMPOREAL",
    type: "READ",
  },
  getVeiculosgaragem: {
    url: "getveiculosgaragem",
    method: "GET",
    resource: "GETVEICULOSGARAGEM",
    type: "READ",
  },
  getVeiculoslazy: {
    url: "getveiculoslazy",
    method: "POST",
    resource: "GETVEICULOSLAZY",
    type: "READ",
  },
  getVeiculospainel: {
    url: "getveiculospainel",
    method: "POST",
    resource: "GETVEICULOSPAINEL",
    type: "READ",
  },
  getVeiculosporlinhaoperacao: {
    url: "getveiculosporlinhaoperacao",
    method: "GET",
    resource: "GETVEICULOSPORLINHAOPERACAO",
    type: "READ",
    params: ["id"],
  },
  getVeiculosporpermissionario: {
    url: "getveiculosporpermissionario",
    method: "GET",
    resource: "GETVEICULOSPORPERMISSIONARIO",
    type: "READ",
    params: ["id"],
  },
  getVeiculosrelatoriokm: {
    url: "getveiculosrelatoriokm",
    method: "POST",
    resource: "GETVEICULOSRELATORIOKM",
    type: "READ",
  },
  getVeiculosrelatoriokmtemporeal: {
    url: "getveiculosrelatoriokmtemporeal",
    method: "POST",
    resource: "GETVEICULOSRELATORIOKMTEMPOREAL",
    type: "READ",
  },
  getVeiculossubsidio: {
    url: "getveiculossubsidio",
    method: "GET",
    resource: "GETVEICULOSSUBSIDIO",
    type: "READ",
  },
  getVeiculosultimaposicaoequipamento: {
    url: "getveiculosultimaposicaoequipamento",
    method: "GET",
    resource: "GETVEICULOSULTIMAPOSICAOEQUIPAMENTO",
    type: "READ",
  },
  getVeiculosvideowall: {
    url: "getveiculosvideowall",
    method: "GET",
    resource: "GETVEICULOSVIDEOWALL",
    type: "READ",
  },
  getViagemgridcercas: {
    url: "getviagemgridcercas",
    method: "GET",
    resource: "GETVIAGEMGRIDCERCAS",
    type: "READ",
    params: ["idviagemgrid"],
  },
  getViagenscercainiciofim: {
    url: "getviagenscercainiciofim",
    method: "POST",
    resource: "GETVIAGENSCERCAINICIOFIM",
    type: "READ",
  },
  getViagenscontroladoresdatacerca: {
    url: "getviagenscontroladoresdatacerca",
    method: "POST",
    resource: "GETVIAGENSCONTROLADORESDATACERCA",
    type: "READ",
  },
  getViagenscontroladoresdatausuario: {
    url: "getviagenscontroladoresdatausuario",
    method: "GET",
    resource: "GETVIAGENSCONTROLADORESDATAUSUARIO",
    type: "READ",
    params: ["dti","dtf","idusuario"],
  },
  getViagenscontroladoresusuario: {
    url: "getviagenscontroladoresusuario",
    method: "GET",
    resource: "GETVIAGENSCONTROLADORESUSUARIO",
    type: "READ",
    params: ["idusuario"],
  },
  getViagenscumprimentoderota: {
    url: "getviagenscumprimentoderota",
    method: "POST",
    resource: "GETVIAGENSCUMPRIMENTODEROTA",
    type: "READ",
  },
  getViagenscumprimentoderotaagregado: {
    url: "getviagenscumprimentoderotaagregado",
    method: "POST",
    resource: "GETVIAGENSCUMPRIMENTODEROTAAGREGADO",
    type: "READ",
  },
  getViagensdashboard: {
    url: "getviagensdashboard",
    method: "GET",
    resource: "GETVIAGENSDASHBOARD",
    type: "READ",
  },
  getViagensfechamentodia: {
    url: "getviagensfechamentodia",
    method: "POST",
    resource: "GETVIAGENSFECHAMENTODIA",
    type: "READ",
  },
  getViagensgridveiculodata: {
    url: "getviagensgridveiculodata",
    method: "POST",
    resource: "GETVIAGENSGRIDVEICULODATA",
    type: "READ",
  },
  getViagensmerusconciliacao: {
    url: "getviagensmerusconciliacao",
    method: "POST",
    resource: "GETVIAGENSMERUSCONCILIACAO",
    type: "READ",
  },
  getViagensnaoassociadas: {
    url: "getviagensnaoassociadas",
    method: "GET",
    resource: "GETVIAGENSNAOASSOCIADAS",
    type: "READ",
    params: ["config"],
  },
  getViagensnewssystem: {
    url: "getviagensnewssystem",
    method: "POST",
    resource: "GETVIAGENSNEWSSYSTEM",
    type: "READ",
  },
  getViagensoperadoraconcialicao: {
    url: "getviagensoperadoraconcialicao",
    method: "POST",
    resource: "GETVIAGENSOPERADORACONCIALICAO",
    type: "READ",
  },
  getViagensporescalabulk: {
    url: "getviagensporescalabulk",
    method: "POST",
    resource: "GETVIAGENSPORESCALABULK",
    type: "READ",
  },
  getViagensporquadrobulk: {
    url: "getviagensporquadrobulk",
    method: "POST",
    resource: "GETVIAGENSPORQUADROBULK",
    type: "READ",
  },
  getViagensprevistaslinha: {
    url: "getviagensprevistaslinha",
    method: "POST",
    resource: "GETVIAGENSPREVISTASLINHA",
    type: "READ",
  },
  getViagensprevistaslinhasdata: {
    url: "getviagensprevistaslinhasdata",
    method: "POST",
    resource: "GETVIAGENSPREVISTASLINHASDATA",
    type: "READ",
  },
  getViagensrealizadasdata: {
    url: "getviagensrealizadasdata",
    method: "GET",
    resource: "GETVIAGENSREALIZADASDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getViagensrealizadaslinha: {
    url: "getviagensrealizadaslinha",
    method: "GET",
    resource: "GETVIAGENSREALIZADASLINHA",
    type: "READ",
    params: ["id"],
  },
  getViagensrealizadaslinhadata: {
    url: "getviagensrealizadaslinhadata",
    method: "POST",
    resource: "GETVIAGENSREALIZADASLINHADATA",
    type: "READ",
  },
  getViagensrealizadasveiculo: {
    url: "getviagensrealizadasveiculo",
    method: "GET",
    resource: "GETVIAGENSREALIZADASVEICULO",
    type: "READ",
    params: ["id"],
  },
  getViagensrealizadasveiculodata: {
    url: "getviagensrealizadasveiculodata",
    method: "POST",
    resource: "GETVIAGENSREALIZADASVEICULODATA",
    type: "READ",
  },
  getallAgenciasemprego: {
    url: "getallagenciasemprego",
    method: "GET",
    resource: "GETALLAGENCIASEMPREGO",
    type: "READ",
  },
  getallAreas: {
    url: "getallareas",
    method: "GET",
    resource: "GETALLAREAS",
    type: "READ",
  },
  getallAreasapoio: {
    url: "getallareasapoio",
    method: "GET",
    resource: "GETALLAREASAPOIO",
    type: "READ",
  },
  getallAreasmapa: {
    url: "getallareasmapa",
    method: "GET",
    resource: "GETALLAREASMAPA",
    type: "READ",
    query: ["zona_risco","incluir_unidades"],
  },
  getallAvisosbanners: {
    url: "getallavisosbanners",
    method: "GET",
    resource: "GETALLAVISOSBANNERS",
    type: "READ",
  },
  getallBanners: {
    url: "getallbanners",
    method: "GET",
    resource: "GETALLBANNERS",
    type: "READ",
  },
  getallCanaiscomunicacao: {
    url: "getallcanaiscomunicacao",
    method: "GET",
    resource: "GETALLCANAISCOMUNICACAO",
    type: "READ",
  },
  getallCandidatos: {
    url: "getallcandidatos",
    method: "POST",
    resource: "GETALLCANDIDATOS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallCategorias: {
    url: "getallcategorias",
    method: "GET",
    resource: "GETALLCATEGORIAS",
    type: "READ",
  },
  getallCategoriasavisos: {
    url: "getallcategoriasavisos",
    method: "GET",
    resource: "GETALLCATEGORIASAVISOS",
    type: "READ",
  },
  getallCategoriastarifas: {
    url: "getallcategoriastarifas",
    method: "GET",
    resource: "GETALLCATEGORIASTARIFAS",
    type: "READ",
  },
  getallCercas: {
    url: "getallcercas",
    method: "POST",
    resource: "GETALLCERCAS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallCercasativas: {
    url: "getallcercasativas",
    method: "GET",
    resource: "GETALLCERCASATIVAS",
    type: "READ",
  },
  getallCercasativascomtipo: {
    url: "getallcercasativascomtipo",
    method: "GET",
    resource: "GETALLCERCASATIVASCOMTIPO",
    type: "READ",
  },
  getallCercasroteirizacao: {
    url: "getallcercasroteirizacao",
    method: "GET",
    resource: "GETALLCERCASROTEIRIZACAO",
    type: "READ",
  },
  getallCercasvigencia: {
    url: "getallcercasvigencia",
    method: "GET",
    resource: "GETALLCERCASVIGENCIA",
    type: "READ",
  },
  getallChecklistsativos: {
    url: "getallchecklistsativos",
    method: "GET",
    resource: "GETALLCHECKLISTSATIVOS",
    type: "READ",
  },
  getallCidades: {
    url: "getallcidades",
    method: "GET",
    resource: "GETALLCIDADES",
    type: "READ",
  },
  getallClassificacoes: {
    url: "getallclassificacoes",
    method: "GET",
    resource: "GETALLCLASSIFICACOES",
    type: "READ",
  },
  getallClientes: {
    url: "getallclientes",
    method: "GET",
    resource: "GETALLCLIENTES",
    type: "READ",
  },
  getallComboios: {
    url: "getallcomboios",
    method: "GET",
    resource: "GETALLCOMBOIOS",
    type: "READ",
  },
  getallComboiosativos: {
    url: "getallcomboiosativos",
    method: "GET",
    resource: "GETALLCOMBOIOSATIVOS",
    type: "READ",
  },
  getallConfig: {
    url: "getallconfig",
    method: "GET",
    resource: "GETALLCONFIG",
    type: "READ",
  },
  getallDashboards: {
    url: "getalldashboards",
    method: "GET",
    resource: "GETALLDASHBOARDS",
    type: "READ",
  },
  getallDashboardsativos: {
    url: "getalldashboardsativos",
    method: "GET",
    resource: "GETALLDASHBOARDSATIVOS",
    type: "READ",
  },
  getallDashboardspermitidos: {
    url: "getalldashboardspermitidos",
    method: "GET",
    resource: "GETALLDASHBOARDSPERMITIDOS",
    type: "READ",
    params: ["id"],
  },
  getallDocumentospessoas: {
    url: "getalldocumentospessoas",
    method: "GET",
    resource: "GETALLDOCUMENTOSPESSOAS",
    type: "READ",
  },
  getallDocumentosveiculos: {
    url: "getalldocumentosveiculos",
    method: "GET",
    resource: "GETALLDOCUMENTOSVEICULOS",
    type: "READ",
  },
  getallEmbarquesdata: {
    url: "getallembarquesdata",
    method: "POST",
    resource: "GETALLEMBARQUESDATA",
    type: "READ",
  },
  getallEmpresas: {
    url: "getallempresas",
    method: "GET",
    resource: "GETALLEMPRESAS",
    type: "READ",
  },
  getallEnderecosexternos: {
    url: "getallenderecosexternos",
    method: "POST",
    resource: "GETALLENDERECOSEXTERNOS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallEnderecosvalidados: {
    url: "getallenderecosvalidados",
    method: "GET",
    resource: "GETALLENDERECOSVALIDADOS",
    type: "READ",
  },
  getallEntradas: {
    url: "getallentradas",
    method: "GET",
    resource: "GETALLENTRADAS",
    type: "READ",
  },
  getallEquipamentos: {
    url: "getallequipamentos",
    method: "GET",
    resource: "GETALLEQUIPAMENTOS",
    type: "READ",
  },
  getallEquipamentosportipo: {
    url: "getallequipamentosportipo",
    method: "POST",
    resource: "GETALLEQUIPAMENTOSPORTIPO",
    type: "READ",
  },
  getallEquipamentosveiculos: {
    url: "getallequipamentosveiculos",
    method: "GET",
    resource: "GETALLEQUIPAMENTOSVEICULOS",
    type: "READ",
  },
  getallEquipes: {
    url: "getallequipes",
    method: "GET",
    resource: "GETALLEQUIPES",
    type: "READ",
  },
  getallErroshikvision: {
    url: "getallerroshikvision",
    method: "GET",
    resource: "GETALLERROSHIKVISION",
    type: "READ",
  },
  getallEscalas: {
    url: "getallescalas",
    method: "GET",
    resource: "GETALLESCALAS",
    type: "READ",
  },
  getallEventosdata: {
    url: "getalleventosdata",
    method: "GET",
    resource: "GETALLEVENTOSDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getallFabricantesrastreador: {
    url: "getallfabricantesrastreador",
    method: "GET",
    resource: "GETALLFABRICANTESRASTREADOR",
    type: "READ",
  },
  getallFamiliasatendimento: {
    url: "getallfamiliasatendimento",
    method: "GET",
    resource: "GETALLFAMILIASATENDIMENTO",
    type: "READ",
  },
  getallFeriados: {
    url: "getallferiados",
    method: "GET",
    resource: "GETALLFERIADOS",
    type: "READ",
  },
  getallFuncionarios: {
    url: "getallfuncionarios",
    method: "GET",
    resource: "GETALLFUNCIONARIOS",
    type: "READ",
  },
  getallGrupos: {
    url: "getallgrupos",
    method: "POST",
    resource: "GETALLGRUPOS",
    type: "READ",
  },
  getallGuias: {
    url: "getallguias",
    method: "GET",
    resource: "GETALLGUIAS",
    type: "READ",
  },
  getallHeaders: {
    url: "getallheaders",
    method: "GET",
    resource: "GETALLHEADERS",
    type: "READ",
  },
  getallHeaderstodisplay: {
    url: "getallheaderstodisplay",
    method: "GET",
    resource: "GETALLHEADERSTODISPLAY",
    type: "READ",
  },
  getallKits: {
    url: "getallkits",
    method: "GET",
    resource: "GETALLKITS",
    type: "READ",
  },
  getallLabelreferentes: {
    url: "getalllabelreferentes",
    method: "POST",
    resource: "GETALLLABELREFERENTES",
    type: "READ",
  },
  getallLimitesapiexternas: {
    url: "getalllimitesapiexternas",
    method: "GET",
    resource: "GETALLLIMITESAPIEXTERNAS",
    type: "READ",
  },
  getallLinhas: {
    url: "getalllinhas",
    method: "POST",
    resource: "GETALLLINHAS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallMetatemplates: {
    url: "getallmetatemplates",
    method: "GET",
    resource: "GETALLMETATEMPLATES",
    type: "READ",
  },
  getallModelos: {
    url: "getallmodelos",
    method: "GET",
    resource: "GETALLMODELOS",
    type: "READ",
  },
  getallModulossistema: {
    url: "getallmodulossistema",
    method: "GET",
    resource: "GETALLMODULOSSISTEMA",
    type: "READ",
  },
  getallMotivos: {
    url: "getallmotivos",
    method: "GET",
    resource: "GETALLMOTIVOS",
    type: "READ",
  },
  getallNotasfiscais: {
    url: "getallnotasfiscais",
    method: "GET",
    resource: "GETALLNOTASFISCAIS",
    type: "READ",
  },
  getallPaises: {
    url: "getallpaises",
    method: "GET",
    resource: "GETALLPAISES",
    type: "READ",
  },
  getallParadas: {
    url: "getallparadas",
    method: "GET",
    resource: "GETALLPARADAS",
    type: "READ",
  },
  getallParametroscontrole: {
    url: "getallparametroscontrole",
    method: "GET",
    resource: "GETALLPARAMETROSCONTROLE",
    type: "READ",
  },
  getallParametroscontroledata: {
    url: "getallparametroscontroledata",
    method: "GET",
    resource: "GETALLPARAMETROSCONTROLEDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getallParametrossetup: {
    url: "getallparametrossetup",
    method: "GET",
    resource: "GETALLPARAMETROSSETUP",
    type: "READ",
  },
  getallPerfisusuarios: {
    url: "getallperfisusuarios",
    method: "GET",
    resource: "GETALLPERFISUSUARIOS",
    type: "READ",
  },
  getallPermissionarios: {
    url: "getallpermissionarios",
    method: "GET",
    resource: "GETALLPERMISSIONARIOS",
    type: "READ",
  },
  getallPessoas: {
    url: "getallpessoas",
    method: "POST",
    resource: "GETALLPESSOAS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallPontosinteresseativos: {
    url: "getallpontosinteresseativos",
    method: "GET",
    resource: "GETALLPONTOSINTERESSESATIVOS",
    type: "READ",
  },
  getallPrecandidatos: {
    url: "getallprecandidatos",
    method: "POST",
    resource: "GETALLPRECANDIDATOS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallProdutosinternos: {
    url: "getallprodutosinternos",
    method: "GET",
    resource: "GETALLPRODUTOSINTERNOS",
    type: "READ",
  },
  getallQuadros: {
    url: "getallquadros",
    method: "GET",
    resource: "GETALLQUADROS",
    type: "READ",
  },
  getallQuadrosativos: {
    url: "getallquadrosativos",
    method: "GET",
    resource: "GETALLQUADROSATIVOS",
    type: "READ",
  },
  getallRecursos: {
    url: "getallrecursos",
    method: "GET",
    resource: "GETALLRECURSOS",
    type: "READ",
  },
  getallRegistros: {
    url: "getallregistros",
    method: "GET",
    resource: "GETALLREGISTROS",
    type: "READ",
  },
  getallRegistrosdata: {
    url: "getallregistrosdata",
    method: "GET",
    resource: "GETALLREGISTROSDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getallRotas: {
    url: "getallrotas",
    method: "POST",
    resource: "GETALLROTAS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallRotasativas: {
    url: "getallrotasativas",
    method: "GET",
    resource: "GETALLROTASATIVAS",
    type: "READ",
  },
  getallRotasvigencia: {
    url: "getallrotasvigencia",
    method: "GET",
    resource: "GETALLROTASVIGENCIA",
    type: "READ",
  },
  getallRotinas: {
    url: "getallrotinas",
    method: "GET",
    resource: "GETALLROTINAS",
    type: "READ",
  },
  getallSentidos: {
    url: "getallsentidos",
    method: "GET",
    resource: "GETALLSENTIDOS",
    type: "READ",
  },
  getallServicos: {
    url: "getallservicos",
    method: "GET",
    resource: "GETALLSERVICOS",
    type: "READ",
  },
  getallSimcards: {
    url: "getallsimcards",
    method: "GET",
    resource: "GETALLSIMCARDS",
    type: "READ",
  },
  getallSituacoes: {
    url: "getallsituacoes",
    method: "GET",
    resource: "GETALLSITUACOES",
    type: "READ",
  },
  getallSituacoespessoaporid: {
    url: "getallsituacoespessoaporid",
    method: "GET",
    resource: "GETALLSITUACOESPESSOAPORID",
    type: "READ",
    params: ["id"],
  },
  getallSituacoespessoas: {
    url: "getallsituacoespessoas",
    method: "GET",
    resource: "GETALLSITUACOESPESSOAS",
    type: "READ",
  },
  getallSituacoesvalidacao: {
    url: "getallsituacoesvalidacao",
    method: "GET",
    resource: "GETALLSITUACOESVALIDACAO",
    type: "READ",
  },
  getallSituacoesvalidacaopessoaporid: {
    url: "getallsituacoesvalidacaopessoaporid",
    method: "GET",
    resource: "GETALLSITUACOESVALIDACAOPESSOAPORID",
    type: "READ",
    params: ["id"],
  },
  getallSituacoesvalidacaopessoas: {
    url: "getallsituacoesvalidacaopessoas",
    method: "GET",
    resource: "GETALLSITUACOESVALIDACAOPESSOAS",
    type: "READ",
  },
  getallStatus: {
    url: "getallstatus",
    method: "GET",
    resource: "GETALLSTATUS",
    type: "READ",
    query: ["screen"],
  },
  getallStatusdocumentos: {
    url: "getallstatusdocumentos",
    method: "GET",
    resource: "GETALLSTATUSDOCUMENTOS",
    type: "READ",
  },
  getallStatusequipamento: {
    url: "getallstatusequipamento",
    method: "GET",
    resource: "GETALLSTATUSEQUIPAMENTO",
    type: "READ",
  },
  getallStatuskit: {
    url: "getallstatuskit",
    method: "GET",
    resource: "GETALLSTATUSKIT",
    type: "READ",
  },
  getallStatusqrcode: {
    url: "getallstatusqrcode",
    method: "GET",
    resource: "GETALLSTATUSQRCODE",
    type: "READ",
  },
  getallStatusveiculosoperacao: {
    url: "getallstatusveiculosoperacao",
    method: "GET",
    resource: "GETALLSTATUSVEICULOSOPERACAO",
    type: "READ",
  },
  getallSublinhas: {
    url: "getallsublinhas",
    method: "GET",
    resource: "GETALLSUBLINHAS",
    type: "READ",
  },
  getallTabelas: {
    url: "getalltabelas",
    method: "GET",
    resource: "GETALLTABELAS",
    type: "READ",
  },
  getallTagsrfid: {
    url: "getalltagsrfid",
    method: "GET",
    resource: "GETALLTAGSRFID",
    type: "READ",
  },
  getallTagsrfidativos: {
    url: "getalltagsrfidativos",
    method: "GET",
    resource: "GETALLTAGSRFIDATIVOS",
    type: "READ",
  },
  getallTagsrfiddisponiveis: {
    url: "getalltagsrfiddisponiveis",
    method: "GET",
    resource: "GETALLTAGSRFIDDISPONIVEIS",
    type: "READ",
  },
  getallTemplatesmensagens: {
    url: "getalltemplatesmensagens",
    method: "GET",
    resource: "GETALLTEMPLATESMENSAGENS",
    type: "READ",
  },
  getallTickets: {
    url: "getalltickets",
    method: "GET",
    resource: "GETALLTICKETS",
    type: "READ",
  },
  getallTiposaberturasviagens: {
    url: "getalltiposaberturasviagens",
    method: "GET",
    resource: "GETALLTIPOSABERTURASVIAGENS",
    type: "READ",
  },
  getallTiposatendimento: {
    url: "getalltiposatendimento",
    method: "GET",
    resource: "GETALLTIPOSATENDIMENTO",
    type: "READ",
  },
  getallTiposdocumentos: {
    url: "getalltiposdocumentos",
    method: "GET",
    resource: "GETALLTIPOSDOCUMENTOS",
    type: "READ",
  },
  getallTiposentrada: {
    url: "getalltiposentrada",
    method: "GET",
    resource: "GETALLTIPOSENTRADA",
    type: "READ",
  },
  getallTiposequipamentos: {
    url: "getalltiposequipamentos",
    method: "GET",
    resource: "GETALLTIPOSEQUIPAMENTOS",
    type: "READ",
  },
  getallTiposkits: {
    url: "getalltiposkits",
    method: "GET",
    resource: "GETALLTIPOSKITS",
    type: "READ",
  },
  getallTiposnotificacoes: {
    url: "getalltiposnotificacoes",
    method: "GET",
    resource: "GETALLTIPOSNOTIFICACOES",
    type: "READ",
  },
  getallTipostarifas: {
    url: "getalltipostarifas",
    method: "GET",
    resource: "GETALLTIPOSTARIFAS",
    type: "READ",
  },
  getallTipostickets: {
    url: "getalltipostickets",
    method: "GET",
    resource: "GETALLTIPOSTICKETS",
    type: "READ",
  },
  getallTiposveiculos: {
    url: "getalltiposveiculos",
    method: "GET",
    resource: "GETALLTIPOSVEICULOS",
    type: "READ",
  },
  getallTrechos: {
    url: "getalltrechos",
    method: "GET",
    resource: "GETALLTRECHOS",
    type: "READ",
  },
  getallTrechoslimites: {
    url: "getalltrechoslimites",
    method: "GET",
    resource: "GETALLTRECHOSLIMITES",
    type: "READ",
  },
  getallTurnos: {
    url: "getallturnos",
    method: "GET",
    resource: "GETALLTURNOS",
    type: "READ",
  },
  getallTurnosfuncionarios: {
    url: "getallturnosfuncionarios",
    method: "GET",
    resource: "GETALLTURNOSFUNCIONARIOS",
    type: "READ",
  },
  getallTurnospassageiros: {
    url: "getallturnospassageiros",
    method: "GET",
    resource: "GETALLTURNOSPASSAGEIROS",
    type: "READ",
  },
  getallUnidades: {
    url: "getallunidades",
    method: "POST",
    resource: "GETALLUNIDADES",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallUnidadesativas: {
    url: "getallunidadesativas",
    method: "GET",
    resource: "GETALLUNIDADESATIVAS",
    type: "READ",
  },
  getallUnidadesequipamentos: {
    url: "getallunidadesequipamentos",
    method: "GET",
    resource: "GETALLUNIDADESEQUIPAMENTOS",
    type: "READ",
  },
  getallUnidadesfederativas: {
    url: "getallunidadesfederativas",
    method: "GET",
    resource: "GETALLUNIDADESFEDERATIVAS",
    type: "READ",
  },
  getallUnidadesoperacao: {
    url: "getallunidadesoperacao",
    method: "GET",
    resource: "GETALLUNIDADESOPERACAO",
    type: "READ",
  },
  getallUsuarios: {
    url: "getallusuarios",
    method: "POST",
    resource: "GETALLUSUARIOS",
    type: "READ",
    params: ["pageNumber","rowsOfPage"],
  },
  getallVeiculos: {
    url: "getallveiculos",
    method: "GET",
    resource: "GETALLVEICULOS",
    type: "READ",
  },
  getallVeiculosativos: {
    url: "getallveiculosativos",
    method: "GET",
    resource: "GETALLVEICULOSATIVOS",
    type: "READ",
  },
  getallVeiculoscrud: {
    url: "getallveiculoscrud",
    method: "GET",
    resource: "GETALLVEICULOSCRUD",
    type: "READ",
  },
  getallVeiculosrastreamento: {
    url: "getallveiculosrastreamento",
    method: "GET",
    resource: "GETALLVEICULOSRASTREAMENTO",
    type: "READ",
  },
  getallViagens: {
    url: "getallviagens",
    method: "POST",
    resource: "GETALLVIAGENS",
    type: "READ",
  },
  getallViagenscontroladores: {
    url: "getallviagenscontroladores",
    method: "GET",
    resource: "GETALLVIAGENSCONTROLADORES",
    type: "READ",
  },
  getallViagenscontroladoresdata: {
    url: "getallviagenscontroladoresdata",
    method: "GET",
    resource: "GETALLVIAGENSCONTROLADORESDATA",
    type: "READ",
    params: ["dti","dtf"],
  },
  getallViagensescalas: {
    url: "getallviagensescalas",
    method: "GET",
    resource: "GETALLVIAGENSESCALAS",
    type: "READ",
  },
  getallViagensporquadro: {
    url: "getallviagensporquadro",
    method: "GET",
    resource: "GETALLVIAGENSPORQUADRO",
    type: "READ",
    params: ["id_quadro"],
  },
  getallViagensprevistas: {
    url: "getallviagensprevistas",
    method: "GET",
    resource: "GETALLVIAGENSPREVISTAS",
    type: "READ",
  },
  getallViagensrealizadas: {
    url: "getallviagensrealizadas",
    method: "GET",
    resource: "GETALLVIAGENSREALIZADAS",
    type: "READ",
  },
  getVigenciashodometroveiculo: {
    url: "getvigenciashodometroveiculo",
    method: "GET",
    resource: "GETVIGENCIASHODOMETROVEICULO",
    type: "READ",
    params: ["idveiculo"],
  },
  googleAuthuser: {
    url: "google/authuser",
    method: "GET",
    resource: "GOOGLE/AUTHUSER",
    type: "READ",
  },
  googleCreateSpace: {
    url: "google/createspace",
    method: "POST",
    resource: "GOOGLE/CREATESPACE",
    type: "WRITE",
  },
  googleListspaces: {
    url: "google/listspaces",
    method: "GET",
    resource: "GOOGLE/LISTSPACES",
    type: "READ",
  },
  googleMapsGetEtapointroute: {
    url: "google/maps/getetapointroute",
    method: "POST",
    resource: "GOOGLE/MAPS/GETETAPOINTROUTE",
    type: "READ",
  },
  googleMapsGetEtapoints: {
    url: "google/maps/getetapoints",
    method: "POST",
    resource: "GOOGLE/MAPS/GETETAPOINTS",
    type: "READ",
  },
  googleMapsGetGeocodebulk: {
    url: "google/maps/getgeocodebulk",
    method: "POST",
    resource: "GOOGLEMAPSGETGEOCODEBULK",
    type: "READ",
  },
  googleMapsGetOptimizedroutes: {
    url: "google/maps/getoptimizedroutes",
    method: "POST",
    resource: "GOOGLE/MAPS/GETOPTIMIZEDROUTES",
    type: "READ",
  },
  googleMapsGetReversegeocodebulk: {
    url: "google/maps/getreversegeocodebulk",
    method: "POST",
    resource: "GOOGLEMAPSGETREVERSEGEOCODEBULK",
    type: "READ",
  },
  googleReceiver: {
    url: "google/receiver",
    method: "POST",
    resource: "GOOGLE/RECEIVER",
    type: "WRITE",
  },
  googleSendDirectmessage: {
    url: "google/senddirectmessage",
    method: "GET",
    resource: "GOOGLE/SENDDIRECTMESSAGE",
    type: "READ",
  },
  googleSendMessage: {
    url: "google/sendmessage",
    method: "POST",
    resource: "GOOGLE/SENDMESSAGE",
    type: "WRITE",
  },
  gravarotascaminhadabulk: {
    url: "gravarotascaminhadabulk",
    method: "POST",
    resource: "GRAVAROTASCAMINHADABULK",
    type: "WRITE",
  },
  gruposUpdateStatushikvision: {
    url: "grupos/updatestatushikvision",
    method: "POST",
    resource: "GRUPOS/UPDATESTATUSHIKVISION",
    type: "WRITE",
  },
  hereMapsGetGeocodebulk: {
    url: "here/maps/getgeocodebulk",
    method: "POST",
    resource: "HEREMAPSGETGEOCODEBULK",
    type: "READ",
  },
  hereMapsGetReversegeocodebulk: {
    url: "here/maps/getreversegeocodebulk",
    method: "POST",
    resource: "HEREMAPSGETREVERSEGEOCODEBULK",
    type: "READ",
  },
  hikvisionAddorganization: {
    url: "hikvision/addorganization",
    method: "POST",
    resource: "HIKVISION/ADDORGANIZATION",
    type: "WRITE",
  },
  hikvisionAddperson: {
    url: "hikvision/addperson",
    method: "POST",
    resource: "HIKVISION/ADDPERSON",
    type: "WRITE",
  },
  hikvisionAddpersonstoaccesslevel: {
    url: "hikvision/addpersonstoaccesslevel",
    method: "POST",
    resource: "HIKVISION/ADDPERSONSTOACCESSLEVEL",
    type: "WRITE",
  },
  hikvisionAddvehiclegroup: {
    url: "hikvision/addvehiclegroup",
    method: "POST",
    resource: "HIKVISION/ADDVEHICLEGROUP",
    type: "WRITE",
  },
  hikvisionChecksubscription: {
    url: "hikvision/checksubscription",
    method: "POST",
    resource: "HIKVISION/CHECKSUBSCRIPTION",
    type: "WRITE",
  },
  hikvisionDeleteOrganization: {
    url: "hikvision/deleteorganization",
    method: "POST",
    resource: "HIKVISION/DELETEORGANIZATION",
    type: "DELETE",
  },
  hikvisionDeletePersonbyid: {
    url: "hikvision/deletepersonbyid",
    method: "POST",
    resource: "HIKVISION/DELETEPERSONBYID",
    type: "DELETE",
  },
  hikvisionDeletePersonsfromaccesslevel: {
    url: "hikvision/deletepersonsfromaccesslevel",
    method: "POST",
    resource: "HIKVISION/DELETEPERSONSFROMACCESSLEVEL",
    type: "DELETE",
  },
  hikvisionEventrcv: {
    url: "hikvision/eventrcv",
    method: "POST",
    resource: "HIKVISION/EVENTRCV",
    type: "WRITE",
  },
  hikvisionFacecheck: {
    url: "hikvision/facecheck",
    method: "POST",
    resource: "HIKVISION/FACECHECK",
    type: "WRITE",
  },
  hikvisionGenerateQrcodebyid: {
    url: "hikvision/generateqrcodebyid",
    method: "POST",
    resource: "HIKVISION/GENERATEQRCODEBYID",
    type: "WRITE",
  },
  hikvisionGetAccesslevellist: {
    url: "hikvision/getaccesslevellist",
    method: "GET",
    resource: "HIKVISION_GETACCESSLEVELLIST",
    type: "READ",
  },
  hikvisionGetAcsdevicebyid: {
    url: "hikvision/getacsdevicebyid",
    method: "POST",
    resource: "HIKVISION/GETACSDEVICEBYID",
    type: "READ",
  },
  hikvisionGetAcsdevicelist: {
    url: "hikvision/getacsdevicelist",
    method: "GET",
    resource: "HIKVISION/GETACSDEVICELIST",
    type: "READ",
  },
  hikvisionGetApplicationresult: {
    url: "hikvision/getapplicationresult",
    method: "GET",
    resource: "HIKVISION/GETAPPLICATIONRESULT",
    type: "READ",
  },
  hikvisionGetDoorbyid: {
    url: "hikvision/getdoorbyid",
    method: "POST",
    resource: "HIKVISION/GETDOORBYID",
    type: "READ",
  },
  hikvisionGetDooreventsbyperiodbytype: {
    url: "hikvision/getdooreventsbyperiodbytype",
    method: "POST",
    resource: "HIKVISION/GETDOOREVENTSBYPERIODBYTYPE",
    type: "READ",
  },
  hikvisionGetDoorlist: {
    url: "hikvision/getdoorlist",
    method: "GET",
    resource: "HIKVISION/GETDOORLIST",
    type: "READ",
  },
  hikvisionGetEquipamentosniveisacesso: {
    url: "hikvision/getequipamentosniveisacesso",
    method: "POST",
    resource: "HIKVISION/GETEQUIPAMENTOSNIVEISACESSO",
    type: "READ",
  },
  hikvisionGetEventpicture: {
    url: "hikvision/geteventpicture",
    method: "POST",
    resource: "HIKVISION/GETEVENTPICTURE",
    type: "READ",
  },
  hikvisionGetOrganizationlist: {
    url: "hikvision/getorganizationlist",
    method: "GET",
    resource: "HIKVISION/GETORGANIZATIONLIST",
    type: "READ",
  },
  hikvisionGetPersonbycode: {
    url: "hikvision/getpersonbycode",
    method: "POST",
    resource: "HIKVISION/GETPERSONBYCODE",
    type: "READ",
  },
  hikvisionGetPersonbyid: {
    url: "hikvision/getpersonbyid",
    method: "POST",
    resource: "HIKVISION/GETPERSONBYID",
    type: "READ",
  },
  hikvisionGetPersonbyname: {
    url: "hikvision/getpersonbyname",
    method: "POST",
    resource: "HIKVISION/GETPERSONBYNAME",
    type: "READ",
  },
  hikvisionGetPersonlist: {
    url: "hikvision/getpersonlist",
    method: "GET",
    resource: "HIKVISION/GETPERSONLIST",
    type: "READ",
  },
  hikvisionGetPersonlistbyaccesslevel: {
    url: "hikvision/getpersonlistbyaccesslevel",
    method: "POST",
    resource: "HIKVISION/GETPERSONLISTBYACCESSLEVEL",
    type: "READ",
  },
  hikvisionGetPersonpicture: {
    url: "hikvision/getpersonpicture",
    method: "POST",
    resource: "HIKVISION/GETPERSONPICTURE",
    type: "READ",
  },
  hikvisionGetRegionslist: {
    url: "hikvision/getregionslist",
    method: "GET",
    resource: "HIKVISION/GETREGIONSLIST",
    type: "READ",
  },
  hikvisionGetRelatoriomanutencao: {
    url: "hikvision/getrelatoriomanutencao",
    method: "POST",
    resource: "HIKVISION/GETRELATORIOMANUTENCAO",
    type: "READ",
  },
  hikvisionGetRootorganization: {
    url: "hikvision/getrootorganization",
    method: "GET",
    resource: "HIKVISION/GETROOTORGANIZATION",
    type: "READ",
  },
  hikvisionGetSiteslist: {
    url: "hikvision/getsiteslist",
    method: "GET",
    resource: "HIKVISION/GETSITESLIST",
    type: "READ",
  },
  hikvisionGetTotaleventosequipamentodata: {
    url: "hikvision/gettotaleventosequipamentodata",
    method: "POST",
    resource: "HIKVISION/GETTOTALEVENTOSEQUIPAMENTODATA",
    type: "READ",
  },
  hikvisionGetTotaleventosveiculodata: {
    url: "hikvision/gettotaleventosveiculodata",
    method: "POST",
    resource: "HIKVISION/GETTOTALEVENTOSVEICULODATA",
    type: "READ",
  },
  hikvisionGetVehiclegroupslist: {
    url: "hikvision/getvehiclegroupslist",
    method: "GET",
    resource: "HIKVISION/GETVEHICLEGROUPSLIST",
    type: "READ",
  },
  hikvisionGetallTiposeventos: {
    url: "hikvision/getalltiposeventos",
    method: "GET",
    resource: "HIKVISION/GETALLTIPOSEVENTOS",
    type: "READ",
  },
  hikvisionIsapiFaceidcardapply: {
    url: "hikvision/isapi/faceidcardapply",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDCARDAPPLY",
    type: "WRITE",
  },
  hikvisionIsapiFaceidcardcount: {
    url: "hikvision/isapi/faceidcardcount",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDCARDCOUNT",
    type: "WRITE",
  },
  hikvisionIsapiFaceidcarddeletebyid: {
    url: "hikvision/isapi/faceidcarddeletebyid",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDCARDDELETEBYID",
    type: "WRITE",
  },
  hikvisionIsapiFaceidcardlistall: {
    url: "hikvision/isapi/faceidcardlistall",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDCARDLISTALL",
    type: "WRITE",
  },
  hikvisionIsapiFaceidcardlistbyid: {
    url: "hikvision/isapi/faceidcardlistbyid",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDCARDLISTBYID",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersonapply: {
    url: "hikvision/isapi/faceidpersonapply",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONAPPLY",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersoncheckdeleteprocess: {
    url: "hikvision/isapi/faceidpersoncheckdeleteprocess",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONCHECKDELETEPROCESS",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersoncount: {
    url: "hikvision/isapi/faceidpersoncount",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONCOUNT",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersondeleteall: {
    url: "hikvision/isapi/faceidpersondeleteall",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONDELETEALL",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersondeletebyid: {
    url: "hikvision/isapi/faceidpersondeletebyid",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONDELETEBYID",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersonlistall: {
    url: "hikvision/isapi/faceidpersonlistall",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONLISTALL",
    type: "WRITE",
  },
  hikvisionIsapiFaceidpersonlistbyid: {
    url: "hikvision/isapi/faceidpersonlistbyid",
    method: "POST",
    resource: "HIKVISION/ISAPI/FACEIDPERSONLISTBYID",
    type: "WRITE",
  },
  hikvisionIsapiPinger: {
    url: "hikvision/isapi/pinger",
    method: "POST",
    resource: "HIKVISION/ISAPI/PINGER",
    type: "WRITE",
  },
  hikvisionReaplyAccesslevel: {
    url: "hikvision/reaplyaccesslevel",
    method: "POST",
    resource: "HIKVISION/REAPLYACCESSLEVEL",
    type: "WRITE",
  },
  hikvisionSubscribeevents: {
    url: "hikvision/subscribeevents",
    method: "POST",
    resource: "HIKVISION/SUBSCRIBEEVENTS",
    type: "WRITE",
  },
  hikvisionUnsubscribeevents: {
    url: "hikvision/unsubscribeevents",
    method: "POST",
    resource: "HIKVISION/UNSUBSCRIBEEVENTS",
    type: "WRITE",
  },
  hikvisionUpdateOrganization: {
    url: "hikvision/updateorganization",
    method: "POST",
    resource: "HIKVISION/UPDATEORGANIZATION",
    type: "WRITE",
  },
  hikvisionUpdatePersonbyid: {
    url: "hikvision/updatepersonbyid",
    method: "POST",
    resource: "HIKVISION/UPDATEPERSONBYID",
    type: "WRITE",
  },
  hikvisionUpdatePersonfacebyid: {
    url: "hikvision/updatepersonfacebyid",
    method: "POST",
    resource: "HIKVISION/UPDATEPERSONFACEBYID",
    type: "WRITE",
  },
  hikvisionUpdateVehiclegroup: {
    url: "hikvision/updatevehiclegroup",
    method: "POST",
    resource: "HIKVISION/UPDATEVEHICLEGROUP",
    type: "WRITE",
  },
  importlinhasplanbulk: {
    url: "importlinhasplanbulk",
    method: "POST",
    resource: "IMPORTLINHASPLANBULK",
    type: "WRITE",
  },
  importprecandidatoscsvticket: {
    url: "importprecandidatoscsvticket",
    method: "POST",
    resource: "IMPORTPRECANDIDATOSCSVTICKET",
    type: "WRITE",
  },
  insertAcessowebapplatlng: {
    url: "insertacessowebapplatlng",
    method: "POST",
    resource: "INSERTACESSOWEBAPPLATLNG",
    type: "WRITE",
  },
  insertAcessowebapplinha: {
    url: "insertacessowebapplinha",
    method: "POST",
    resource: "INSERTACESSOWEBAPPLINHA",
    type: "WRITE",
  },
  insertAgenciaemprego: {
    url: "insertagenciaemprego",
    method: "POST",
    resource: "INSERTAGENCIAEMPREGO",
    type: "WRITE",
  },
  insertAgendamentosdownloads: {
    url: "insertagendamentosdownloads",
    method: "POST",
    resource: "INSERTAGENDAMENTOSDOWNLOADS",
    type: "WRITE",
  },
  insertArea: {
    url: "insertarea",
    method: "POST",
    resource: "INSERTAREA",
    type: "WRITE",
  },
  insertAvisobanner: {
    url: "insertavisobanner",
    method: "POST",
    resource: "INSERTAVISOBANNER",
    type: "WRITE",
  },
  insertCandidato: {
    url: "insertcandidato",
    method: "POST",
    resource: "INSERTCANDIDATO",
    type: "WRITE",
  },
  insertCandidatosbulk: {
    url: "insertcandidatosbulk",
    method: "POST",
    resource: "INSERTCANDIDATOSBULK",
    type: "WRITE",
  },
  insertCategoriaticket: {
    url: "insertcategoriaticket",
    method: "POST",
    resource: "INSERTCATEGORIATICKET",
    type: "WRITE",
  },
  insertCerca: {
    url: "insertcerca",
    method: "POST",
    resource: "INSERCERCA",
    type: "WRITE",
  },
  insertCercafromaddress: {
    url: "insertcercafromaddress",
    method: "POST",
    resource: "INSERTCERCAFROMADDRESS",
    type: "WRITE",
  },
  insertCercalinhaviavigencia: {
    url: "insertcercalinhaviavigencia",
    method: "POST",
    resource: "INSERTCERCALINHAVIAVIGENCIA",
    type: "WRITE",
  },
  insertCercaordem: {
    url: "insertcercaordem",
    method: "POST",
    resource: "INSERTCERCAORDEM",
    type: "WRITE",
  },
  insertCercaordembulk: {
    url: "insertcercaordembulk",
    method: "POST",
    resource: "INSERTCERCAORDEMBULK",
    type: "WRITE",
  },
  insertCercasbulk: {
    url: "insertcercasbulk",
    method: "POST",
    resource: "INSERTCERCASBULK",
    type: "WRITE",
  },
  insertCercascontrolador: {
    url: "insertcercascontrolador",
    method: "POST",
    resource: "INSERTCERCASCONTROLADOR",
    type: "WRITE",
  },
  insertCercaslinhabulk: {
    url: "insertcercaslinhabulk",
    method: "POST",
    resource: "INSERTCERCASLINHABULK",
    type: "WRITE",
  },
  insertCercavigencia: {
    url: "insertcercavigencia",
    method: "POST",
    resource: "INSERTCERCAVIGENCIA",
    type: "WRITE",
  },
  insertCercavigenciacomsequencia: {
    url: "insertcercavigenciacomsequencia",
    method: "POST",
    resource: "INSERTCERCAVIGENCIACOMSEQUENCIA",
    type: "WRITE",
  },
  insertChecklist: {
    url: "insertchecklist",
    method: "POST",
    resource: "INSERTCHECKLIST",
    type: "WRITE",
  },
  insertChecklistequipamento: {
    url: "insertchecklistequipamento",
    method: "POST",
    resource: "INSERTCHECKLISTEQUIPAMENTO",
    type: "WRITE",
  },
  insertChecklistequipamentoresposta: {
    url: "insertchecklistequipamentoresposta",
    method: "POST",
    resource: "INSERTCHECKLISTEQUIPAMENTORESPOSTA",
    type: "WRITE",
  },
  insertClassificacao: {
    url: "insertclassificacao",
    method: "POST",
    resource: "INSERTCLASSIFICACAO",
    type: "WRITE",
  },
  insertCliente: {
    url: "insertcliente",
    method: "POST",
    resource: "INSERTCLIENTE",
    type: "WRITE",
  },
  insertComentario: {
    url: "insertcomentario",
    method: "POST",
    resource: "INSERTCOMENTARIO",
    type: "WRITE",
  },
  insertDashboard: {
    url: "insertdashboard",
    method: "POST",
    resource: "INSERTDASHBOARD",
    type: "WRITE",
  },
  insertDocumentopessoa: {
    url: "insertdocumentopessoa",
    method: "POST",
    resource: "INSERTDOCUMENTOPESSOA",
    type: "WRITE",
  },
  insertDocumentopessoazip: {
    url: "insertdocumentopessoazip",
    method: "POST",
    resource: "INSERTDOCUMENTOPESSOAZIP",
    type: "WRITE",
  },
  insertDocumentoveiculo: {
    url: "insertdocumentoveiculo",
    method: "POST",
    resource: "INSERTDOCUMENTOVEICULO",
    type: "WRITE",
  },
  insertDocumentoveiculozip: {
    url: "insertdocumentoveiculozip",
    method: "POST",
    resource: "INSERTDOCUMENTOVEICULOZIP",
    type: "WRITE",
  },
  insertEmpresa: {
    url: "insertempresa",
    method: "POST",
    resource: "INSEREMPRESA",
    type: "WRITE",
  },
  insertEnderecovalidado: {
    url: "insertenderecovalidado",
    method: "POST",
    resource: "INSERTENDERECOVALIDADO",
    type: "WRITE",
  },
  insertEnderecovalidadobulk: {
    url: "insertenderecovalidadobulk",
    method: "POST",
    resource: "INSERTENDERECOVALIDADOBULK",
    type: "WRITE",
  },
  insertEntrada: {
    url: "insertentrada",
    method: "POST",
    resource: "INSERTENTRADA",
    type: "WRITE",
  },
  insertEquipamento: {
    url: "insertequipamento",
    method: "POST",
    resource: "INSERTEQUIPAMENTO",
    type: "WRITE",
  },
  insertEquipamentosbulk: {
    url: "insertequipamentosbulk",
    method: "POST",
    resource: "INSERTEQUIPAMENTOSBULK",
    type: "WRITE",
  },
  insertEscala: {
    url: "insertescala",
    method: "POST",
    resource: "INSERTESCALA",
    type: "WRITE",
  },
  insertFamiliaatendimento: {
    url: "insertfamiliaatendimento",
    method: "POST",
    resource: "INSERTFAMILIAATENDIMENTO",
    type: "WRITE",
  },
  insertFechamentodia: {
    url: "insertfechamentodia",
    method: "POST",
    resource: "INSERTFECHAMENTODIA",
    type: "WRITE",
  },
  insertFeriado: {
    url: "insertferiado",
    method: "POST",
    resource: "INSERTFERIADO",
    type: "WRITE",
  },
  insertFeriadosbulk: {
    url: "insertferiadosbulk",
    method: "POST",
    resource: "INSERTFERIADOSBULK",
    type: "WRITE",
  },
  insertFuncionario: {
    url: "insertfuncionario",
    method: "POST",
    resource: "INSERTFUNCIONARIO",
    type: "WRITE",
  },
  insertFuncionarioguia: {
    url: "insertfuncionarioguia",
    method: "POST",
    resource: "INSERTFUNCIONARIOGUIA",
    type: "WRITE",
  },
  insertFuncionariosbulk: {
    url: "insertfuncionariosbulk",
    method: "POST",
    resource: "INSERTFUNCIONARIOSBULK",
    type: "WRITE",
  },
  insertFuncionariosguiabulk: {
    url: "insertfuncionariosguiabulk",
    method: "POST",
    resource: "INSERTFUNCIONARIOSGUIABULK",
    type: "WRITE",
  },
  insertGuia: {
    url: "insertguia",
    method: "POST",
    resource: "INSERTGUIA",
    type: "WRITE",
  },
  insertGuiacomfuncionarios: {
    url: "insertguiacomfuncionarios",
    method: "POST",
    resource: "INSERTGUIACOMFUNCIONARIOS",
    type: "WRITE",
  },
  insertGuiasbulk: {
    url: "insertguiasbulk",
    method: "POST",
    resource: "INSERTGUIASBULK",
    type: "WRITE",
  },
  insertHeader: {
    url: "insertheader",
    method: "POST",
    resource: "INSERTHEADER",
    type: "WRITE",
  },
  insertHistoricoalteracoesrotas: {
    url: "inserthistoricoalteracoesrotas",
    method: "POST",
    resource: "INSERTHISTORICOALTERACOESROTAS",
    type: "WRITE",
  },
  insertHistoricoroteirizacao: {
    url: "inserthistoricoroteirizacao",
    method: "POST",
    resource: "INSERTHISTORICOROTEIRIZACAO",
    type: "WRITE",
  },
  insertInspecaoveiculo: {
    url: "insertinspecaoveiculo",
    method: "POST",
    resource: "INSERTINSPECAOVEICULO",
    type: "WRITE",
  },
  insertKit: {
    url: "insertkit",
    method: "POST",
    resource: "INSERTKIT",
    type: "WRITE",
  },
  insertKittipo: {
    url: "insertkittipo",
    method: "POST",
    resource: "INSERTKITTIPO",
    type: "WRITE",
  },
  insertLabelreferente: {
    url: "insertlabelreferente",
    method: "POST",
    resource: "INSERTLABELREFERENTE",
    type: "WRITE",
  },
  insertLinha: {
    url: "insertlinha",
    method: "POST",
    resource: "INSERTLINHA",
    type: "WRITE",
  },
  insertLinhasentradabulk: {
    url: "insertlinhasentradabulk",
    method: "POST",
    resource: "INSERTLINHASENTRADABULK",
    type: "WRITE",
  },
  insertLocal: {
    url: "insertlocal",
    method: "POST",
    resource: "INSERTLOCAL",
    type: "WRITE",
  },
  insertLocalempresa: {
    url: "insertlocalempresa",
    method: "POST",
    resource: "INSERTLOCALEMPRESA",
    type: "WRITE",
  },
  insertLocationunidade: {
    url: "insertlocationunidade",
    method: "POST",
    resource: "INSERTLOCATIONUNIDADE",
    type: "WRITE",
  },
  insertMensagem: {
    url: "insertmensagem",
    method: "POST",
    resource: "INSERTMENSAGEM",
    type: "WRITE",
  },
  insertMotivo: {
    url: "insertmotivo",
    method: "POST",
    resource: "INSERTMOTIVO",
    type: "WRITE",
  },
  insertNotafiscal: {
    url: "insertnotafiscal",
    method: "POST",
    resource: "INSERTNOTAFISCAL",
    type: "WRITE",
  },
  insertNotafiscalitemequipamento: {
    url: "insertnotafiscalitemequipamento",
    method: "POST",
    resource: "INSERTNOTAFISCALITEMEQUIPAMENTO",
    type: "WRITE",
  },
  insertParadaroteirizacao: {
    url: "insertparadaroteirizacao",
    method: "POST",
    resource: "INSERTPARADAROTEIRIZACAO",
    type: "WRITE",
  },
  insertParadasbulk: {
    url: "insertparadasbulk",
    method: "POST",
    resource: "INSERTPARADASBULK",
    type: "WRITE",
  },
  insertParadasroteirizacaobulk: {
    url: "insertparadasroteirizacaobulk",
    method: "POST",
    resource: "INSERTPARADASROTEIRIZACAOBULK",
    type: "WRITE",
  },
  insertPerfil: {
    url: "insertperfil",
    method: "POST",
    resource: "INSERTPERFIL",
    type: "WRITE",
  },
  insertPermissao: {
    url: "insertpermissao",
    method: "POST",
    resource: "INSERTPERMISSAO",
    type: "WRITE",
  },
  insertPermissionario: {
    url: "insertpermissionario",
    method: "POST",
    resource: "INSERTPERMISSIONARIO",
    type: "WRITE",
  },
  insertPermissoesbulk: {
    url: "insertpermissoesbulk",
    method: "POST",
    resource: "INSERTPERMISSOESBULK",
    type: "WRITE",
  },
  insertPessoasfotoszip: {
    url: "insertpessoasfotoszip",
    method: "POST",
    resource: "INSERTPESSOASFOTOSZIP",
    type: "WRITE",
  },
  insertPessoaszip: {
    url: "insertpessoaszip",
    method: "POST",
    resource: "INSERTPESSOASZIP",
    type: "WRITE",
  },
  insertProdutointerno: {
    url: "insertprodutointerno",
    method: "POST",
    resource: "INSERTPRODUTOINTERNO",
    type: "WRITE",
  },
  insertQuadro: {
    url: "insertquadro",
    method: "POST",
    resource: "INSERTQUADRO",
    type: "WRITE",
  },
  insertQuadroandupdate: {
    url: "insertquadroandupdate",
    method: "POST",
    resource: "INSERTQUADROANDUPDATE",
    type: "WRITE",
  },
  insertRecurso: {
    url: "insertrecurso",
    method: "POST",
    resource: "INSERTRECURSO",
    type: "WRITE",
  },
  insertRecursospermissaobulk: {
    url: "insertrecursospermissaobulk",
    method: "POST",
    resource: "INSERTRECURSOSPERMISSAOBULK",
    type: "WRITE",
  },
  insertRegistro: {
    url: "insertregistro",
    method: "POST",
    resource: "INSERTREGISTRO",
    type: "WRITE",
  },
  insertReservacandidato: {
    url: "insertreservacandidato",
    method: "POST",
    resource: "INSERTRESERVACANDIDATO",
    type: "WRITE",
  },
  insertRota: {
    url: "insertrota",
    method: "POST",
    resource: "INSERTROTA",
    type: "WRITE",
  },
  insertRotaslinha: {
    url: "insertrotaslinha",
    method: "POST",
    resource: "INSERTROTASLINHA",
    type: "WRITE",
  },
  insertRotaslinhabulk: {
    url: "insertrotaslinhabulk",
    method: "POST",
    resource: "INSERTROTASLINHABULK",
    type: "WRITE",
  },
  insertRotavigencia: {
    url: "insertrotavigencia",
    method: "POST",
    resource: "INSERTROTAVIGENCIA",
    type: "WRITE",
  },
  insertServico: {
    url: "insertservico",
    method: "POST",
    resource: "INSERTSERVICO",
    type: "WRITE",
  },
  insertSimcard: {
    url: "insertsimcard",
    method: "POST",
    resource: "INSERTSIMCARD",
    type: "WRITE",
  },
  insertSituacao: {
    url: "insertsituacao",
    method: "POST",
    resource: "INSERTSITUACAO",
    type: "WRITE",
  },
  insertSituacaopessoa: {
    url: "insertsituacaopessoa",
    method: "POST",
    resource: "INSERTSITUACAOPESSOA",
    type: "WRITE",
  },
  insertSituacaovalidacaopessoa: {
    url: "insertsituacaovalidacaopessoa",
    method: "POST",
    resource: "INSERTSITUACAOVALIDACAOPESSOA",
    type: "WRITE",
  },
  insertStatusticket: {
    url: "insertstatusticket",
    method: "POST",
    resource: "INSERTTICKETSTATUS",
    type: "WRITE",
  },
  insertTagrfid: {
    url: "inserttagrfid",
    method: "POST",
    resource: "INSERTTAGRFID",
    type: "WRITE",
  },
  insertTagrfidbulk: {
    url: "inserttagrfidbulk",
    method: "POST",
    resource: "INSERTTAGRFIDBULK",
    type: "WRITE",
  },
  insertTarifa: {
    url: "inserttarifa",
    method: "GET",
    resource: "INSERTTARIFA",
    type: "READ",
  },
  insertTema: {
    url: "inserttema",
    method: "GET",
    resource: "INSERTTEMA",
    type: "READ",
  },
  insertTemplatemensagem: {
    url: "inserttemplatemensagem",
    method: "POST",
    resource: "INSERTTEMPLATEMENSAGEM",
    type: "WRITE",
  },
  insertTicket: {
    url: "insertticket",
    method: "POST",
    resource: "INSERTTICKET",
    type: "WRITE",
  },
  insertTicketsolicitacaocandidatosagencia: {
    url: "insertticketsolicitacaocandidatosagencia",
    method: "POST",
    resource: "INSERTTICKETSOLICITACAOCANDIDATOSAGENCIA",
    type: "WRITE",
  },
  insertTicketsuportesistema: {
    url: "insertticketsuportesistema",
    method: "POST",
    resource: "INSERTTICKETSUPORTESISTEMA",
    type: "WRITE",
  },
  insertTipoatendimento: {
    url: "inserttipoatendimento",
    method: "POST",
    resource: "INSERTTIPOATENDIMENTO",
    type: "WRITE",
  },
  insertTipoentrada: {
    url: "inserttipoentrada",
    method: "POST",
    resource: "INSERTTIPOENTRADA",
    type: "WRITE",
  },
  insertTipoequipamento: {
    url: "inserttipoequipamento",
    method: "POST",
    resource: "INSERTTIPOEQUIPAMENTO",
    type: "WRITE",
  },
  insertTipotarifa: {
    url: "inserttipotarifa",
    method: "POST",
    resource: "INSERTTIPOTARIFA",
    type: "WRITE",
  },
  insertTipoveiculo: {
    url: "inserttipoveiculo",
    method: "POST",
    resource: "INSERTTIPOVEICULO",
    type: "WRITE",
  },
  insertTrecho: {
    url: "inserttrecho",
    method: "POST",
    resource: "INSERTTRECHO",
    type: "WRITE",
  },
  insertTrecholimite: {
    url: "inserttrecholimite",
    method: "POST",
    resource: "INSERTTRECHOLIMITE",
    type: "WRITE",
  },
  insertTrechoslimitesbulk: {
    url: "inserttrechoslimitesbulk",
    method: "POST",
    resource: "INSERTTRECHOSLIMITESBULK",
    type: "WRITE",
  },
  insertTrechoslinhabulk: {
    url: "inserttrechoslinhabulk",
    method: "POST",
    resource: "INSERTTRECHOSLINHASBULK",
    type: "WRITE",
  },
  insertTurno: {
    url: "insertturno",
    method: "POST",
    resource: "INSERTTURNO",
    type: "WRITE",
  },
  insertTurnofuncionario: {
    url: "insertturnofuncionario",
    method: "POST",
    resource: "INSERTTURNOFUNCIONARIO",
    type: "WRITE",
  },
  insertTurnopassageiro: {
    url: "insertturnopassageiro",
    method: "POST",
    resource: "INSERTTURNOPASSAGEIRO",
    type: "WRITE",
  },
  insertTurnoslinhabulk: {
    url: "insertturnoslinhabulk",
    method: "POST",
    resource: "INSERTTURNOSLINHABULK",
    type: "WRITE",
  },
  insertUnidade: {
    url: "insertunidade",
    method: "POST",
    resource: "INSERTUNIDADE",
    type: "WRITE",
  },
  insertUnidadepermissao: {
    url: "insertunidadepermissao",
    method: "POST",
    resource: "INSERTUNIDADEPERMISSAO",
    type: "WRITE",
  },
  insertUsuario: {
    url: "insertusuario",
    method: "POST",
    resource: "INSERTUSUARIO",
    type: "WRITE",
  },
  insertVeiculo: {
    url: "insertveiculo",
    method: "POST",
    resource: "INSERTVEICULO",
    type: "WRITE",
  },
  insertVeiculosbulk: {
    url: "insertveiculosbulk",
    method: "POST",
    resource: "INSERTVEICULOSBULK",
    type: "WRITE",
  },
  insertVeiculosentradabulk: {
    url: "insertveiculosentradabulk",
    method: "POST",
    resource: "INSERTVEICULOSENTRADABULK",
    type: "WRITE",
  },
  insertViagemcontrolador: {
    url: "insertviagemcontrolador",
    method: "POST",
    resource: "INSERTVIAGEMCONTROLADOR",
    type: "WRITE",
  },
  insertViagemescala: {
    url: "insertviagemescala",
    method: "POST",
    resource: "INSERTVIAGEMESCALA",
    type: "WRITE",
  },
  insertViagemgrid: {
    url: "insertviagemgrid",
    method: "POST",
    resource: "INSERTVIAGEMGRID",
    type: "WRITE",
  },
  insertViagemquadro: {
    url: "insertviagemquadro",
    method: "POST",
    resource: "INSERTVIAGEMQUADRO",
    type: "WRITE",
  },
  insertViagemrealizada: {
    url: "insertviagemrealizada",
    method: "POST",
    resource: "INSERTVIAGEMREALIZADA",
    type: "WRITE",
  },
  insertViagensbulk: {
    url: "insertviagensbulk",
    method: "POST",
    resource: "INSERTVIAGENSBULK",
    type: "WRITE",
  },
  insertViagenscontroladoresentradabulk: {
    url: "insertviagenscontroladoresentradabulk",
    method: "POST",
    resource: "INSERTVIAGENSCONTROLADORESENTRADABULK",
    type: "WRITE",
  },
  insertViagensescalabulk: {
    url: "insertviagensescalabulk",
    method: "POST",
    resource: "INSERTVIAGENSESCALABULK",
    type: "WRITE",
  },
  insertViagensprevistasentradabulk: {
    url: "insertviagensprevistasentradabulk",
    method: "POST",
    resource: "INSERTVIAGENSPREVISTASENTRADABULK",
    type: "WRITE",
  },
  insertViagensrealizadasentradabulk: {
    url: "insertviagensrealizadasentradabulk",
    method: "POST",
    resource: "INSERTVIAGENSREALIZADASENTRADABULK",
    type: "WRITE",
  },
  insertVigenciahodometroveiculo: {
    url: "insertvigenciahodometroveiculo",
    method: "POST",
    resource: "INSERTVIGENCIAHODOMETROVEICULO",
    type: "WRITE",
  },
  isapiDeleteFirmwarepermitido: {
    url: "isapi/deletefirmwarepermitido",
    method: "POST",
    resource: "ISAPI/DELETEFIRMWAREPERMITIDO",
    type: "DELETE",
  },
  isapiForcasyncisapi: {
    url: "isapi/forcasyncisapi",
    method: "POST",
    resource: "ISAPI/FORCASYNCISAPI",
    type: "WRITE",
  },
  isapiGetErroshikcentral: {
    url: "isapi/geterroshikcentral",
    method: "POST",
    resource: "ISAPI/GETERROSHIKCENTRAL",
    type: "READ",
  },
  isapiGetIsapiatualizacaoitens: {
    url: "isapi/getisapiatualizacaoitens",
    method: "POST",
    resource: "ISAPI/GETISAPIATUALIZACAOITENS",
    type: "READ",
  },
  isapiGetIsapiatualizacoes: {
    url: "isapi/getisapiatualizacoes",
    method: "POST",
    resource: "ISAPI/GETISAPIATUALIZACOES",
    type: "READ",
  },
  isapiGetIsapicartoes: {
    url: "isapi/getisapicartoes",
    method: "POST",
    resource: "ISAPI/GETISAPICARTOES",
    type: "READ",
  },
  isapiGetIsapidiagnostico: {
    url: "isapi/getisapidiagnostico",
    method: "POST",
    resource: "ISAPI/GETISAPIDIAGNOSTICO",
    type: "READ",
  },
  isapiGetIsapiequipamentos: {
    url: "isapi/getisapiequipamentos",
    method: "GET",
    resource: "ISAPI/GETISAPIEQUIPAMENTOS",
    type: "READ",
  },
  isapiGetIsapierrossync: {
    url: "isapi/getisapierrossync",
    method: "POST",
    resource: "ISAPI/GETISAPIERROSSYNC",
    type: "READ",
  },
  isapiGetIsapiexcecoes: {
    url: "isapi/getisapiexcecoes",
    method: "POST",
    resource: "ISAPI/GETISAPIEXCECOES",
    type: "READ",
  },
  isapiGetIsapipessoas: {
    url: "isapi/getisapipessoas",
    method: "POST",
    resource: "ISAPI/GETISAPIPESSOAS",
    type: "READ",
  },
  isapiGetallFirmwarespermitidos: {
    url: "isapi/getallfirmwarespermitidos",
    method: "GET",
    resource: "ISAPI/GETALLFIRMWARESPERMITIDOS",
    type: "READ",
  },
  isapiGetallProvedoresip: {
    url: "isapi/getallprovedoresip",
    method: "GET",
    resource: "ISAPI/GETALLPROVEDORESIP",
    type: "READ",
  },
  isapiGetallSuitescomunicacao: {
    url: "isapi/getallsuitescomunicacao",
    method: "GET",
    resource: "ISAPI/GETALLSUITESCOMUNICACAO",
    type: "READ",
  },
  isapiInsertFirmwarepermitido: {
    url: "isapi/insertfirmwarepermitido",
    method: "POST",
    resource: "ISAPI/INSERTFIRMWAREPERMITIDO",
    type: "WRITE",
  },
  isapiInsertIsapiexcecoes: {
    url: "isapi/insertisapiexcecoes",
    method: "POST",
    resource: "ISAPI/INSERTISAPIEXCECOES",
    type: "WRITE",
  },
  isapiReaplicaisapierro: {
    url: "isapi/reaplicaisapierro",
    method: "POST",
    resource: "ISAPI/REAPLICAISAPIERRO",
    type: "WRITE",
  },
  isapiRevogaisapiexcecoes: {
    url: "isapi/revogaisapiexcecoes",
    method: "POST",
    resource: "ISAPI/REVOGAISAPIEXCECOES",
    type: "WRITE",
  },
  isapiUpdateFirmwarepermitido: {
    url: "isapi/updatefirmwarepermitido",
    method: "PUT",
    resource: "ISAPI/UPDATEFIRMWAREPERMITIDO",
    type: "WRITE",
  },
  marcarnotasvisualizadas: {
    url: "marcarnotasvisualizadas",
    method: "POST",
    resource: "MARCARNOTASVISUALIZADAS",
    type: "WRITE",
  },
  mercedesGetConsumoporperiodo: {
    url: "mercedes/getconsumoporperiodo",
    method: "GET",
    resource: "MERCEDES/GETCONSUMOPORPERIODO",
    type: "READ",
    params: ["dti","dtf"],
  },
  monitriipDeleteViagem: {
    url: "monitriip/deleteviagem",
    method: "GET",
    resource: "MONITRIIP/DELETEVIAGEM",
    type: "DELETE",
  },
  monitriipGetLogserrosviagem: {
    url: "monitriip/getlogserrosviagem",
    method: "GET",
    resource: "MONITRIIP/GETLOGSERROSVIAGEM",
    type: "READ",
    params: ["autorizacao"],
  },
  monitriipGetLogsviagem: {
    url: "monitriip/getlogsviagem",
    method: "GET",
    resource: "MONITRIIP/GETLOGSVIAGEM",
    type: "READ",
    params: ["autorizacao"],
  },
  monitriipGetMovimentosviagem: {
    url: "monitriip/getmovimentosviagem",
    method: "GET",
    resource: "MONITRIIP/GETMOVIMENTOSVIAGEM",
    type: "READ",
    params: ["autorizacao"],
  },
  monitriipGetVelocidadetempolocalizacao: {
    url: "monitriip/getvelocidadetempolocalizacao",
    method: "GET",
    resource: "MONITRIIP/GETVELOCIDADETEMPOLOCALIZACAO",
    type: "READ",
    params: ["placa"],
  },
  monitriipGetallViagensdata: {
    url: "monitriip/getallviagensdata",
    method: "POST",
    resource: "MONITRIIP/GETALLVIAGENSDATA",
    type: "READ",
  },
  monitriipInsertMovimento: {
    url: "monitriip/insertmovimento",
    method: "POST",
    resource: "MONITRIIP/INSERTMOVIMENTO",
    type: "WRITE",
  },
  monitriipRegistrarViagem: {
    url: "monitriip/registrarviagem",
    method: "POST",
    resource: "MONITRIIP/REGISTRARVIAGEM",
    type: "WRITE",
  },
  monitriipUpdateViagem: {
    url: "monitriip/updateviagem",
    method: "PUT",
    resource: "MONITRIIP/UPDATEVIAGEM",
    type: "WRITE",
  },
  moovit: {
    url: "moovit",
    method: "GET",
    resource: "MOOVIT",
    type: "READ",
  },
  paradasroteirizacaoFromcsv: {
    url: "paradasroteirizacao/fromcsv",
    method: "POST",
    resource: "PARADASROTEIRIZACAOFROMCSV",
    type: "WRITE",
  },
  parsecsvprecandidatosticket: {
    url: "parsecsvprecandidatosticket",
    method: "POST",
    resource: "PARSECSVPRECANDIDATOSTICKET",
    type: "WRITE",
  },
  parsekml: {
    url: "parsekml",
    method: "POST",
    resource: "PARSEKML",
    type: "WRITE",
  },
  parsekml_json: {
    url: "parsekml-json",
    method: "POST",
    resource: "PARSEKMLJSON",
    type: "WRITE",
  },
  peoplechatEnviaqrcode: {
    url: "peoplechat/enviaqrcode",
    method: "POST",
    resource: "PEOPLECHAT_ENVIAQRCODE",
    type: "WRITE",
  },
  pessoasAtualizaniveisacessohikvision: {
    url: "pessoas/atualizaniveisacessohikvision",
    method: "POST",
    resource: "PESSOAS/ATUALIZANIVEISACESSOHIKVISION",
    type: "WRITE",
  },
  pessoasGetBycodintegracaofaceid: {
    url: "pessoas/getbycodintegracaofaceid",
    method: "POST",
    resource: "PESSOAS/GETBYCODINTEGRACAOFACEID",
    type: "READ",
  },
  pessoasGetallBycodintegracaofaceid: {
    url: "pessoas/getallbycodintegracaofaceid",
    method: "POST",
    resource: "PESSOAS/GETALLBYCODINTEGRACAOFACEID",
    type: "READ",
  },
  pessoasUpdateStatushikvision: {
    url: "pessoas/updatestatushikvision",
    method: "POST",
    resource: "PESSOAS/UPDATESTATUSHIKVISION",
    type: "WRITE",
  },
  postenderecodevalidacao: {
    url: "postenderecodevalidacao",
    method: "POST",
    resource: "POSTENDERECODEVALIDACAO",
    type: "WRITE",
  },
  postenderecoexterno: {
    url: "postenderecoexterno",
    method: "POST",
    resource: "POSTENDERECOEXTERNO",
    type: "WRITE",
  },
  postenderecosvalidacoes: {
    url: "postenderecosvalidacoes",
    method: "POST",
    resource: "POSTENDERECOSVALIDACOES",
    type: "WRITE",
  },
  postguiamotoristacheck: {
    url: "postguiamotoristacheck",
    method: "POST",
    resource: "POSTGUIAMOTORISTACHECK",
    type: "WRITE",
  },
  postguiamotoristainsertguiacadastro: {
    url: "postguiamotoristainsertguiacadastro",
    method: "POST",
    resource: "POSTGUIAMOTORISTAINSERTGUIACADASTRO",
    type: "WRITE",
  },
  postjornadamotorista: {
    url: "postjornadamotorista",
    method: "POST",
    resource: "POSTJORNADAMOTORISTA",
    type: "WRITE",
  },
  postvalidacaoenderecosexterno: {
    url: "postvalidacaoenderecosexterno",
    method: "POST",
    resource: "POSTVALIDACAOENDERECOSEXTERNO",
    type: "WRITE",
  },
  postvalidacaoprecandidatos: {
    url: "postvalidacaoprecandidatos",
    method: "POST",
    resource: "POSTVALIDACAOPRECANDIDATOS",
    type: "WRITE",
  },
  processaCsvcandidatos: {
    url: "processacsvcandidatos",
    method: "GET",
    resource: "PROCESSACSVCANDIDATOS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvcercas: {
    url: "processacsvcercas",
    method: "POST",
    resource: "PROCESSACSVCERCAS",
    type: "WRITE",
    params: ["file","idusuario"],
  },
  processaCsvcercaslinha: {
    url: "processacsvcercaslinha",
    method: "POST",
    resource: "PROCESSACSVCERCASLINHA",
    type: "WRITE",
    params: ["file","idusuario"],
  },
  processaCsvcittati: {
    url: "processacsvcittati",
    method: "GET",
    resource: "PROCESSACSVCITTATI",
    type: "READ",
    params: ["file","dti","dtf"],
  },
  processaCsvdeletepessoas: {
    url: "processacsvdeletepessoas",
    method: "GET",
    resource: "PROCESSACSVDELETEPESSOAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvempresas: {
    url: "processacsvempresas",
    method: "GET",
    resource: "PROCESSACSVEMPRESAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvequipamentos: {
    url: "processacsvequipamentos",
    method: "GET",
    resource: "PROCESSACSVEQUIPAMENTOS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvescalas: {
    url: "processacsvescalas",
    method: "GET",
    resource: "PROCESSACSVESCALAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvfuncionarios: {
    url: "processacsvfuncionarios",
    method: "GET",
    resource: "PROCESSASVFUNCIONARIOS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvgrupos: {
    url: "processacsvgrupos",
    method: "GET",
    resource: "PROCESSACSVGRUPOS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvguias: {
    url: "processacsvguias",
    method: "GET",
    resource: "PROCESSACSVGUIAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvguiasmimo: {
    url: "processacsvguiasmimo",
    method: "GET",
    resource: "PROCESSACSVGUIASGLOBUS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvpessoas: {
    url: "processacsvpessoas",
    method: "GET",
    resource: "PROCESSACSVPESSOAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvquadros: {
    url: "processacsvquadros",
    method: "GET",
    resource: "PROCESSACSVQUADROS",
    type: "READ",
    params: ["file"],
  },
  processaCsvrotas: {
    url: "processacsvrotas",
    method: "GET",
    resource: "PROCESSACSVROTAS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvrotaslinha: {
    url: "processacsvrotaslinha",
    method: "GET",
    resource: "PROCESSACSVROTASLINHA",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvroteirizacao: {
    url: "processacsvroteirizacao",
    method: "GET",
    resource: "PROCESSACSVROTEIRIZACAO",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvroteirizacaoUpload: {
    url: "processacsvroteirizacao/upload",
    method: "POST",
    resource: "PROCESSACSVROTEIRIZACAO/UPLOAD",
    type: "WRITE",
  },
  processaCsvtags: {
    url: "processacsvtags",
    method: "GET",
    resource: "PROCESSACSVTAGS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvturnosfuncionarios: {
    url: "processacsvturnosfuncionarios",
    method: "GET",
    resource: "PROCESSACSVTURNOSFUNCIONARIOS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvturnospassageiros: {
    url: "processacsvturnospassageiros",
    method: "GET",
    resource: "PROCESSACSVTURNOSPASSAGEIROS",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvunidades: {
    url: "processacsvunidades",
    method: "GET",
    resource: "PROCESSACSVUNIDADES",
    type: "READ",
    params: ["file","idusuario"],
  },
  processaCsvusuarios: {
    url: "processacsvusuarios",
    method: "GET",
    resource: "PROCESSACSVUSUARIOS",
    type: "READ",
    params: ["file"],
  },
  processaCsvveiculos: {
    url: "processacsvveiculos",
    method: "GET",
    resource: "PROCESSACSVVEICULOS",
    type: "READ",
    params: ["file"],
  },
  processaKml: {
    url: "processakml",
    method: "POST",
    resource: "PROCESSAKML",
    type: "WRITE",
  },
  putenderecodevalidacao: {
    url: "putenderecodevalidacao",
    method: "PUT",
    resource: "PUTENDERECODEVALIDACAO",
    type: "WRITE",
    params: ["id"],
  },
  putenderecoexterno: {
    url: "putenderecoexterno",
    method: "PUT",
    resource: "PUTENDERECOEXTERNO",
    type: "WRITE",
    params: ["id"],
  },
  putenderecosvalidacoes: {
    url: "putenderecosvalidacoes",
    method: "PUT",
    resource: "PUTENDERECOSVALIDACOES",
    type: "WRITE",
    params: ["id"],
  },
  queclinkGetDadoscan: {
    url: "queclink/getdadoscan",
    method: "POST",
    resource: "QUECLINK/GETDADOSCAN",
    type: "READ",
  },
  queclinkGetUltimaposicaoimei: {
    url: "queclink/getultimaposicaoimei",
    method: "POST",
    resource: "QUECLINK/GETULTIMAPOSICAOIMEI",
    type: "READ",
  },
  reagendarbyidagendamento: {
    url: "reagendarbyidagendamento",
    method: "POST",
    resource: "REAGENDARBYIDAGENDAMENTO",
    type: "WRITE",
  },
  recuperasenha: {
    url: "recuperasenha",
    method: "POST",
    resource: "RECUPERASENHA",
    type: "WRITE",
  },
  registrarChamadasapiexternas: {
    url: "registrarchamadasapiexternas",
    method: "POST",
    resource: "REGISTRARCHAMADASAPIEXTERNAS",
    type: "WRITE",
  },
  removetickettequipamento: {
    url: "removetickettequipamento",
    method: "POST",
    resource: "REMOVETICKETEQUIPAMENTO",
    type: "WRITE",
  },
  reprocessaembarques: {
    url: "reprocessaembarques",
    method: "POST",
    resource: "REPROCESSAEMBARQUES",
    type: "WRITE",
  },
  resetrecuperacao: {
    url: "resetrecuperacao",
    method: "POST",
    resource: "RESETRECUPERACAO",
    type: "WRITE",
  },
  resetrotina: {
    url: "resetrotina",
    method: "PUT",
    resource: "RESETROTINA",
    type: "WRITE",
  },
  resolveHistoricoroteirizacaosessaocrud: {
    url: "resolvehistoricoroteirizacaosessaocrud",
    method: "POST",
    resource: "RESOLVEHISTORICOROTEIRIZACAOSESSAOCRUD",
    type: "WRITE",
  },
  resolvePendenciassff: {
    url: "resolvependenciassff",
    method: "POST",
    resource: "RESOLVEPENDENCIASSFF",
    type: "WRITE",
  },
  revalidarviagemgrid: {
    url: "revalidarviagemgrid",
    method: "PUT",
    resource: "REVALIDARVIAGEMGRID",
    type: "WRITE",
  },
  roteirizacaoCancelapipeline: {
    url: "roteirizacao/cancelapipeline",
    method: "POST",
    resource: "ROTEIRIZACAOCANCELAPIPELINE",
    type: "WRITE",
  },
  roteirizacaoClusterparadas: {
    url: "roteirizacao/clusterparadas",
    method: "POST",
    resource: "ROTEIRIZACAOCLUSTERPARADAS",
    type: "WRITE",
  },
  roteirizacaoGetPipelinebyid: {
    url: "roteirizacao/getpipelinebyid",
    method: "POST",
    resource: "ROTEIRIZACAOGETPIPELINEBYID",
    type: "READ",
  },
  roteirizacaoGetPipelinesbyids: {
    url: "roteirizacao/getpipelinesbyids",
    method: "POST",
    resource: "ROTEIRIZACAOGETPIPELINESBYIDS",
    type: "READ",
  },
  roteirizacaoIniciapipeline: {
    url: "roteirizacao/iniciapipeline",
    method: "POST",
    resource: "ROTEIRIZACAOINICIAPIPELINE",
    type: "WRITE",
  },
  roteirizacaoPreviewareastops: {
    url: "roteirizacao/previewareastops",
    method: "POST",
    resource: "ROTEIRIZACAOPREVIEWAREASTOPS",
    type: "WRITE",
  },
  roteirizacaoSequenciamotoristas: {
    url: "roteirizacao/sequenciamotoristas",
    method: "POST",
    resource: "ROTEIRIZACAO/SEQUENCIAMOTORISTAS",
    type: "WRITE",
  },
  roteirizacaoSummarizeautofleet: {
    url: "roteirizacao/summarizeautofleet",
    method: "POST",
    resource: "ROTEIRIZACAOSUMMARIZEAUTOFLEET",
    type: "WRITE",
  },
  roteirizacaoValidaPreviewpolygon: {
    url: "roteirizacao/validapreviewpolygon",
    method: "POST",
    resource: "ROTEIRIZACAOVALIDAPREVIEWPOLYGON",
    type: "WRITE",
  },
  schedulerCancelaprocesso: {
    url: "scheduler/cancelaprocesso",
    method: "POST",
    resource: "SCHEDULER/CANCELAPROCESSO",
    type: "WRITE",
  },
  schedulerGetProcessoschedulerbydate: {
    url: "scheduler/getprocessoschedulerbydate",
    method: "POST",
    resource: "SCHEDULER/GETPROCESSOSCHEDULERBYDATE",
    type: "READ",
  },
  schedulerGetProcessoschedulerbyid: {
    url: "scheduler/getprocessoschedulerbyid",
    method: "POST",
    resource: "GETPROCESSOSCHEDULERBYID",
    type: "READ",
    params: ["id"],
  },
  schedulerGetSolicitacoesrelatorios: {
    url: "scheduler/getsolicitacoesrelatorios",
    method: "POST",
    resource: "SCHEDULER/GETSOLICITACOESRELATORIOS",
    type: "READ",
  },
  schedulerQprocesso: {
    url: "scheduler/qprocesso",
    method: "POST",
    resource: "SCHEDULER/QPROCESSO",
    type: "WRITE",
  },
  sendTemplatetometa: {
    url: "sendtemplatetometa",
    method: "POST",
    resource: "SENDTEMPLATETOMETA",
    type: "WRITE",
  },
  smsstatus: {
    url: "smsstatus",
    method: "POST",
    resource: "SMSSTATUS",
    type: "WRITE",
  },
  solicitacomparacaoetas: {
    url: "solicitacomparacaoetas",
    method: "POST",
    resource: "SOLICITACOMPARACAOETAS",
    type: "WRITE",
  },
  ssffAuthenticate: {
    url: "ssff/authenticate",
    method: "GET",
    resource: "SSFF/AUTHENTICATE",
    type: "READ",
  },
  ssffGetEmployeebydocument: {
    url: "ssff/getemployeebydocument",
    method: "POST",
    resource: "SSFF/GETEMPLOYEEBYDOCUMENT",
    type: "READ",
  },
  ssffGetEmployeebyemail: {
    url: "ssff/getemployeebyemail",
    method: "POST",
    resource: "SSFF/GETEMPLOYEEBYEMAIL",
    type: "READ",
  },
  ssffGetEmployeebyregistration: {
    url: "ssff/getemployeebyregistration",
    method: "GET",
    resource: "SSFF/GETEMPLOYEEBYREGISTRATION",
    type: "READ",
    params: ["reg"],
  },
  ssffGetEmployeesbylastupdate: {
    url: "ssff/getemployeesbylastupdate",
    method: "GET",
    resource: "SSFF/GETEMPLOYEESBYLASTUPDATE",
    type: "READ",
    params: ["lastupdate","page"],
  },
  ssffGetEmployeesbysite: {
    url: "ssff/getemployeesbysite",
    method: "GET",
    resource: "SSFF/GETEMPLOYEESBYSITE",
    type: "READ",
    params: ["site","page"],
  },
  ssffGetSitelocation: {
    url: "ssff/getsitelocation",
    method: "GET",
    resource: "SSFF/GETSITELOCATION",
    type: "READ",
    params: ["location"],
  },
  ssffGetSiteslocations: {
    url: "ssff/getsiteslocations",
    method: "POST",
    resource: "SSFF/GETSITESLOCATIONS",
    type: "READ",
    params: ["page"],
  },
  ssffGetallEmployees: {
    url: "ssff/getallemployees",
    method: "GET",
    resource: "SSFF/GETALLEMPLOYEES",
    type: "READ",
    params: ["page"],
  },
  ssffGetallShifts: {
    url: "ssff/getallshifts",
    method: "GET",
    resource: "SSFF/GETALLSHIFTS",
    type: "READ",
    params: ["page"],
  },
  ssffGetallSitelocations: {
    url: "ssff/getallsitelocations",
    method: "GET",
    resource: "SSFF/GETALLSITELOCATIONS",
    type: "READ",
    params: ["page"],
  },
  ssffGetallSites: {
    url: "ssff/getallsites",
    method: "GET",
    resource: "SSFF/GETALLSITES",
    type: "READ",
    params: ["page"],
  },
  ssffUpdateEmployees: {
    url: "ssff/updateemployees",
    method: "GET",
    resource: "SSFF/UPDATEEMPLOYEES",
    type: "READ",
  },
  subsidioAplicarreajustecontrato: {
    url: "subsidio/aplicarreajustecontrato",
    method: "POST",
    resource: "SUBSIDIO/APLICARREAJUSTECONTRATO",
    type: "WRITE",
  },
  subsidioCancelarenviotemplatecontrato: {
    url: "subsidio/cancelarenviotemplatecontrato",
    method: "PUT",
    resource: "SUBSIDIO/CANCELARENVIOTEMPLATECONTRATO",
    type: "WRITE",
  },
  subsidioDeleteAllunidadescontrato: {
    url: "subsidio/deleteallunidadescontrato",
    method: "POST",
    resource: "SUBSIDIO/DELETEALLUNIDADESCONTRATO",
    type: "DELETE",
  },
  subsidioDeleteContratosubsidio: {
    url: "subsidio/deletecontratosubsidio",
    method: "PUT",
    resource: "SUBSIDIO/DELETECONTRATOSUBSIDIO",
    type: "DELETE",
  },
  subsidioDeleteContratotemplate: {
    url: "subsidio/deletecontratotemplate",
    method: "PUT",
    resource: "DELETECONTRATOTEMPLATE",
    type: "DELETE",
  },
  subsidioDeleteIndicadorreajuste: {
    url: "subsidio/deleteindicadorreajuste",
    method: "PUT",
    resource: "SUBSIDIO/DELETEINDICADORREAJUSTE",
    type: "DELETE",
  },
  subsidioFinalizarenviotemplatecontrato: {
    url: "subsidio/finalizarenviotemplatecontrato",
    method: "POST",
    resource: "SUBSIDIO/FINALIZARENVIOTEMPLATECONTRATO",
    type: "WRITE",
  },
  subsidioFriburgoGetAnaliticofrota: {
    url: "subsidio/friburgo/getanaliticofrota",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETANALITICOFROTA",
    type: "READ",
  },
  subsidioFriburgoGetRelatoriomensal: {
    url: "subsidio/friburgo/getrelatoriomensal",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETRELATORIOMENSAL",
    type: "READ",
  },
  subsidioFriburgoGetRelatorioveiculosdata: {
    url: "subsidio/friburgo/getrelatorioveiculosdata",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETRELATORIOVEICULOSDATA",
    type: "READ",
  },
  subsidioFriburgoGetRelatorioviagensdata: {
    url: "subsidio/friburgo/getrelatorioviagensdata",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETRELATORIOVIAGENSDATA",
    type: "READ",
  },
  subsidioFriburgoGetSubsidiotarifafrota: {
    url: "subsidio/friburgo/getsubsidiotarifafrota",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETSUBSIDIOTARIFAFROTA",
    type: "READ",
  },
  subsidioFriburgoGetSubsidiotarifakm: {
    url: "subsidio/friburgo/getsubsidiotarifakm",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETSUBSIDIOTARIFAKM",
    type: "READ",
  },
  subsidioFriburgoGetSubsidiototal: {
    url: "subsidio/friburgo/getsubsidiototal",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/GETSUBSIDIOTOTAL",
    type: "READ",
  },
  subsidioFriburgoPrestacaocontas: {
    url: "subsidio/friburgo/prestacaocontas",
    method: "POST",
    resource: "SUBSIDIO/FRIBURGO/PRESTACAOCONTAS",
    type: "WRITE",
  },
  subsidioGetContratosconsolidados: {
    url: "subsidio/getcontratosconsolidados",
    method: "GET",
    resource: "GETCONTRATOSCONSOLIDADOS",
    type: "READ",
    params: ["id"],
  },
  subsidioGetContratotemplate: {
    url: "subsidio/getcontratotemplate",
    method: "GET",
    resource: "GETCONTRATOTEMPLATE",
    type: "READ",
    params: ["id"],
  },
  subsidioGetEnviorecebidotemplatecontrato: {
    url: "subsidio/getenviorecebidotemplatecontrato",
    method: "GET",
    resource: "SUBSIDIO/GETENVIORECEBIDOTEMPLATECONTRATO",
    type: "READ",
    params: ["id"],
  },
  subsidioGetEnviostemplatecontrato: {
    url: "subsidio/getenviostemplatecontrato",
    method: "GET",
    resource: "SUBSIDIO/GETENVIOSTEMPLATECONTRATO",
    type: "READ",
    params: ["id"],
  },
  subsidioGetEnviotemplatecontratorevisao: {
    url: "subsidio/getenviotemplatecontratorevisao",
    method: "GET",
    resource: "SUBSIDIO/GETENVIOTEMPLATECONTRATOREVISAO",
    type: "READ",
    params: ["id"],
  },
  subsidioGetPlanilhaenviotemplatecontrato: {
    url: "subsidio/getplanilhaenviotemplatecontrato",
    method: "GET",
    resource: "SUBSIDIO/GETPLANILHAENVIOTEMPLATECONTRATO",
    type: "READ",
    params: ["id"],
  },
  subsidioGetFechamentodiafinanceiroativo: {
    url: "subsidio/getfechamentodiafinanceiroativo",
    method: "POST",
    resource: "SUBSIDIO/GETFECHAMENTODIAFINANCEIROATIVO",
    type: "READ",
  },
  subsidioGetFechamentomesativo: {
    url: "subsidio/getfechamentomesativo",
    method: "POST",
    resource: "SUBSIDIO/GETFECHAMENTOMESATIVO",
    type: "READ",
  },
  subsidioGetIndicadorreajuste: {
    url: "subsidio/getindicadorreajuste",
    method: "GET",
    resource: "SUBSIDIO/GETINDICADORREAJUSTE",
    type: "READ",
    params: ["id"],
  },
  subsidioGetLinhasassociadascontrato: {
    url: "subsidio/getlinhasassociadascontrato",
    method: "GET",
    resource: "SUBSIDIO/GETLINHASASSOCIADASCONTRATO",
    type: "READ",
    params: ["id"],
  },
  subsidioGetRecebidostemplatecontrato: {
    url: "subsidio/getrecebidostemplatecontrato",
    method: "GET",
    resource: "SUBSIDIO/GETRECEBIDOSTEMPLATECONTRATO",
    type: "READ",
    query: ["page","pageSize"],
  },
  subsidioGetRelatoriomensal: {
    url: "subsidio/getrelatoriomensal",
    method: "POST",
    resource: "SUBSIDIO/GETRELATORIOMENSAL",
    type: "READ",
  },
  subsidioGetRelatorioveiculosdata: {
    url: "subsidio/getrelatorioveiculosdata",
    method: "POST",
    resource: "SUBSIDIO/GETRELATORIOVEICULOSDATA",
    type: "READ",
  },
  subsidioGetRelatorioveiculosdatacontrato: {
    url: "subsidio/getrelatorioveiculosdatacontrato",
    method: "POST",
    resource: "SUBSIDIO_GETRELATORIOVEICULOSDATACONTRATO",
    type: "READ",
  },
  subsidioGetRelatorioviagensdata: {
    url: "subsidio/getrelatorioviagensdata",
    method: "POST",
    resource: "SUBSIDIO/GETRELATORIOVIAGENSDATA",
    type: "READ",
  },
  subsidioGetRelatorioviagensdatacontrato: {
    url: "subsidio/getrelatorioviagensdatacontrato",
    method: "POST",
    resource: "SUBSIDIO_GETRELATORIOVIAGENSDATACONTRATO",
    type: "READ",
  },
  subsidioGetRespostastemplatecontrato: {
    url: "subsidio/getrespostastemplatecontrato",
    method: "GET",
    resource: "SUBSIDIO/GETRESPOSTASTEMPLATECONTRATO",
    type: "READ",
  },
  subsidioGetSubsidiototal: {
    url: "subsidio/getsubsidiototal",
    method: "POST",
    resource: "SUBSIDIO/GETSUBSIDIOTOTAL",
    type: "READ",
  },
  subsidioGetUnidadesassociadascontrato: {
    url: "subsidio/getunidadesassociadascontrato",
    method: "GET",
    resource: "SUBSIDIO/GETUNIDADESASSOCIADASCONTRATO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioGetValorescontratotipoveiculo: {
    url: "subsidio/getvalorescontratotipoveiculo",
    method: "GET",
    resource: "GETVALORESCONTRATOTIPOVEICULO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioGetallContratossubsidio: {
    url: "subsidio/getallcontratossubsidio",
    method: "GET",
    resource: "SUBSIDIO/GETALLCONTRATOSSUBSIDIO",
    type: "READ",
  },
  subsidioGetallContratossubsidiosfromempresaetiposveiculos: {
    url: "subsidio/getallcontratossubsidiosfromempresaetiposveiculos",
    method: "GET",
    resource: "SUBSIDIOGETALLCONTRATOSSUBSIDIOSFROMEMPRESAETIPOSVEICULOS",
    type: "READ",
    query: ["id_empresa","id_cliente","id_unidade","ids_tipo_veiculo"],
  },
  subsidioGetallContratotemplates: {
    url: "subsidio/getallcontratotemplates",
    method: "GET",
    resource: "GETALLCONTRATOTEMPLATES",
    type: "READ",
  },
  subsidioGetallFechamentosmes: {
    url: "subsidio/getallfechamentosmes",
    method: "POST",
    resource: "SUBSIDIO/GETALLFECHAMENTOSMES",
    type: "READ",
  },
  subsidioGetallIndicadoresreajuste: {
    url: "subsidio/getallindicadoresreajuste",
    method: "POST",
    resource: "SUBSIDIO/GETALLINDICADORESREAJUSTE",
    type: "READ",
  },
  subsidioGetallTiposveiculosfromcontratossubsidio: {
    url: "subsidio/getalltiposveiculosfromcontratossubsidio",
    method: "GET",
    resource: "SUBSIDIOGETALLTIPOSVEICULOSFROMCONTRATOSSUBSIDIO",
    type: "READ",
    query: ["id_empresa","id_cliente","id_unidade"],
  },
  subsidioInsertContratosubsidio: {
    url: "subsidio/insertcontratosubsidio",
    method: "POST",
    resource: "SUBSIDIO/INSERTCONTRATOSUBSIDIO",
    type: "WRITE",
  },
  subsidioInsertContratotemplate: {
    url: "subsidio/insertcontratotemplate",
    method: "POST",
    resource: "INSERTCONTRATOTEMPLATE",
    type: "WRITE",
  },
  subsidioImportarplanilhaenviotemplatecontrato: {
    url: "subsidio/importarplanilhaenviotemplatecontrato",
    method: "POST",
    resource: "SUBSIDIO/IMPORTARPLANILHAENVIOTEMPLATECONTRATO",
    type: "WRITE",
  },
  subsidioInsertEnviotemplatecontrato: {
    url: "subsidio/insertenviotemplatecontrato",
    method: "POST",
    resource: "SUBSIDIO/INSERTENVIOTEMPLATECONTRATO",
    type: "WRITE",
  },
  subsidioInsertFechamentodiafinanceiro: {
    url: "subsidio/insertfechamentodiafinanceiro",
    method: "POST",
    resource: "SUBSIDIO/INSERTFECHAMENTODIAFINANCEIRO",
    type: "WRITE",
  },
  subsidioInsertFechamentomes: {
    url: "subsidio/insertfechamentomes",
    method: "POST",
    resource: "SUBSIDIO/INSERTFECHAMENTOMES",
    type: "WRITE",
  },
  subsidioInsertIndicadorreajuste: {
    url: "subsidio/insertindicadorreajuste",
    method: "POST",
    resource: "SUBSIDIO/INSERTINDICADORREAJUSTE",
    type: "WRITE",
  },
  subsidioInsertLinhascontratosubsidio: {
    url: "subsidio/insertlinhascontratosubsidio",
    method: "POST",
    resource: "SUBSIDIO/INSERTLINHASCONTRATOSUBSIDIO",
    type: "WRITE",
  },
  subsidioInsertUnidadescontratossubsidio: {
    url: "subsidio/insertunidadescontratossubsidio",
    method: "POST",
    resource: "SUBSIDIO/INSERTUNIDADESCONTRATOSSUBSIDIO",
    type: "WRITE",
  },
  subsidioMeliDeleteAllunidadescontrato: {
    url: "subsidio/meli/deleteallunidadescontrato",
    method: "POST",
    resource: "SUBSIDIO/MELI/DELETEALLUNIDADESCONTRATO",
    type: "DELETE",
  },
  subsidioMeliGetUnidadesassociadascontrato: {
    url: "subsidio/meli/getunidadesassociadascontrato",
    method: "GET",
    resource: "GETUNIDADESASSOCIADASCONTRATO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioMeliInsertUnidadescontratossubsidio: {
    url: "subsidio/meli/insertunidadescontratossubsidio",
    method: "POST",
    resource: "SUBSIDIO/MELI/INSERTUNIDADESCONTRATOSSUBSIDIO",
    type: "WRITE",
  },
  subsidioMelibrasilGetPontualidadeporlinha: {
    url: "subsidio/melibrasil/getpontualidadeporlinha",
    method: "POST",
    resource: "SUBSIDIOMELIBRASILPONTUALIDADE",
    type: "READ",
  },
  subsidioMelibrasilScorecard: {
    url: "subsidio/melibrasil/scorecard",
    method: "POST",
    resource: "SUBSIDIOMELIBRASILSCORECARD",
    type: "WRITE",
    params: ["id","idOcorrencia","idPilar"],
    query: ["ano_mes","id_contrato"],
  },
  subsidioMexicoGetRelatoriomensal: {
    url: "subsidio/mexico/getrelatoriomensal",
    method: "POST",
    resource: "SUBSIDIO/MEXICO/GETRELATORIOMENSAL",
    type: "READ",
  },
  subsidioMexicoGetRelatorioveiculosdata: {
    url: "subsidio/mexico/getrelatorioveiculosdata",
    method: "POST",
    resource: "SUBSIDIO/MEXICO/GETRELATORIOVEICULOSDATA",
    type: "READ",
  },
  subsidioMexicoGetRelatorioviagensdata: {
    url: "subsidio/mexico/getrelatorioviagensdata",
    method: "POST",
    resource: "SUBSIDIO/MEXICO/GETRELATORIOVIAGENSDATA",
    type: "READ",
  },
  subsidioMexicoGetSubsidiototal: {
    url: "subsidio/mexico/getsubsidiototal",
    method: "POST",
    resource: "SUBSIDIO/MEXICO/GETSUBSIDIOTOTAL",
    type: "READ",
  },
  subsidioMotorAgrupamentos: {
    url: "subsidio/motor/agrupamentos",
    method: "GET",
    resource: "GETSUBSIDIOMOTORAGRUPAMENTOS",
    type: "READ",
  },
  subsidioMotorCalculos: {
    url: "subsidio/motor/calculos",
    method: "GET",
    resource: "GETSUBSIDIOMOTORCALCULOS",
    type: "READ",
  },
  subsidioMotorDeleteAgrupamento: {
    url: "subsidio/motor/deleteagrupamento",
    method: "POST",
    resource: "DELETESUBSIDIOMOTORAGRUPAMENTO",
    type: "DELETE",
  },
  subsidioMotorDeleteCalculo: {
    url: "subsidio/motor/deletecalculo",
    method: "POST",
    resource: "DELETESUBSIDIOMOTORCALCULO",
    type: "DELETE",
  },
  subsidioMotorDeleteGrandeza: {
    url: "subsidio/motor/deletegrandeza",
    method: "POST",
    resource: "DELETESUBSIDIOMOTORGRANDEZA",
    type: "DELETE",
  },
  subsidioMotorDeleteVariavel: {
    url: "subsidio/motor/deletevariavel",
    method: "POST",
    resource: "DELETESUBSIDIOMOTORVARIAVEL",
    type: "DELETE",
  },
  subsidioMotorGetCalculosassociadoscontrato: {
    url: "subsidio/motor/getcalculosassociadoscontrato",
    method: "GET",
    resource: "GETSUBSIDIOMOTORCALCULOSCONTRATO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioMotorGetLinhasviagenscontrato: {
    url: "subsidio/motor/getlinhasviagenscontrato",
    method: "POST",
    resource: "GETSUBSIDIOMOTORLINHASVIAGENSCONTRATO",
    type: "READ",
  },
  subsidioMotorGetMaterializacoes: {
    url: "subsidio/motor/getmaterializacoes",
    method: "POST",
    resource: "GETSUBSIDIOMOTORMATERIALIZACOES",
    type: "READ",
  },
  subsidioMotorGetViagenscontrato: {
    url: "subsidio/motor/getviagenscontrato",
    method: "POST",
    resource: "GETSUBSIDIOMOTORVIAGENSCONTRATO",
    type: "READ",
  },
  subsidioMotorGrandezas: {
    url: "subsidio/motor/grandezas",
    method: "GET",
    resource: "GETSUBSIDIOMOTORGRANDEZAS",
    type: "READ",
  },
  subsidioMotorInsertAgrupamento: {
    url: "subsidio/motor/insertagrupamento",
    method: "POST",
    resource: "INSERTSUBSIDIOMOTORAGRUPAMENTO",
    type: "WRITE",
  },
  subsidioMotorInsertCalculo: {
    url: "subsidio/motor/insertcalculo",
    method: "POST",
    resource: "INSERTSUBSIDIOMOTORCALCULO",
    type: "WRITE",
  },
  subsidioMotorInsertGrandeza: {
    url: "subsidio/motor/insertgrandeza",
    method: "POST",
    resource: "INSERTSUBSIDIOMOTORGRANDEZA",
    type: "WRITE",
  },
  subsidioMotorInsertVariavel: {
    url: "subsidio/motor/insertvariavel",
    method: "POST",
    resource: "INSERTSUBSIDIOMOTORVARIAVEL",
    type: "WRITE",
  },
  subsidioMotorMaterializegrandezas: {
    url: "subsidio/motor/materializegrandezas",
    method: "POST",
    resource: "MATERIALIZESUBSIDIOMOTORGRANDEZAS",
    type: "WRITE",
  },
  subsidioMotorSetcalculoscontrato: {
    url: "subsidio/motor/setcalculoscontrato",
    method: "POST",
    resource: "SETSUBSIDIOMOTORCALCULOSCONTRATO",
    type: "WRITE",
  },
  subsidioMotorUpdateAgrupamento: {
    url: "subsidio/motor/updateagrupamento",
    method: "POST",
    resource: "UPDATESUBSIDIOMOTORAGRUPAMENTO",
    type: "WRITE",
  },
  subsidioMotorUpdateCalculo: {
    url: "subsidio/motor/updatecalculo",
    method: "POST",
    resource: "UPDATESUBSIDIOMOTORCALCULO",
    type: "WRITE",
  },
  subsidioMotorUpdateGrandeza: {
    url: "subsidio/motor/updategrandeza",
    method: "POST",
    resource: "UPDATESUBSIDIOMOTORGRANDEZA",
    type: "WRITE",
  },
  subsidioMotorUpdateVariavel: {
    url: "subsidio/motor/updatevariavel",
    method: "POST",
    resource: "UPDATESUBSIDIOMOTORVARIAVEL",
    type: "WRITE",
  },
  subsidioMotorValidaRcalculoscontrato: {
    url: "subsidio/motor/validarcalculoscontrato",
    method: "POST",
    resource: "VALIDARSUBSIDIOMOTORCALCULOSCONTRATO",
    type: "WRITE",
  },
  subsidioMotorVariaveis: {
    url: "subsidio/motor/variaveis",
    method: "GET",
    resource: "GETSUBSIDIOMOTORVARIAVEIS",
    type: "READ",
  },
  subsidioReabrirfechamentodiafinanceiro: {
    url: "subsidio/reabrirfechamentodiafinanceiro",
    method: "PUT",
    resource: "SUBSIDIO/REABRIRFECHAMENTODIAFINANCEIRO",
    type: "WRITE",
  },
  subsidioReabrirfechamentomes: {
    url: "subsidio/reabrirfechamentomes",
    method: "PUT",
    resource: "SUBSIDIO/REABRIRFECHAMENTOMES",
    type: "WRITE",
  },
  subsidioRioGetLinhasassociadascontrato: {
    url: "subsidio/rio/getlinhasassociadascontrato",
    method: "GET",
    resource: "SUBSIDIO/RIO/GETLINHASASSOCIADASCONTRATO",
    type: "READ",
    params: ["id"],
  },
  subsidioRioGetLinhassemcontrato: {
    url: "subsidio/rio/getlinhassemcontrato",
    method: "GET",
    resource: "SUBSIDIO/RIO/GETLINHASSEMCONTRATO",
    type: "READ",
  },
  subsidioRioGetSubsidioviagensdata: {
    url: "subsidio/rio/getsubsidioviagensdata",
    method: "POST",
    resource: "SUBSIDIO/RIO/GETSUBSIDIOVIAGENSDATA",
    type: "READ",
  },
  subsidioRioGetSubsidioviagensdataprefeitura: {
    url: "subsidio/rio/getsubsidioviagensdataprefeitura",
    method: "POST",
    resource: "SUBSIDIO/RIO/GETSUBSIDIOVIAGENSDATAPREFEITURA",
    type: "READ",
  },
  subsidioRioInsertLinhascontratosubsidio: {
    url: "subsidio/rio/insertlinhascontratosubsidio",
    method: "POST",
    resource: "SUBSIDIO/RIO/INSERTLINHASCONTRATOSUBSIDIO",
    type: "WRITE",
  },
  subsidioSalvarvaloresenviotemplatecontrato: {
    url: "subsidio/salvarvaloresenviotemplatecontrato",
    method: "POST",
    resource: "SUBSIDIO/SALVARVALORESENVIOTEMPLATECONTRATO",
    type: "WRITE",
  },
  subsidioSetcontratosconsolidados: {
    url: "subsidio/setcontratosconsolidados",
    method: "PUT",
    resource: "SETCONTRATOSCONSOLIDADOS",
    type: "WRITE",
  },
  subsidioSetvalorescontratotipoveiculo: {
    url: "subsidio/setvalorescontratotipoveiculo",
    method: "POST",
    resource: "SETVALORESCONTRATOTIPOVEICULO",
    type: "WRITE",
  },
  subsidioUpdateContratosubsidio: {
    url: "subsidio/updatecontratosubsidio",
    method: "POST",
    resource: "SUBSIDIO/UPDATECONTRATOSUBSIDIO",
    type: "WRITE",
  },
  subsidioUpdateContratotemplate: {
    url: "subsidio/updatecontratotemplate",
    method: "POST",
    resource: "UPDATECONTRATOTEMPLATE",
    type: "WRITE",
  },
  subsidioUpdateIndicadorreajuste: {
    url: "subsidio/updateindicadorreajuste",
    method: "POST",
    resource: "SUBSIDIO/UPDATEINDICADORREAJUSTE",
    type: "WRITE",
  },
  syncMensagenswithtemplate: {
    url: "syncmensagenswithtemplate",
    method: "POST",
    resource: "SYNCMENSAGENSWITHTEMPLATES",
    type: "WRITE",
  },
  tema: {
    url: "tema",
    method: "POST",
    resource: "TEMA",
    type: "WRITE",
  },
  temaActivaTe: {
    url: "tema/activate",
    method: "POST",
    resource: "TEMA/ACTIVATE",
    type: "WRITE",
  },
  temaAll: {
    url: "tema/all",
    method: "GET",
    resource: "TEMA/ALL",
    type: "READ",
  },
  temaDelete: {
    url: "tema/delete",
    method: "POST",
    resource: "TEMA/DELETE",
    type: "DELETE",
  },
  temaDeleteLogo: {
    url: "tema/delete/logo",
    method: "POST",
    resource: "TEMA/DELETE/LOGO",
    type: "DELETE",
  },
  temaLogo: {
    url: "tema/logo",
    method: "POST",
    resource: "TEMA/LOGO",
    type: "WRITE",
  },
  temaLogoAll: {
    url: "tema/logo/all",
    method: "GET",
    resource: "TEMA/LOGO/ALL",
    type: "READ",
  },
  temaUpdate: {
    url: "tema/update",
    method: "POST",
    resource: "TEMA/UPDATE",
    type: "WRITE",
  },
  transoftChangestatusviagem: {
    url: "transoft/changestatusviagem",
    method: "POST",
    resource: "TRANSOFT/CHANGESTATUSVIAGEM",
    type: "WRITE",
  },
  transoftDeleteByid: {
    url: "transoft/deletebyid",
    method: "POST",
    resource: "TRANSOFT/DELETEBYID",
    type: "DELETE",
  },
  transoftGetByid: {
    url: "transoft/getbyid",
    method: "POST",
    resource: "TRANSOFT/GETBYID",
    type: "READ",
  },
  transoftGetByperiod: {
    url: "transoft/getbyperiod",
    method: "POST",
    resource: "TRANSOFT/GETBYPERIOD",
    type: "READ",
  },
  transoftGetGridallviagenspordata: {
    url: "transoft/getgridallviagenspordata",
    method: "POST",
    resource: "TRANSOFT/GETGRIDALLVIAGENSPORDATA",
    type: "READ",
  },
  transoftInsertBulk: {
    url: "transoft/insertbulk",
    method: "POST",
    resource: "TRANSOFT/INSERTBULK",
    type: "WRITE",
  },
  transoftInsertGridbulk: {
    url: "transoft/insertgridbulk",
    method: "GET",
    resource: "TRANSOFT/INSERTGRIDBULK",
    type: "READ",
  },
  transoftInsertSingle: {
    url: "transoft/insertsingle",
    method: "POST",
    resource: "TRANSOFT/INSERT",
    type: "WRITE",
  },
  transoftProcessaCsvviagensprevistas: {
    url: "transoft/processacsvviagensprevistas",
    method: "GET",
    resource: "TRANSOFT/PROCESSACSVVIAGENSPREVISTAS",
    type: "READ",
    params: ["file"],
  },
  updateAcessoqrcode: {
    url: "updateacessoqrcode",
    method: "POST",
    resource: "UPDATEACESSOQRCODE",
    type: "WRITE",
  },
  updateAgenciaemprego: {
    url: "updateagenciaemprego",
    method: "PUT",
    resource: "UPDATEAGENCIAEMPREGO",
    type: "WRITE",
  },
  updateArea: {
    url: "updatearea",
    method: "PUT",
    resource: "UPDATEAREA",
    type: "WRITE",
  },
  updateAutorizacaoprefeitura: {
    url: "updateautorizacaoprefeitura",
    method: "PUT",
    resource: "UPDATEAUTORIZACAOPREFEITURA",
    type: "WRITE",
  },
  updateAvisobanner: {
    url: "updateavisobanner",
    method: "PUT",
    resource: "UPDATEAVISOBANNER",
    type: "WRITE",
  },
  updateCategoria: {
    url: "updatecategoria",
    method: "POST",
    resource: "UPDATECATEGORIA",
    type: "WRITE",
  },
  updateCerca: {
    url: "updatecerca",
    method: "PUT",
    resource: "UPDATECERCA",
    type: "WRITE",
  },
  updateCercavigencia: {
    url: "updatecercavigencia",
    method: "PUT",
    resource: "UPDATECERCAVIGENCIA",
    type: "WRITE",
    params: ["id"],
  },
  updateChamadashereapi: {
    url: "updatechamadashereapi",
    method: "POST",
    resource: "UPDATECHAMADASHEREAPI",
    type: "WRITE",
  },
  updateChecklistequipamento: {
    url: "updatechecklistequipamento",
    method: "PUT",
    resource: "UPDATECHECKLISTEQUIPAMENTO",
    type: "WRITE",
    params: ["id"],
  },
  updateChecklistequipamentoresposta: {
    url: "updatechecklistequipamentoresposta",
    method: "POST",
    resource: "UPDATECHECKLISTEQUIPAMENTORESPOSTA",
    type: "WRITE",
  },
  updateClassificacao: {
    url: "updateclassificacao",
    method: "POST",
    resource: "UPDATECLASSIFICACAO",
    type: "WRITE",
  },
  updateCliente: {
    url: "updatecliente",
    method: "PUT",
    resource: "UPDATECLIENTE",
    type: "WRITE",
  },
  updateConcessoesperfil: {
    url: "updateconcessoesperfil",
    method: "POST",
    resource: "UPDATECONCESSOESPERFIL",
    type: "WRITE",
  },
  updateConcessoesusuario: {
    url: "updateconcessoesusuario",
    method: "POST",
    resource: "UPDATECONCESSOESUSUARIO",
    type: "WRITE",
  },
  updateConciliacaocanceladamerus: {
    url: "updateconciliacaocanceladamerus",
    method: "POST",
    resource: "UPDATECONCILIACAOCANCELADAMERUS",
    type: "WRITE",
  },
  updateConfig: {
    url: "updateconfig",
    method: "PUT",
    resource: "UPDATECONFIG",
    type: "WRITE",
  },
  updateDashboard: {
    url: "updatedashboard",
    method: "POST",
    resource: "UPDATEDASHBOARD",
    type: "WRITE",
  },
  updateDocumentopessoa: {
    url: "updatedocumentopessoa",
    method: "POST",
    resource: "UPDATEDOCUMENTOPESSOA",
    type: "WRITE",
  },
  updateDocumentoveiculo: {
    url: "updatedocumentoveiculo",
    method: "POST",
    resource: "UPDATEDOCUMENTOVEICULO",
    type: "WRITE",
  },
  updateEmpresa: {
    url: "updateempresa",
    method: "PUT",
    resource: "UPDATEEMPRESA",
    type: "WRITE",
  },
  updateEndereconotificacao: {
    url: "updateendereconotificacao",
    method: "PUT",
    resource: "UPDATEENDERECONOTIFICACAO",
    type: "WRITE",
  },
  updateEndpointstela: {
    url: "updateendpointstela",
    method: "POST",
    resource: "UPDATEENDPOINTSTELA",
    type: "WRITE",
  },
  updateEntrada: {
    url: "updateentrada",
    method: "POST",
    resource: "UPDATEENTRADA",
    type: "WRITE",
  },
  updateEnviomensagem: {
    url: "updateenviomensagem",
    method: "POST",
    resource: "UPDATEENVIOMENSAGEM",
    type: "WRITE",
  },
  updateEquipamento: {
    url: "updateequipamento",
    method: "PUT",
    resource: "UPDATEEQUIPAMENTO",
    type: "WRITE",
  },
  updateEquipe: {
    url: "updateequipe",
    method: "PUT",
    resource: "UPDATEEQUIPE",
    type: "WRITE",
  },
  updateEscala: {
    url: "updateescala",
    method: "POST",
    resource: "UPDATEESCALA",
    type: "WRITE",
  },
  updateFamiliaatendimento: {
    url: "updatefamiliaatendimento",
    method: "PUT",
    resource: "UPDATEFAMILIAATENDIMENTO",
    type: "WRITE",
  },
  updateFeriado: {
    url: "updateferiado",
    method: "PUT",
    resource: "UPDATEFERIADO",
    type: "WRITE",
  },
  updateFuncionario: {
    url: "updatefuncionario",
    method: "PUT",
    resource: "UPDATEFUNCIONARIO",
    type: "WRITE",
  },
  updateGrupo: {
    url: "updategrupo",
    method: "PUT",
    resource: "UPDATEGRUPO",
    type: "WRITE",
  },
  updateGuia: {
    url: "updateguia",
    method: "PUT",
    resource: "UPDATEGUIA",
    type: "WRITE",
  },
  updateHeader: {
    url: "updateheader",
    method: "POST",
    resource: "UPDATEHEADER",
    type: "WRITE",
  },
  updateHeadersbulk: {
    url: "updateheadersbulk",
    method: "POST",
    resource: "UPDATEHEADERSBULK",
    type: "WRITE",
  },
  updateKit: {
    url: "updatekit",
    method: "PUT",
    resource: "UPDATEKIT",
    type: "WRITE",
  },
  updateLabelreferente: {
    url: "updatelabelreferente",
    method: "PUT",
    resource: "UPDATELABELREFERENTE",
    type: "WRITE",
  },
  updateLimitesapiexternas: {
    url: "updatelimitesapiexternas",
    method: "PUT",
    resource: "UPDATELIMITESAPIEXTERNAS",
    type: "WRITE",
  },
  updateLinha: {
    url: "updatelinha",
    method: "PUT",
    resource: "UPDATELINHA",
    type: "WRITE",
  },
  updateLocal: {
    url: "updatelocal",
    method: "PUT",
    resource: "UPDATELOCAL",
    type: "WRITE",
    params: ["id"],
  },
  updateLocationunidade: {
    url: "updatelocationunidade",
    method: "PUT",
    resource: "UPDATELOCATIONUNIDADE",
    type: "WRITE",
  },
  updateMensagem: {
    url: "updatemensagem",
    method: "POST",
    resource: "UPDATEMENSAGEM",
    type: "WRITE",
  },
  updateMetatemplates: {
    url: "updatemetatemplates",
    method: "POST",
    resource: "UPDATEMETATEMPLATES",
    type: "WRITE",
  },
  updateMotivo: {
    url: "updatemotivo",
    method: "PUT",
    resource: "UPDATEMOTIVO",
    type: "WRITE",
  },
  updateNotafiscal: {
    url: "updatenotafiscal",
    method: "PUT",
    resource: "UPDATENOTAFISCAL",
    type: "WRITE",
  },
  updateNotificacao: {
    url: "updatenotificacao",
    method: "PUT",
    resource: "UPDATENOTIFICACAO",
    type: "WRITE",
  },
  updateNotificacaoporperiodo: {
    url: "updatenotificacaoporperiodo",
    method: "PUT",
    resource: "UPDATENOTIFICACAOPORPERIODO",
    type: "WRITE",
  },
  updatePerfil: {
    url: "updateperfil",
    method: "PUT",
    resource: "UPDATEPERFIL",
    type: "WRITE",
  },
  updatePermissao: {
    url: "updatepermissao",
    method: "PUT",
    resource: "UPDATEPERMISSAO",
    type: "WRITE",
  },
  updatePermissionario: {
    url: "updatepermissionario",
    method: "PUT",
    resource: "UPDATEPERMISSIONARIO",
    type: "WRITE",
  },
  updatePermissoespadrao: {
    url: "updatepermissoespadrao",
    method: "POST",
    resource: "UPDATEPERMISSOESPADRAO",
    type: "WRITE",
  },
  updatePessoa: {
    url: "updatepessoa",
    method: "POST",
    resource: "UPDATEPESSOA",
    type: "WRITE",
  },
  updatePessoasenderecoslatlngbulk: {
    url: "updatepessoasenderecoslatlngbulk",
    method: "POST",
    resource: "UPDATEPESSOASENDERECOSLATLNGBULK",
    type: "WRITE",
  },
  updatePrecandidato: {
    url: "updateprecandidato",
    method: "POST",
    resource: "UPDATEPRECANDIDATO",
    type: "WRITE",
  },
  updatePrefguiavalidadorviagem: {
    url: "updateprefguiavalidadorviagem",
    method: "POST",
    resource: "UPDATEPREFGUIAVALIDADORVIAGEM",
    type: "WRITE",
  },
  updateProdutointerno: {
    url: "updateprodutointerno",
    method: "PUT",
    resource: "UPDATEPRODUTOINTERNO",
    type: "WRITE",
  },
  updateQuadro: {
    url: "updatequadro",
    method: "PUT",
    resource: "UPDATEQUADRO",
    type: "WRITE",
  },
  updateRelmanutencaotiposequipamentos: {
    url: "updaterelmanutencaotiposequipamentos",
    method: "PUT",
    resource: "UPDATERELMANUTENCAOTIPOSEQUIPAMENTOS",
    type: "WRITE",
  },
  updateReservacandidato: {
    url: "updatereservacandidato",
    method: "POST",
    resource: "UPDATERESERVACANDIDATO",
    type: "WRITE",
  },
  updateRoleta: {
    url: "updateroleta",
    method: "POST",
    resource: "UPDATEROLETA",
    type: "WRITE",
  },
  updateRota: {
    url: "updaterota",
    method: "PUT",
    resource: "UPDATEROTA",
    type: "WRITE",
  },
  updateRotavigencia: {
    url: "updaterotavigencia",
    method: "PUT",
    resource: "UPDATEROTAVIGENCIA",
    type: "WRITE",
    params: ["id"],
  },
  updateRotinaligada: {
    url: "updaterotinaligada",
    method: "PUT",
    resource: "UPDATEROTINALIGADA",
    type: "WRITE",
  },
  updateRotinaparams: {
    url: "updaterotinaparams",
    method: "PUT",
    resource: "UPDATEROTINAPARAMS",
    type: "WRITE",
  },
  updateServico: {
    url: "updateservico",
    method: "PUT",
    resource: "UPDATESERVICO",
    type: "WRITE",
  },
  updateSimcard: {
    url: "updatesimcard",
    method: "PUT",
    resource: "UPDATESIMCARD",
    type: "WRITE",
  },
  updateSituacao: {
    url: "updatesituacao",
    method: "POST",
    resource: "UPDATESITUACAO",
    type: "WRITE",
  },
  updateSituacaopessoa: {
    url: "updatesituacaopessoa",
    method: "POST",
    resource: "UPDATESITUACAOPESSOA",
    type: "WRITE",
  },
  updateSituacaovalidacaopessoa: {
    url: "updatesituacaovalidacaopessoa",
    method: "POST",
    resource: "UPDATESITUACAOVALIDACAOPESSOA",
    type: "WRITE",
  },
  updateStatusticket: {
    url: "updatestatusticket",
    method: "POST",
    resource: "UPDATETICKETSTATUS",
    type: "WRITE",
  },
  updateStatusveiculosoperacao: {
    url: "updatestatusveiculosoperacao",
    method: "PUT",
    resource: "UPDATESTATUSVEICULOSOPERACAO",
    type: "WRITE",
  },
  updateTagrfid: {
    url: "updatetagrfid",
    method: "POST",
    resource: "UPDATETAGRFID",
    type: "WRITE",
  },
  updateTarifa: {
    url: "updatetarifa",
    method: "GET",
    resource: "UPDATETARIFA",
    type: "READ",
  },
  updateTema: {
    url: "updatetema",
    method: "GET",
    resource: "UPDATETEMA",
    type: "READ",
  },
  updateTemplatemensagem: {
    url: "updatetemplatemensagem",
    method: "POST",
    resource: "UPDATETEMPLATEMENSAGEM",
    type: "WRITE",
  },
  updateTicket: {
    url: "updateticket",
    method: "POST",
    resource: "UPDATETICKET",
    type: "WRITE",
  },
  updateTicketCamposCriacao: {
    url: "updateTicketCamposCriacao",
    method: "PUT",
    resource: "UPDATECAMPOSCRIACAO",
    type: "WRITE",
  },
  updateTicketCamposDetalhe: {
    url: "updateTicketCamposDetalhe",
    method: "PUT",
    resource: "UPDATECAMPOSDETALHE",
    type: "WRITE",
  },
  updateTickettaskstatus: {
    url: "updatetickettaskstatus",
    method: "POST",
    resource: "UPDATETICKETTASKSTATUS",
    type: "WRITE",
  },
  updateTipoatendimento: {
    url: "updatetipoatendimento",
    method: "PUT",
    resource: "UPDATETIPOATENDIMENTO",
    type: "WRITE",
  },
  updateTipoentrada: {
    url: "updatetipoentrada",
    method: "PUT",
    resource: "UPDATETIPOENTRADA",
    type: "WRITE",
  },
  updateTipoequipamento: {
    url: "updatetipoequipamento",
    method: "POST",
    resource: "UPDATETIPOEQUIPAMENTO",
    type: "WRITE",
  },
  updateTipokit: {
    url: "updatetipokit",
    method: "PUT",
    resource: "UPDATETIPOKIT",
    type: "WRITE",
  },
  updateTiposnotificacoes: {
    url: "updatetiposnotificacoes",
    method: "POST",
    resource: "UPDATETIPOSNOTIFICACOES",
    type: "WRITE",
  },
  updateTipotarifa: {
    url: "updatetipotarifa",
    method: "POST",
    resource: "UPDATETIPOTARIFA",
    type: "WRITE",
  },
  updateTipoveiculo: {
    url: "updatetipoveiculo",
    method: "POST",
    resource: "UPDATETIPOVEICULO",
    type: "WRITE",
  },
  updateTrecho: {
    url: "updatetrecho",
    method: "POST",
    resource: "UPDATETRECHO",
    type: "WRITE",
  },
  updateTrecholimite: {
    url: "updatetrecholimite",
    method: "POST",
    resource: "UPDATETRECHOLIMITE",
    type: "WRITE",
  },
  updateTurno: {
    url: "updateturno",
    method: "POST",
    resource: "UPDATETURNO",
    type: "WRITE",
  },
  updateTurnofuncionario: {
    url: "updateturnofuncionario",
    method: "POST",
    resource: "UPDATETURNOFUNCIONARIO",
    type: "WRITE",
  },
  updateTurnopassageiro: {
    url: "updateturnopassageiro",
    method: "POST",
    resource: "UPDATETURNOPASSAGEIRO",
    type: "WRITE",
  },
  updateUnidade: {
    url: "updateunidade",
    method: "PUT",
    resource: "UPDATEUNIDADE",
    type: "WRITE",
  },
  updateUsuario: {
    url: "updateusuario",
    method: "PUT",
    resource: "UPDATEUSUARIO",
    type: "WRITE",
  },
  updateVeiculo: {
    url: "updateveiculo",
    method: "PUT",
    resource: "UPDATEVEICULO",
    type: "WRITE",
  },
  updateViagemcontrolador: {
    url: "updateviagemcontrolador",
    method: "POST",
    resource: "UPDATEVIAGEMCONTROLADOR",
    type: "WRITE",
  },
  updateViagemescala: {
    url: "updateviagemescala",
    method: "POST",
    resource: "UPDATEVIAGEMESCALA",
    type: "WRITE",
  },
  updateViagemgrid: {
    url: "updateviagemgrid",
    method: "PUT",
    resource: "UPDATEVIAGEMGRID",
    type: "WRITE",
  },
  updateViagemoperadora: {
    url: "updateviagemoperadora",
    method: "POST",
    resource: "UPDATEVIAGEMOPERADORA",
    type: "WRITE",
  },
  updateViagemquadro: {
    url: "updateviagemquadro",
    method: "PUT",
    resource: "UPDATEVIAGEMQUADRO",
    type: "WRITE",
  },
  updateViagemrealizada: {
    url: "updateviagemrealizada",
    method: "PUT",
    resource: "UPDATEVIAGEMREALIZADA",
    type: "WRITE",
  },
  updateVigenciadatas: {
    url: "updatevigenciadatas",
    method: "PUT",
    resource: "UPDATEVIGENCIADATAS",
    type: "WRITE",
    params: ["id"],
  },
  updateVigenciahodometroveiculo: {
    url: "updatevigenciahodometroveiculo",
    method: "PUT",
    resource: "UPDATEVIGENCIAHODOMETROVEICULO",
    type: "WRITE",
  },
  uploadChecklistmedia: {
    url: "uploadchecklistmedia",
    method: "POST",
    resource: "UPLOADCHECKLISTMEDIA",
    type: "WRITE",
  },
  uploadCsv: {
    url: "uploadcsv",
    method: "POST",
    resource: "UPLOADCSV",
    type: "WRITE",
  },
  uploadCsvfromgooglesheets: {
    url: "uploadcsvfromgooglesheets",
    method: "POST",
    resource: "UPLOADCSVFROMGOOGLESHEETS",
    type: "WRITE",
  },
  uploadImg: {
    url: "uploadimg",
    method: "POST",
    resource: "UPLOADIMG",
    type: "WRITE",
  },
  uploadImgbulk: {
    url: "uploadimgbulk",
    method: "POST",
    resource: "UPLOADIMGBULK",
    type: "WRITE",
  },
  uploadViagensoperadora: {
    url: "uploadviagensoperadora",
    method: "GET",
    resource: "UPLOADVIAGENSOPERADORA",
    type: "READ",
    params: ["file","idusuario","idempresa"],
  },
  upsertEmpresasbulk: {
    url: "upsertempresasbulk",
    method: "POST",
    resource: "UPSERTEMPRESASBULK",
    type: "WRITE",
  },
  upsertEnderecoexterno: {
    url: "upsertenderecoexterno",
    method: "POST",
    resource: "UPSERTENDERECOEXTERNO",
    type: "WRITE",
  },
  upsertFuncionariosbulk: {
    url: "upsertfuncionariosbulk",
    method: "POST",
    resource: "UPSERTFUNCIONARIOSBULK",
    type: "WRITE",
  },
  upsertGruposbulk: {
    url: "upsertgruposbulk",
    method: "POST",
    resource: "UPSERTGRUPOSBULK",
    type: "WRITE",
  },
  upsertLinhascompletobulk: {
    url: "upsertlinhascompletobulk",
    method: "POST",
    resource: "UPSERTLINHASCOMPLETOBULK",
    type: "WRITE",
  },
  upsertPessoasbulk: {
    url: "upsertpessoasbulk",
    method: "POST",
    resource: "UPSERTPESSOASBULK",
    type: "WRITE",
  },
  upsertPrecandidato: {
    url: "upsertprecandidato",
    method: "POST",
    resource: "UPSERTPRECANDIDATO",
    type: "WRITE",
  },
  upsertRotasbulk: {
    url: "upsertrotasbulk",
    method: "POST",
    resource: "UPSERTROTASBULK",
    type: "WRITE",
  },
  upsertTurnosfuncionariosbulk: {
    url: "upsertturnosfuncionariosbulk",
    method: "POST",
    resource: "UPSERTTURNOSFUNCIONARIOSBULK",
    type: "WRITE",
  },
  upsertTurnospassageirosbulk: {
    url: "upsertturnospassageirosbulk",
    method: "POST",
    resource: "UPSERTTURNOSPASSAGEIROSBULK",
    type: "WRITE",
  },
  upsertUnidadesbulk: {
    url: "upsertunidadesbulk",
    method: "POST",
    resource: "UPSERTUNIDADESBULK",
    type: "WRITE",
  },
  upsertUsuariosbulk: {
    url: "upsertusuariosbulk",
    method: "POST",
    resource: "UPSERTUSUARIOSBULK",
    type: "WRITE",
  },
  validaCandidatosbulk: {
    url: "validacandidatosbulk",
    method: "POST",
    resource: "VALIDACANDIDATOSBULK",
    type: "WRITE",
  },
  validaEnderecocandidato: {
    url: "validaenderecocandidato",
    method: "POST",
    resource: "VALIDAENDERECOCANDIDATO",
    type: "WRITE",
  },
  verificaconflitovigencia: {
    url: "verificaconflitovigencia",
    method: "POST",
    resource: "VERIFICACONFLITOVIGENCIA",
    type: "WRITE",
  },
  verificarecuperacaosenha: {
    url: "verificarecuperacaosenha",
    method: "POST",
    resource: "VERIFICARECUPERACAOSENHA",
    type: "WRITE",
  },
  versoPlan: {
    url: "verso/plan",
    method: "POST",
    resource: "VERSOPLAN",
    type: "WRITE",
  },
  versoSolve: {
    url: "verso/solve",
    method: "POST",
    resource: "VERSOSOLVE",
    type: "WRITE",
  },
  geraRotaotimizadalinha: {
    url: "gerarotaotimizadalinha",
    method: "POST",
    resource: "GERAROTAOTIMIZADALINHA",
    type: "WRITE",
  },
  geraRotaotimizadaunidade: {
    url: "gerarotaotimizadaunidade",
    method: "POST",
    resource: "GERAROTAOTIMIZADAUNIDADE",
    type: "WRITE",
  },
  getkpisEnderecosexternos: {
    url: "getkpisenderecosexternos",
    method: "POST",
    resource: "GETKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  getmapakpisEnderecosexternos: {
    url: "getmapakpisenderecosexternos",
    method: "POST",
    resource: "GETMAPAKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  getenderecoskpisEnderecosexternos: {
    url: "getenderecoskpisenderecosexternos",
    method: "POST",
    resource: "GETENDERECOSKPISENDERECOSEXTERNOS",
    type: "READ",
  },
  subsidioMotorGetGrandezas: {
    url: "subsidio/motor/grandezas",
    method: "GET",
    resource: "GETSUBSIDIOMOTORGRANDEZAS",
    type: "READ",
  },
  subsidioMotorGetGrandezasContrato: {
    url: "subsidio/motor/getgrandezasassociadascontrato",
    method: "GET",
    resource: "GETSUBSIDIOMOTORGRANDEZASCONTRATO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioMotorSetGrandezasContrato: {
    url: "subsidio/motor/setgrandezascontrato",
    method: "POST",
    resource: "SETSUBSIDIOMOTORGRANDEZASCONTRATO",
    type: "WRITE",
  },
  subsidioMotorMaterializeGrandezas: {
    url: "subsidio/motor/materializegrandezas",
    method: "POST",
    resource: "MATERIALIZESUBSIDIOMOTORGRANDEZAS",
    type: "WRITE",
  },
  subsidioMotorGetCalculosContrato: {
    url: "subsidio/motor/getcalculosassociadoscontrato",
    method: "GET",
    resource: "GETSUBSIDIOMOTORCALCULOSCONTRATO",
    type: "READ",
    params: ["idcontrato"],
  },
  subsidioMotorValidarCalculosContrato: {
    url: "subsidio/motor/validarcalculoscontrato",
    method: "POST",
    resource: "VALIDARSUBSIDIOMOTORCALCULOSCONTRATO",
    type: "READ",
  },
};

export default endpoints;
